import { n as __toESM, t as __commonJSMin } from "../chunks/rolldown-runtime-CO0Nlsmt.js";
import { Qt as ChevronLeftIcon, Xt as ChevronsLeftIcon, Yt as ChevronsRightIcon, Zt as ChevronRightIcon, i as VerticalEllipsisIcon, r as VerticalGripIcon } from "../chunks/icons-CPQCRIUN.js";
import { At as IconButton, D as Menu, S as QrCode, St as Flex } from "../chunks/components-9RkKXUJL.js";
import { PureComponent, forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { format, parseISO } from "date-fns";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { fr } from "date-fns/locale";
import Cropper$1 from "react-cropper";
import classnames from "classnames";
import { any, array, arrayOf, bool, func, instanceOf, node, number, object, string } from "prop-types";
import isEmpty from "lodash/isEmpty";
import isNumber from "lodash/isNumber";
import isEqual from "lodash/isEqual";
import { IoIosAttach, IoMdCheckmark } from "react-icons/io";
import { AiFillEye, AiFillMail, AiFillPicture, AiFillPrinter, AiOutlineClose, AiOutlineUnlock, AiOutlineUsergroupAdd, AiOutlineWarning } from "react-icons/ai";
import { BiEnvelope, BiImageAdd, BiSolidDuplicate, BiSolidVideos, BiTime } from "react-icons/bi";
import { BsArrowCounterclockwise, BsCheckLg, BsFillGridFill, BsHeartFill, BsPin, BsPinFill } from "react-icons/bs";
import { CgMail, CgMailOpen, CgPill } from "react-icons/cg";
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleDown, FaAngleLeft, FaAngleRight, FaAngleUp, FaBoxOpen, FaChartBar, FaChartLine, FaDesktop, FaEuroSign, FaEyeSlash, FaFile, FaFolder, FaHandHoldingMedical, FaHistory, FaList, FaLongArrowAltRight, FaMapMarkerAlt, FaMobileAlt, FaPen, FaPlus, FaRegBuilding, FaRegCalendarCheck, FaRegFileAlt, FaRegFileImage, FaRegStar, FaSearch, FaSortAlphaDown, FaSortAmountDown, FaSortNumericDownAlt, FaSpinner, FaTimes, FaTrash, FaUser } from "react-icons/fa";
import { FaHouseMedical, FaMagnifyingGlass } from "react-icons/fa6";
import { FiDownload, FiEdit, FiTruck } from "react-icons/fi";
import { GoArchive } from "react-icons/go";
import { HiLink, HiOutlineDocument, HiUsers } from "react-icons/hi";
import { HiMapPin, HiPhone, HiQrCode } from "react-icons/hi2";
import { ImTruck } from "react-icons/im";
import { IoCalendarSharp, IoChatbubblesSharp } from "react-icons/io5";
import { MdOutlineFiberNew } from "react-icons/md";
import { RiArrowGoBackLine, RiCloseFill } from "react-icons/ri";
import { SiUber } from "react-icons/si";
import { TbClockEdit, TbLetterD, TbLetterJ, TbLetterL, TbLetterM, TbLetterS, TbLetterV } from "react-icons/tb";
import { VscFilePdf, VscZoomIn, VscZoomOut } from "react-icons/vsc";
import isString from "lodash/isString";
import isArray from "lodash/isArray";
import { Application, Chart, Dataset, DatePicker, DateTimePicker, TimePicker } from "react-rainbow-components";
import isDate from "lodash/isDate";
import useDownloader from "react-use-downloader";
import Highlighter from "react-highlight-words";
import map from "lodash/map";
import size from "lodash/size";
import Select, { components } from "react-select";
import AsyncSelect from "react-select/async";
import get from "lodash/get.js";
import includes from "lodash/includes";
import isEqual$1 from "lodash/isEqual.js";
import isString$1 from "lodash/isString.js";
import isUndefined from "lodash/isUndefined.js";
import every from "lodash/every";
import uniq from "lodash/uniq";
import { Editor, EditorProvider } from "react-simple-wysiwyg";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";
import imageCompression from "browser-image-compression";
// src/legacy/ValwinFactoParagraph/ValwinFactoParagraph.jsx
const ValwinFactoParagraph$1 = ({ label, className, isBordered, isUnderline, isItalic, onClick, html }) => {
	const communProps = {
		className: classnames(`valwinFactoParagraph ${className}`, {
			"valwinFactoParagraph--bordered": isBordered,
			"valwinFactoParagraph--underline": isUnderline,
			"valwinFactoParagraph--italic": isItalic,
			"valwinFactoParagraph--clickable": onClick
		}),
		onClick
	};
	return /* @__PURE__ */ jsx(Fragment$1, { children: isEmpty(html) ? /* @__PURE__ */ jsx("div", {
		...communProps,
		children: label
	}) : /* @__PURE__ */ jsx("div", {
		...communProps,
		dangerouslySetInnerHTML: { __html: html }
	}) });
};
ValwinFactoParagraph$1.propTypes = {
	label: any,
	className: string,
	isBordered: bool,
	isUnderline: bool,
	isItalic: bool,
	onClick: func,
	html: string
};
// src/legacy/ValwinFactoActivation/ValwinFactoActivation.jsx
const ValwinFactoActivation$1 = ({ value, onClick, className, label, isSbo }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoActivation ${className}`,
		children: [/* @__PURE__ */ jsx("div", {
			onClick,
			className: classnames("valwinFactoActivation__container", {
				"valwinFactoActivation__container--sbo": isSbo,
				"valwinFactoActivation__container--true": value,
				"valwinFactoActivation__container--false": !value
			}),
			children: /* @__PURE__ */ jsx("div", { className: classnames("valwinFactoActivation__circle", {
				"valwinFactoActivation__circle--true": value,
				"valwinFactoActivation__circle--false": !value
			}) })
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label,
			className: "valwinFactoActivation__label"
		})]
	});
};
ValwinFactoActivation$1.propTypes = {
	value: bool.isRequired,
	onClick: func.isRequired,
	label: string.isRequired,
	className: string,
	isSbo: bool
};
// src/legacy/ValwinFactoAdvancement/ValwinFactoAdvancement.jsx
const ValwinFactoAdvancement$1 = ({ advancement, label, className }) => {
	const advancementNumber = isNumber(advancement) ? advancement : 0;
	const advancementFormatted = advancementNumber < 100 ? advancementNumber.toFixed(0) : 100;
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoAdvancement ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: classnames("valwinFactoAdvancement__paragraph", {
				"valwinFactoParagraph--red": advancementFormatted <= 50,
				"valwinFactoParagraph--yellow": advancementFormatted >= 50 && advancementFormatted <= 99,
				"valwinFactoParagraph--greenLight": advancementFormatted === 100,
				"valwinFactoParagraph--grey": advancementFormatted === 0
			}),
			label
		}), /* @__PURE__ */ jsx("div", {
			className: "valwinFactoAdvancement__bar",
			children: /* @__PURE__ */ jsx("div", {
				style: {
					height: "100%",
					width: `${advancementFormatted}%`,
					borderRadius: "inherit"
				},
				className: classnames("valwinFactoAdvancement__advancement", {
					"valwinFactoAdvancement__advancement--red": advancementFormatted <= 50,
					"valwinFactoAdvancement__advancement--yellow": advancementFormatted >= 50 && advancementFormatted <= 99,
					"valwinFactoAdvancement__advancement--green": advancementFormatted === 100
				})
			})
		})]
	});
};
ValwinFactoAdvancement$1.propTypes = {
	advancement: number.isRequired,
	label: string,
	className: string
};
// src/legacy/ValwinFactoAlgoliaHierarchicalMenu/ValwinFactoAlgoliaHierarchicalMenuUtils.js
const beautifyString = (item) => {
	return `${(item?.label || "").split(" ").map((word) => word.toLowerCase().replace(/^./, (char) => char.toUpperCase())).join(" ")} (${item?.count || 0})`;
};
// src/legacy/ValwinFactoAlgoliaHierarchicalMenu/ValwinFactoAlgoliaHierarchicalMenu.jsx
const ValwinFactoAlgoliaHierarchicalMenu$1 = ({ items, refine, className }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoAlgoliaHierarchicalMenu ${className}`,
		children: items.map((first, firstIndex) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: classnames("valwinFactoAlgoliaHierarchicalMenu__paragraph", { "valwinFactoParagraph--green valwinFactoParagraph--underline": first.isRefined }),
			onClick: () => refine(first.value),
			label: beautifyString(first)
		}), !isEmpty(first?.data || []) && first.data.map((second, secondIndex) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			style: {
				marginLeft: "10px",
				color: second.isRefined ? "green" : ""
			},
			className: classnames("valwinFactoAlgoliaHierarchicalMenu__paragraph valwinFactoAlgoliaHierarchicalMenu__second", { "valwinFactoParagraph--green valwinFactoParagraph--underline": second.isRefined }),
			label: beautifyString(second),
			onClick: () => refine(second.value)
		}), !isEmpty(second?.data || []) && second.data.map((third, thirdIndex) => /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: classnames("valwinFactoAlgoliaHierarchicalMenu__paragraph valwinFactoAlgoliaHierarchicalMenu__third", { "valwinFactoParagraph--green valwinFactoParagraph--underline": third.isRefined }),
			label: beautifyString(third),
			onClick: () => refine(third.value)
		}, thirdIndex))] }, secondIndex))] }, firstIndex))
	});
};
ValwinFactoAlgoliaHierarchicalMenu$1.propTypes = {
	items: arrayOf(object).isRequired,
	refine: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoLoading/ValwinFactoLoading.jsx
const ValwinFactoLoading$1 = ({ size, className }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoLoading ${className}`,
		children: /* @__PURE__ */ jsx(FaSpinner, {
			icon: "spinner",
			className: "valwinFactoLoading__spinner",
			style: { fontSize: `${size}px` }
		})
	});
};
ValwinFactoLoading$1.propTypes = {
	size: number.isRequired,
	className: string
};
// src/legacy/ValwinFactoTooltip/ValwinFactoTooltip.jsx
const ValwinFactoTooltip$1 = ({ className, tooltip, helpLabel = "Aide" }) => {
	const [showTooltip, setShowTooltip] = useState(false);
	return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoTooltip ${className}`, { "valwinFactoTooltip--selected": showTooltip }),
		onMouseOver: () => setShowTooltip(true),
		onMouseLeave: () => setShowTooltip(false),
		children: [/* @__PURE__ */ jsx("div", { children: "?" }), showTooltip && /* @__PURE__ */ jsx(ValwinFactoTooltipContent, {
			tooltip,
			helpLabel
		})]
	}) });
};
ValwinFactoTooltip$1.propTypes = {
	tooltip: object.isRequired,
	className: string
};
// src/legacy/ValwinFactoSubTitle/ValwinFactoSubTitle.jsx
const ValwinFactoSubTitle$1 = ({ label, tooltip, className, isSupport }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoSubTitle ${className}`,
		children: [
			isSupport ? /* @__PURE__ */ jsx("span", { children: "Support\xA0" }) : "",
			label,
			!isEmpty(tooltip) && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
				tooltip,
				className: "valwinFactoSubTitle__tooltip"
			})
		]
	});
};
ValwinFactoSubTitle$1.propTypes = {
	label: any.isRequired,
	tooltip: object,
	className: string,
	isSupport: bool
};
// src/legacy/ValwinFactoTooltipContent/ValwinFactoTooltipContent.jsx
const ValwinFactoTooltipContent = ({ className, tooltip, helpLabel = "Aide" }) => {
	const content = tooltip?.content || [];
	const placement = tooltip?.placement || "";
	const width = tooltip?.width || "";
	return /* @__PURE__ */ jsx("div", {
		className: classnames(`valwinFactoTooltipContent ${className}`, {
			"valwinFactoTooltipContent--topCenter": isEqual(placement, "topCenter") || isEmpty(placement),
			"valwinFactoTooltipContent--topRight": isEqual(placement, "topRight"),
			"valwinFactoTooltipContent--topLeft": isEqual(placement, "topLeft"),
			"valwinFactoTooltipContent--bottomCenter": isEqual(placement, "bottomCenter"),
			"valwinFactoTooltipContent--bottomRight": isEqual(placement, "bottomRight"),
			"valwinFactoTooltipContent--bottomLeft": isEqual(placement, "bottomLeft")
		}),
		style: { width: isEmpty(width) ? "300px" : width },
		children: content.map((element, index) => {
			switch (element?.type) {
				case "TITLE": return /* @__PURE__ */ jsx(ValwinFactoSubTitle$1, { label: /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("span", {
					className: "valwinFactoTooltipContent__help",
					children: helpLabel
				}), element?.text] }) }, index);
				case "PARAGRAPH": return /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: element?.text,
					className: `${element?.className} valwinFactoTooltipContent__paragraph`
				}, index);
				case "IMAGE": return /* @__PURE__ */ jsx("img", {
					src: element?.src,
					alt: element?.src,
					className: "valwinFactoTooltipContent__image"
				}, index);
				case "IFRAME": return /* @__PURE__ */ jsx("iframe", {
					title: element?.title,
					src: element?.src,
					frameBorder: "0",
					allowFullScreen: true,
					className: "valwinFactoTooltipContent__iframe"
				}, index);
				default: return null;
			}
		})
	});
};
ValwinFactoTooltipContent.propTypes = {
	tooltip: object.isRequired,
	className: string
};
// src/legacy/ValwinFactoIcon/ValwinFactoIcon.jsx
const ICON_COMPONENT_BY_NAME = {
	EDIT: FaPen,
	ADD: FaPlus,
	ARROW_DOWN: FaAngleDown,
	ARROW_UP: FaAngleUp,
	ARROW_LEFT: FaAngleLeft,
	ARROW_RIGHT: FaAngleRight,
	CLOSE: FaTimes,
	FILE: FaFile,
	BOX: FaBoxOpen,
	BUILDING: FaRegBuilding,
	TRUCK: FiTruck,
	LOCKER: AiOutlineUnlock,
	UBER: SiUber,
	CALENDAR: IoCalendarSharp,
	HISTORY: FaHistory,
	PILL: CgPill,
	USERS: HiUsers,
	PDF: VscFilePdf,
	ENVELOPE: BiEnvelope,
	DRAFT: HiOutlineDocument,
	ARCHIVE: GoArchive,
	TRASH: FaTrash,
	ZOOM_IN: VscZoomIn,
	ZOOM_OUT: VscZoomOut,
	STAR: FaRegStar,
	CHAT: IoChatbubblesSharp,
	CHART: FaChartBar,
	PHONE: HiPhone,
	MEETINGS: FaRegCalendarCheck,
	USER: FaUser,
	PIN: BsPin,
	PIN_FILLED: BsPinFill,
	MAIL: CgMail,
	MAIL_OPEN: CgMailOpen,
	MAIL_FILLED: AiFillMail,
	ATTACHMENT: IoIosAttach,
	TIME: BiTime,
	CHECK: BsCheckLg,
	UNCHECKED: RiCloseFill,
	HIDE: FaEyeSlash,
	SHOW: AiFillEye,
	DESKTOP: FaDesktop,
	PICTURE: AiFillPicture,
	LINK: HiLink,
	WARNING: AiOutlineWarning,
	QR_CODE: HiQrCode,
	MOBILE: FaMobileAlt,
	NEW: MdOutlineFiberNew,
	HOUSE_MEDICAL: FaHouseMedical,
	EURO: FaEuroSign,
	LIST: FaList,
	DOUBLE_LEFT: FaAngleDoubleLeft,
	DOUBLE_RIGHT: FaAngleDoubleRight,
	DOWNLOAD: FiDownload,
	PRINT: AiFillPrinter,
	LINE: FaChartLine,
	RETURN: BsArrowCounterclockwise,
	HEART: BsHeartFill,
	BACK: RiArrowGoBackLine,
	L: TbLetterL,
	M: TbLetterM,
	J: TbLetterJ,
	V: TbLetterV,
	S: TbLetterS,
	D: TbLetterD,
	TRUCK_FILLED: ImTruck,
	SORT_DOWN_ALPHABETICAL: FaSortAlphaDown,
	SORT_DOWN_NUMERIC: FaSortNumericDownAlt,
	USER_GROUP: AiOutlineUsergroupAdd,
	CLOCK_EDIT: TbClockEdit,
	EDIT_ALT: FiEdit,
	IMAGE_ADD: BiImageAdd,
	GRID_FILL: BsFillGridFill,
	HAND_MEDICAL: FaHandHoldingMedical,
	SORT_DOWN_ADVANCEMENT: FaSortAmountDown,
	MARKER: FaMapMarkerAlt,
	VIDEOS: BiSolidVideos,
	DUPLICATE: BiSolidDuplicate,
	PIN_MAP: HiMapPin,
	FILE_ALT: FaRegFileAlt,
	MAGNIFY_GLASS: FaMagnifyingGlass,
	LONG_ARROW_RIGHT: FaLongArrowAltRight
};
const ValwinFactoIcon$1 = ({ icon, onClick, disabled, loading, className, tooltip }) => {
	const [showTooltip, setShowTooltip] = useState(false);
	const IconComponent = ICON_COMPONENT_BY_NAME[icon];
	return /* @__PURE__ */ jsxs("div", {
		disabled: disabled || loading,
		className: classnames(`valwinFactoIcon ${className}`, {
			"valwinFactoIcon--clickable": onClick,
			"valwinFactoIcon--disabled": disabled,
			"valwinFactoIcon--loading": loading
		}),
		onClick: disabled ? null : onClick,
		onMouseOver: () => setShowTooltip(true),
		onMouseLeave: () => setShowTooltip(false),
		children: [/* @__PURE__ */ jsx("div", {
			className: "valwinFactoIcon__content",
			children: showTooltip && !isEmpty(tooltip) && /* @__PURE__ */ jsx(ValwinFactoTooltipContent, { tooltip })
		}), loading ? /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
			size: 15,
			className: "valwinFactoLoading--white"
		}) : IconComponent && /* @__PURE__ */ jsx(IconComponent, {})]
	});
};
ValwinFactoIcon$1.propTypes = {
	icon: string.isRequired,
	onClick: func,
	disabled: bool,
	loading: bool,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoCheckbox/ValwinFactoCheckbox.jsx
const ValwinFactoCheckbox$1 = ({ name, label, disabled, required, touched, errors, className, onChange, checked, tooltip, color, buttonIconEditOnClick, buttonIconDeleteOnClick }) => {
	const inputElement = useRef(null);
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoCheckbox ${className}`, { "valwinFactoCheckbox--disabled": disabled }),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoCheckbox__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoCheckbox__square", {
						"valwinFactoCheckbox__square--checked": checked,
						"valwinFactoCheckbox__square--disabled": disabled
					}),
					onClick: () => {
						if (!disabled) inputElement.current.click();
					},
					style: color && checked ? {
						background: color,
						borderColor: color
					} : {},
					children: checked && /* @__PURE__ */ jsx(IoMdCheckmark, { className: classnames("valwinFactoCheckbox__checked", { "valwinFactoCheckbox__checked--disabled": disabled }) })
				}),
				/* @__PURE__ */ jsx("input", {
					ref: inputElement,
					name,
					id: name,
					type: "checkbox",
					label,
					disabled,
					className: "valwinFactoCheckbox__input",
					onChange,
					checked
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoCheckbox__label",
					htmlFor: name,
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: "valwinFactoCheckbox__required",
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoCheckbox__tooltip"
				}),
				buttonIconEditOnClick && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "EDIT",
					onClick: buttonIconEditOnClick,
					className: "valwinFactoCheckbox__edit valwinFactoIcon--greenLight"
				}),
				buttonIconDeleteOnClick && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "TRASH",
					onClick: buttonIconDeleteOnClick,
					className: "valwinFactoCheckbox__delete valwinFactoIcon--greenLight"
				})
			]
		}), errors && errors[name] && touched && touched[name] && /* @__PURE__ */ jsx("div", {
			className: classnames("valwinFactoCheckbox__errors", { "valwinFactoCheckbox__errors--disabled": disabled }),
			children: errors[name]
		})]
	});
};
ValwinFactoCheckbox$1.propTypes = {
	name: string.isRequired,
	onChange: func.isRequired,
	label: string,
	disabled: bool,
	required: bool,
	touched: object,
	errors: object,
	className: string,
	tooltip: object,
	checked: bool,
	color: string,
	buttonIconEditOnClick: func,
	buttonIconDeleteOnClick: func
};
// src/legacy/ValwinFactoAlgoliaRefinementList/ValwinFactoAlgoliaRefinementList.jsx
const ValwinFactoAlgoliaRefinementList$1 = ({ className, search, items, attributeList, setAttributeList, lastSearch, setSearch, refine }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `ValwinFactoAlgoliaRefinementList ${className}`,
		children: isEmpty(search) ? attributeList.map((attribute, index) => /* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
			name: `${attribute}_${index}`,
			label: `${attribute}`,
			checked: true,
			onChange: () => {
				setAttributeList([...attributeList].filter((att) => !isEqual(attribute, att)));
				refine(attribute);
			}
		}, `${attribute}_${index}`)) : items.map((item, index) => /* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
			name: `${item.value}_${index}`,
			label: `${item.value}`,
			checked: item.isRefined,
			onChange: () => {
				if (item.isRefined) setAttributeList([...attributeList].filter((attribute) => !isEqual(attribute, item.value)));
				else setAttributeList([...attributeList, item.value]);
				lastSearch.current = "";
				setSearch("");
				refine(item.value);
			}
		}, `${item.value}_${index}`))
	});
};
ValwinFactoAlgoliaRefinementList$1.propTypes = {
	items: arrayOf(object).isRequired,
	attributeList: arrayOf(string).isRequired,
	setAttributeList: func.isRequired,
	lastSearch: any.isRequired,
	setSearch: func.isRequired,
	refine: func.isRequired,
	search: string,
	className: string
};
// src/legacy/ValwinFactoArea/ValwinFactoArea.jsx
const ValwinFactoArea$1 = ({ name, label, placeholder, disabled, required, touched, errors, className, onChange, onBlur, value, tooltip, maxLength }) => {
	const textAreaRef = useRef(null);
	const resizeTextArea = () => {
		textAreaRef.current.style.height = "auto";
		textAreaRef.current.style.height = textAreaRef.current.scrollHeight + "px";
	};
	useEffect(resizeTextArea, [value]);
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoArea ${className}`, { "valwinFactoArea--disabled": disabled }),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoArea__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoArea__label", { "valwinFactoArea__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoArea__required", { "valwinFactoArea__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoArea__tooltip"
				}),
				errors && errors[name] && touched && touched[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoArea__errors", { "valwinFactoArea__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), /* @__PURE__ */ jsx("textarea", {
			rows: 1,
			name,
			id: name,
			placeholder,
			disabled,
			className: classnames("valwinFactoArea__input", { "valwinFactoArea__input--disabled": disabled }),
			onChange,
			onBlur,
			value,
			maxLength,
			ref: textAreaRef
		})]
	});
};
ValwinFactoArea$1.propTypes = {
	label: string.isRequired,
	placeholder: string.isRequired,
	value: string.isRequired,
	onChange: func.isRequired,
	name: string.isRequired,
	onBlur: func,
	disabled: bool,
	required: bool,
	touched: object,
	errors: object,
	className: string,
	tooltip: object,
	maxlength: number
};
// src/legacy/ValwinFactoButtonIcon/ValwinFactoButtonIcon.jsx
const ValwinFactoButtonIcon$1 = ({ type, icon, onClick, disabled, loading, className, tooltip }) => {
	const [showTooltip, setShowTooltip] = useState(false);
	return /* @__PURE__ */ jsx("button", {
		disabled: disabled || loading,
		type,
		className: classnames(`valwinFactoButtonIcon ${className}`, {
			"valwinFactoButtonIcon--disabled": disabled,
			"valwinFactoButtonIcon--loading": loading
		}),
		onClick,
		onMouseOver: () => setShowTooltip(true),
		onMouseLeave: () => setShowTooltip(false),
		children: /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoButtonIcon__content",
			children: [showTooltip && !isEmpty(tooltip) && /* @__PURE__ */ jsx(ValwinFactoTooltipContent, { tooltip }), loading ? /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
				size: 15,
				className: "valwinFactoLoading--white"
			}) : /* @__PURE__ */ jsx(ValwinFactoIcon$1, { icon })]
		})
	});
};
ValwinFactoButtonIcon$1.propTypes = {
	type: string.isRequired,
	icon: string.isRequired,
	onClick: func,
	disabled: bool,
	loading: bool,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoAsset/ValwinFactoAsset.jsx
const ValwinFactoAsset$1 = ({ asset, onClickEdit, onClickDelete, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoAsset ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: asset?.title || "",
			isUnderline: true,
			className: "valwinFactoAsset__title valwinFactoParagraph--green"
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoAsset__buttons",
			children: [/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
				type: "button",
				icon: "EDIT",
				className: "valwinFactoButtonIcon--green",
				onClick: onClickEdit
			}), /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
				type: "button",
				icon: "TRASH",
				className: "valwinFactoButtonIcon--red",
				onClick: onClickDelete
			})]
		})]
	});
};
ValwinFactoAsset$1.propTypes = {
	asset: object.isRequired,
	onClickEdit: func.isRequired,
	onClickDelete: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoAttachment/ValwinFactoAttachmentConst.js
const VALWIN_FACTO_ATTACHMENT_CONST = {
	IMAGE: {
		maxSize: 5242880,
		error: "5Mo maximum pour les images"
	},
	FILE: {
		maxSize: 10485760,
		error: "10Mo maximum pour les documents"
	},
	AUDIO: {
		maxSize: 52428800,
		error: "50Mo maximum pour les audios"
	}
};
// src/legacy/ValwinFactoAttachment/ValwinFactoAttachmentHandlers.js
const postFile$1 = async (formData, urlApi) => {
	return await (await fetch(urlApi, {
		method: "POST",
		body: formData
	})).json();
};
// src/legacy/ValwinFactoAttachment/ValwinFactoAttachmentUtils.js
const getFileType = (file) => {
	if (file?.type?.includes("image")) return "IMAGE";
	if (file?.type?.includes("audio")) return "AUDIO";
	return "FILE";
};
const uploadFile$1 = async (addFile, setLoading, urlApi, file, assetPath, setError, inputRef) => {
	setLoading(true);
	setError(null);
	const fileType = getFileType(file);
	if ((file?.size || 0) > VALWIN_FACTO_ATTACHMENT_CONST[fileType].maxSize) {
		setError(VALWIN_FACTO_ATTACHMENT_CONST[fileType].error);
		inputRef.current.value = "";
		setLoading(false);
		return;
	}
	const formData = new FormData();
	formData.append("file", file);
	if (assetPath) formData.append("assetPath", assetPath);
	const response = await postFile$1(formData, urlApi);
	setLoading(false);
	addFile(response);
};
// src/legacy/ValwinFactoAttachment/ValwinFactoAttachment.jsx
const ValwinFactoAttachment$1 = ({ addFile, removeFile, urlApi, className, tooltip, required, errors, name, disabled, file, onBlur, assetPath, accept, attachmentLabel = "Pièce-jointe", addAttachmentLabel = "Ajouter une pièce-jointe", noAttachmentLabel = "Aucune pièce-jointe" }) => {
	const inputRef = useRef(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	return /* @__PURE__ */ jsxs("div", {
		onClick: () => {
			if (!file?.name) inputRef.current.click();
		},
		className: classnames(`valwinFactoAttachment ${className}`, {
			"valwinFactoAttachment--disabled": disabled,
			"valwinFactoAttachment--hoverable": isEmpty(file),
			"valwinFactoAttachment--loading": loading
		}),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoAttachment__header",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoAttachment__label", { "valwinFactoAttachment__label--disabled": disabled }),
						children: isEmpty(file) ? addAttachmentLabel : attachmentLabel
					}),
					required && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoAttachment__required", { "valwinFactoAttachment__required--disabled": disabled }),
						children: "*"
					}),
					tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
						tooltip,
						className: "valwinFactoAttachment__tooltip"
					}),
					errors && errors[name] && !error && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoAttachment__errors", { "valwinFactoAttachment__errors--disabled": disabled }),
						children: errors[name]
					}),
					error && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoAttachment__errors", { "valwinFactoAttachment__errors--disabled": disabled }),
						children: error
					})
				]
			}),
			loading ? /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
				size: 20,
				className: "valwinFactoLoading--green"
			}) : /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx("input", {
				className: "valwinFactoAttachment__input",
				ref: inputRef,
				type: "file",
				onChange: (event) => {
					uploadFile$1(addFile, setLoading, urlApi, event.target.files[0], assetPath, setError, inputRef);
				},
				disabled: disabled || loading,
				name,
				onBlur,
				accept
			}) }),
			/* @__PURE__ */ jsxs("div", {
				className: classnames("valwinFactoAttachment__file", {
					"valwinFactoAttachment__file--disabled": disabled,
					"valwinFactoAttachment__file--green": file?.name || false
				}),
				children: [file?.name || noAttachmentLabel, file?.name && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "TRASH",
					className: "valwinFactoAttachment__icon valwinFactoIcon--greenLight",
					onClick: () => {
						removeFile(file);
						inputRef.current.value = null;
					}
				})]
			})
		]
	});
};
ValwinFactoAttachment$1.propTypes = {
	addFile: func,
	removeFile: func,
	urlApi: string.isRequired,
	onBlur: func.isRequired,
	accept: string.isRequired,
	name: string,
	file: object,
	className: string,
	tooltip: object,
	errors: object,
	disabled: bool,
	required: bool,
	assetPath: string
};
// src/legacy/ValwinFactoAttachmentImage/ValwinFactoAttachmentImage.jsx
const ValwinFactoAttachmentImage$1 = ({ url, name, className, onClick }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoAttachmentImage ${className}`,
		onClick: () => onClick(url, name),
		children: /* @__PURE__ */ jsx("img", {
			src: url,
			alt: "",
			className: "valwinFactoAttachmentImage__image"
		})
	});
};
ValwinFactoAttachmentImage$1.propTypes = {
	url: string.isRequired,
	className: string,
	onClick: func.isRequired
};
// src/legacy/ValwinFactoAttachmentPdf/ValwinFactoAttachmentPdf.jsx
const ValwinFactoAttachmentPdf$1 = ({ url, className, title }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoAttachmentPdf ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
			icon: "PDF",
			className: "valwinFactoAttachmentPdf__icon valwinFactoIcon--greenLight"
		}), /* @__PURE__ */ jsx("a", {
			className: "valwinFactoAttachmentPdf__title valwinFactoParagraph--greenLight",
			href: url,
			target: "_blank",
			rel: "noopener noreferrer",
			children: title
		})]
	});
};
ValwinFactoAttachmentPdf$1.propTypes = {
	url: string.isRequired,
	title: string.isRequired,
	className: string
};
// src/legacy/ValwinFactoAttendeeDetails/ValwinFactoAttendeeDetails.jsx
const ValwinFactoAttendeeDetails$1 = ({ event, attendee, isEventPassed, buttonIconFormOnClick, buttonIconScheduleOnClick, buttonIconDeleteOnClick, className }) => {
	const meetingtype = isEmpty(attendee?.selectedMeetingType?.id) ? event?.meetingTypes?.find((type) => isEqual(type?.id, event?.meetingConfiguration?.types[0])) : event?.meetingTypes?.find((type) => isEqual(type?.id, attendee?.selectedMeetingType?.id));
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoAttendeeDetails ${className}`,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoAttendeeDetails__header",
				children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: `${attendee?.firstName || ""} ${attendee?.lastName || ""}`,
					className: "valwinFactoParagraph--green valwinFactoAttendeeDetails__name"
				}), /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoAttendeeDetails__icons",
					children: [
						buttonIconFormOnClick && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "FILE",
							onClick: () => buttonIconFormOnClick(attendee),
							className: "valwinFactoAttendeeDetails__icon"
						}),
						/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "HISTORY",
							onClick: () => buttonIconScheduleOnClick(attendee),
							className: "valwinFactoAttendeeDetails__icon"
						}),
						!isEventPassed && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "TRASH",
							onClick: () => buttonIconDeleteOnClick(attendee),
							className: "valwinFactoAttendeeDetails__icon"
						})
					]
				})]
			}),
			attendee?.phoneNumber && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `${attendee?.phoneNumber}`,
				className: "valwinFactoAttendeeDetails__text"
			}),
			attendee?.email && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `${attendee?.email}`,
				className: "valwinFactoAttendeeDetails__email valwinFactoAttendeeDetails__text"
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `${meetingtype?.label || ""}`,
				className: "valwinFactoAttendeeDetails__text valwinFactoParagraph--blue"
			})
		]
	});
};
ValwinFactoAttendeeDetails$1.propTypes = {
	event: object.isRequired,
	attendee: object.isRequired,
	isEventPassed: bool,
	buttonIconFormOnClick: func,
	buttonIconScheduleOnClick: func.isRequired,
	buttonIconDeleteOnClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoButton/ValwinFactoButton.jsx
const ValwinFactoButton$1 = ({ type, label, onClick, disabled, loading, className, tooltip }) => {
	const [showTooltip, setShowTooltip] = useState(false);
	return /* @__PURE__ */ jsx("button", {
		disabled: disabled || loading,
		type,
		className: classnames(`valwinFactoButton ${className}`, {
			"valwinFactoButton--disabled": disabled,
			"valwinFactoButton--loading": loading
		}),
		onClick,
		onMouseOver: () => setShowTooltip(true),
		onMouseLeave: () => setShowTooltip(false),
		children: loading ? /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
			size: 15,
			className: `valwinFactoLoading--${isString(className) && className.includes("Reversed") ? "green" : "white"}`
		}) : /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoButton__content",
			children: [label, showTooltip && !isEmpty(tooltip) && /* @__PURE__ */ jsx(ValwinFactoTooltipContent, { tooltip })]
		})
	});
};
ValwinFactoButton$1.propTypes = {
	type: string.isRequired,
	onClick: func,
	label: string.isRequired,
	disabled: bool,
	loading: bool,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoButtonImage/ValwinFactoButtonImage.jsx
const ValwinFactoButtonImage$1 = ({ url, label, onClick, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		onClick,
		className: `valwinFactoButtonImage ${className}`,
		children: [/* @__PURE__ */ jsx("div", {
			className: "valwinFactoButtonImage__imageContainer",
			children: /* @__PURE__ */ jsx("img", {
				src: url,
				alt: "",
				className: "valwinFactoButtonImage__image"
			})
		}), /* @__PURE__ */ jsx("div", {
			className: "valwinFactoButtonImage__labelContainer",
			children: /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label,
				className: "valwinFactoParagraph--lightBold valwinFactoButtonImage__label"
			})
		})]
	});
};
ValwinFactoButtonImage$1.propTypes = {
	url: string.isRequired,
	label: string.isRequired,
	onClick: func,
	className: string
};
// src/legacy/ValwinFactoCaroussel/ValwinFactoCaroussel.jsx
const ValwinFactoCaroussel$1 = ({ images, time, className }) => {
	const [displayedIndex, setDisplayedIndex] = useState(0);
	const displayedImage = images[displayedIndex] || {};
	const onlyOneImage = isArray(images) && isEqual(images.length, 1);
	let intervalId;
	const indexPlus = (images, displayedIndex, setDisplayedIndex) => {
		clearInterval(intervalId);
		setDisplayedIndex(displayedIndex === images.length - 1 ? 0 : displayedIndex + 1);
	};
	const indexLess = (images, displayedIndex, setDisplayedIndex) => {
		clearInterval(intervalId);
		setDisplayedIndex(displayedIndex === 0 ? images.length - 1 : displayedIndex - 1);
	};
	const setInterval = (images, displayedIndex, setDisplayedIndex) => {
		intervalId = setTimeout(() => {
			indexPlus(images, displayedIndex, setDisplayedIndex);
		}, time);
	};
	useEffect(() => {
		if (!onlyOneImage) setInterval(images, displayedIndex, setDisplayedIndex);
	}, [displayedIndex]);
	useEffect(() => {
		return () => clearInterval(intervalId);
	}, []);
	const emptyFn = () => {};
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoCaroussel ${className}`,
		children: [
			!onlyOneImage && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoCaroussel__container valwinFactoCaroussel__container--left",
				children: /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					className: "valwinFactoCaroussel__icon valwinFactoIcon--green",
					icon: "ARROW_LEFT",
					onClick: () => indexLess(images, displayedIndex, setDisplayedIndex)
				})
			}),
			/* @__PURE__ */ jsx("img", {
				src: displayedImage?.src || "",
				alt: "",
				onClick: displayedImage?.onClick || emptyFn,
				className: classnames("valwinFactoCaroussel__image", { "valwinFactoCaroussel__image--clickable": displayedImage?.onClick })
			}),
			!onlyOneImage && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoCaroussel__container valwinFactoCaroussel__container--right",
				children: /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					className: "valwinFactoCaroussel__icon valwinFactoIcon--green",
					icon: "ARROW_RIGHT",
					onClick: () => indexPlus(images, displayedIndex, setDisplayedIndex)
				})
			})
		]
	});
};
ValwinFactoCaroussel$1.propTypes = {
	images: arrayOf(object).isRequired,
	time: number.isRequired,
	className: string
};
// src/legacy/ValwinFactoChart/ValwinFactoChart.jsx
const ValwinFactoChart$1 = ({ data, labels, chartType, className }) => {
	return /* @__PURE__ */ jsx(Chart, {
		labels,
		type: chartType,
		style: {
			height: "300px",
			width: "100%"
		},
		className: `valwinFactoChart ${className}`,
		maintainAspectRatio: false,
		children: data.map((d, index) => /* @__PURE__ */ jsx(Dataset, {
			title: d.title,
			values: d.values,
			backgroundColor: d.backgroundColor,
			borderColor: d.borderColor
		}, index))
	});
};
ValwinFactoChart$1.propTypes = {
	data: arrayOf(object).isRequired,
	labels: array.isRequired,
	chartType: string.isRequired,
	className: string
};
// src/legacy/ValwinFactoCheckboxList/ValwinFactoCheckboxList.jsx
const ValwinFactoCheckboxList$1 = ({ name, checkboxList, label, required, values, onChange, maxChecked: maxCheckedProps, className, disabled, touched, errors, tooltip, buttonIconTitleLabel, buttonIconTitleOnClick, isEqualFunction }) => {
	const maxChecked = maxCheckedProps || checkboxList.length + 1;
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoCheckboxList ${className}`, { "valwinFactoCheckboxList--disabled": disabled }),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoCheckboxList__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoCheckboxList__label", { "valwinFactoCheckboxList__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoCheckboxList__required", { "valwinFactoCheckboxList__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoCheckboxList__tooltip"
				}),
				buttonIconTitleLabel && buttonIconTitleOnClick && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: buttonIconTitleLabel,
					onClick: buttonIconTitleOnClick,
					className: "valwinFactoCheckboxList__icon"
				}),
				errors && errors[name] && touched && touched[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoCheckboxList__errors", { "valwinFactoCheckboxList__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), checkboxList.map((checkbox, index) => {
			const checked = !isEmpty(values.find((value) => {
				return isEqualFunction ? isEqualFunction(value, checkbox) : isEqual(value, checkbox);
			}));
			return /* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
				className: classnames("valwinFactoCheckboxList__checkbox", { "valwinFactoCheckboxList__checkbox--disabled": disabled }),
				checked,
				buttonIconEditOnClick: checkbox.buttonIconEditOnClick,
				buttonIconDeleteOnClick: checkbox.buttonIconDeleteOnClick,
				name: checkbox.name,
				label: checkbox.label,
				tooltip: checkbox.tooltip,
				disabled: disabled || !checked && values.length >= maxChecked,
				onChange: () => {
					if (checked) onChange(values.filter((value) => !(isEqualFunction ? isEqualFunction(value, checkbox) : isEqual(value, checkbox))));
					else if (values.length < maxChecked) onChange([...values, checkbox]);
				}
			}, index);
		})]
	});
};
ValwinFactoCheckboxList$1.propTypes = {
	name: string.isRequired,
	checkboxList: array.isRequired,
	label: string.isRequired,
	onChange: func.isRequired,
	values: array.isRequired,
	className: string,
	required: bool,
	maxChecked: number,
	tooltip: object,
	touched: object,
	errors: object,
	disabled: bool,
	buttonIconTitleLabel: string,
	buttonIconTitleOnClick: func,
	isEqualFunction: func
};
// src/legacy/ValwinFactoDate/ValwinFactoDate.jsx
const ValwinFactoDate$1 = ({ name, label, placeholder, disabled, required, errors, className, onChange, onBlur, value, tooltip, minDate, maxDate, withHours, isDouble, isRange, resetable, cancelLabel = "Annuler", okLabel = "Valider", locale }) => {
	const communProps = {
		name,
		value,
		onChange: (value) => onChange(value),
		className: "valwinFactoDate__input",
		hideLabel: true,
		placeholder,
		hour24: true,
		cancelLabel,
		okLabel,
		disabled,
		formatStyle: "large",
		minDate,
		maxDate,
		onBlur,
		variant: isDouble ? "double" : "single",
		selectionType: isRange ? "range" : "single",
		locale
	};
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoDate ${className}`, { "valwinFactoDate--disabled": disabled }),
		id: `container__${name}`,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoDate__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoDate__label", { "valwinFactoDate__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoDate__required", { "valwinFactoDate__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoDate__tooltip"
				}),
				!disabled && resetable && (!isEmpty(value) || isDate(value)) && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "CLOSE",
					onClick: () => onChange(""),
					className: "valwinFactoDate__reset"
				}),
				errors && errors[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoDate__errors", { "valwinFactoDate__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), /* @__PURE__ */ jsx(Application, {
			theme: { rainbow: { palette: { brand: "#0b7678" } } },
			children: withHours ? /* @__PURE__ */ jsx(DateTimePicker, { ...communProps }) : /* @__PURE__ */ jsx(DatePicker, { ...communProps })
		})]
	});
};
ValwinFactoDate$1.propTypes = {
	label: string.isRequired,
	placeholder: string.isRequired,
	value: any,
	onChange: func.isRequired,
	name: string.isRequired,
	onBlur: func,
	disabled: bool,
	required: bool,
	errors: object,
	className: string,
	tooltip: object,
	minDate: instanceOf(Date),
	maxDate: instanceOf(Date),
	withHours: bool,
	isDouble: bool,
	isRange: bool,
	resetable: bool,
	locale: string
};
// src/legacy/ValwinFactoFieldAlt/ValwinFactoFieldAlt.jsx
const ValwinFactoFieldAlt$1 = forwardRef(({ name, type, value, min, max, step, onChange, onClick, onBlur, disabled, placeholder, readOnly, className, textAlignLeft, autoFocus = false }, ref) => {
	const inputRef = useRef(null);
	useImperativeHandle(ref, () => ({
		focus: () => inputRef.current?.focus(),
		blur: () => inputRef.current?.blur(),
		select: () => inputRef.current?.select()
	}));
	return /* @__PURE__ */ jsx("input", {
		ref: inputRef,
		name,
		id: name,
		type,
		disabled,
		onChange,
		onClick,
		onBlur,
		value,
		min,
		max,
		step,
		placeholder,
		readOnly,
		className: classnames(`valwinFactoFieldAlt ${className}`, {
			"valwinFactoFieldAlt--disabled": disabled,
			"valwinFactoFieldAlt--textAlignLeft": textAlignLeft
		}),
		autoFocus
	});
});
ValwinFactoFieldAlt$1.displayName = "ValwinFactoFieldAlt";
ValwinFactoFieldAlt$1.propTypes = {
	name: string.isRequired,
	type: string.isRequired,
	onChange: func.isRequired,
	placeholder: string,
	onClick: func,
	onBlur: func,
	step: number,
	min: number,
	max: number,
	value: any,
	disabled: bool,
	readOnly: bool,
	className: string,
	textAlignLeft: bool,
	autoFocus: bool
};
// src/legacy/ValwinFactoDateAlt/ValwinFactoDateAlt.jsx
const ValwinFactoDateAlt$1 = ({ className, onChange, value, isDouble, isRange, minDate, maxDate, disabled, type, locale = "fr" }) => {
	const calendarRef = useRef(null);
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoDateAlt ${className}`,
		children: [
			isEqual(type, "ICON") && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
				icon: "CALENDAR",
				className: classnames("valwinFactoDateAlt__icon", { "valwinFactoDateAlt__icon--disabled": disabled }),
				onClick: () => calendarRef.current.click()
			}),
			isEqual(type, "FIELD") && /* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: "valwinFactoDateAlt",
				type: "date",
				value: !isString(value) && isDate(value) ? format(value, "yyyy-MM-dd") : format(/* @__PURE__ */ new Date(), "yyyy-MM-dd"),
				placeholder: "Date",
				readOnly: true,
				onChange: () => {},
				onClick: () => calendarRef.current.click(),
				className: classnames("valwinFactoDateAlt__field", { "valwinFactoDateAlt__field--disabled": disabled })
			}),
			/* @__PURE__ */ jsx(Application, {
				theme: { rainbow: { palette: { brand: "#0b7678" } } },
				children: /* @__PURE__ */ jsx(DatePicker, {
					ref: calendarRef,
					value,
					onChange: (value) => onChange(value),
					className: "valwinFactoDateAlt__input",
					hideLabel: true,
					cancelLabel: "Annuler",
					okLabel: "Valider",
					formatStyle: "large",
					variant: isDouble ? "double" : "single",
					selectionType: isRange ? "range" : "single",
					minDate,
					maxDate,
					disabled,
					locale
				})
			})
		]
	});
};
ValwinFactoDateAlt$1.propTypes = {
	value: any.isRequired,
	onChange: func.isRequired,
	type: string.isRequired,
	className: string,
	isDouble: bool,
	isRange: bool,
	minDate: instanceOf(Date),
	maxDate: instanceOf(Date),
	locale: string
};
// src/legacy/ValwinFactoDownload/ValwinFactoDownload.jsx
const ValwinFactoDownload$1 = ({ label, className, fileUrl, fileName }) => {
	if (isString(fileUrl)) fileUrl = fileUrl.replace("s3-eu-west-1.amazonaws.com/valwin", "d20fhuz7ayclct.cloudfront.net");
	const { download, isInProgress } = useDownloader();
	return /* @__PURE__ */ jsx(ValwinFactoButton$1, {
		loading: isInProgress,
		type: "button",
		label,
		className: `valwinFactoButton--greenStrong ${className}`,
		onClick: () => download(fileUrl, fileName)
	});
};
ValwinFactoDownload$1.propTypes = {
	label: string.isRequired,
	fileUrl: string.isRequired,
	fileName: string.isRequired,
	className: string
};
// src/legacy/ValwinFactoBullet/ValwinFactoBullet.jsx
const ValwinFactoBullet = ({ className, label }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoBullet ${className}`,
		children: label
	});
};
ValwinFactoBullet.propTypes = {
	className: string,
	label: number.isRequired
};
// src/legacy/ValwinFactoDropdownItem/ValwinFactoDropdownItemUtils.js
const filterFunction = (list, search) => {
	return list.filter((element) => {
		return (element?.title || "").toLowerCase().normalize("NFD").replaceAll(/[\u0300-\u036F]/g, "").includes(search.toLowerCase().normalize("NFD").replaceAll(/[\u0300-\u036F]/g, ""));
	});
};
// src/legacy/ValwinFactoDropdownItem/ValwinFactoDropdownItem.jsx
const ValwinFactoDropdownItem$1 = ({ item, title, subItems, currentSubItem, setCurrentSubItem, setCurrentItem, search, onClickIconAdd, onClickIconEdit, onClickIconDelete, onClickSubIconEdit, onClickSubIconDelete }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [filteredSubItems, setFilteredSubItems] = useState(null);
	useEffect(() => {
		if (isEmpty(search)) setFilteredSubItems(subItems);
		else setFilteredSubItems(filterFunction(subItems, search));
	}, [search]);
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoDropdownItem",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoDropdownItem__categoryContainer",
			onClick: () => {
				setCurrentItem(item);
				setIsOpen(!isOpen);
			},
			children: [/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoDropdownItem__categoryTitleContainer",
				children: [
					isOpen ? /* @__PURE__ */ jsx(ValwinFactoIcon$1, { icon: "ARROW_DOWN" }) : /* @__PURE__ */ jsx(ValwinFactoIcon$1, { icon: "ARROW_RIGHT" }),
					/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: title,
						className: "valwinFactoDropdownItem__categoryTitle"
					}),
					/* @__PURE__ */ jsx(ValwinFactoBullet, {
						label: size(filteredSubItems),
						className: "valwinFactoBullet--grey"
					})
				]
			}), /* @__PURE__ */ jsxs("div", {
				className: "valwinFactoDropdownItem__categoryIcons",
				children: [
					onClickIconAdd && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "ADD",
						onClick: () => {
							onClickIconAdd(item);
						},
						className: "valwinFactoIcon--green"
					}),
					onClickIconEdit && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "EDIT",
						onClick: () => {
							onClickIconEdit(item.id);
						}
					}),
					onClickIconDelete && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "TRASH",
						onClick: () => {
							onClickIconDelete(item.id);
						}
					})
				]
			})]
		}), /* @__PURE__ */ jsx("div", {
			className: "valwinFactoDropdownItem__themeContainer",
			children: isOpen && map(filteredSubItems, (theme) => {
				const then = new Date(theme.createdAt);
				const now = /* @__PURE__ */ new Date();
				const daysBetweenDates = Math.abs(then.getTime() - now.getTime()) / 864e5;
				return /* @__PURE__ */ jsxs("div", {
					className: classnames("valwinFactoDropdownItem__themeItem", { "valwinFactoDropdownItem__themeItem--selected": currentSubItem?.id === theme.id }),
					onClick: () => setCurrentSubItem(theme),
					children: [/* @__PURE__ */ jsxs("div", {
						className: "valwinFactoDropdownItem__themeItem__label",
						children: [daysBetweenDates < 30 && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "NEW",
							className: "valwinFactoDropdownItem__themeItem__icon"
						}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: /* @__PURE__ */ jsx(Highlighter, {
							highlightClassName: "valwinFactoParagraph__highlight",
							searchWords: isString(search) ? search.split(" ") : [],
							autoEscape: true,
							textToHighlight: isEmpty(theme.title) ? "Sans titre" : theme.title || ""
						}) })]
					}), /* @__PURE__ */ jsxs("div", {
						className: "valwinFactoDropdownItem__themeItem__details",
						children: [onClickSubIconEdit && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "EDIT",
							onClick: () => {
								onClickSubIconEdit(theme.id, item.id);
							}
						}), onClickSubIconDelete && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "TRASH",
							onClick: () => {
								onClickSubIconDelete(theme.id);
							}
						})]
					})]
				}, theme.id);
			})
		})]
	});
};
ValwinFactoDropdownItem$1.propTypes = {
	item: object.isRequired,
	title: string.isRequired,
	subItems: array.isRequired,
	currentSubItem: object,
	setCurrentSubItem: func.isRequired,
	setCurrentItem: func.isRequired,
	search: string.isRequired,
	onClickIconAdd: func,
	onClickIconEdit: func,
	onClickIconDelete: func,
	onClickSubIconEdit: func,
	onClickSubIconDelete: func
};
// src/legacy/ValwinFactoDropdownMenu/ValwinFactoDropdownMenu.jsx
const ValwinFactoDropdownMenu$1 = ({ elements, currentSubItem, setCurrentSubItem, setCurrentItem, search, onClickIconAdd, onClickIconEdit, onClickIconDelete, onClickSubIconEdit, onClickSubIconDelete }) => {
	return /* @__PURE__ */ jsx("ul", {
		className: "valwinFactoDropdownMenu",
		children: map(elements, (elem) => {
			return /* @__PURE__ */ jsx(ValwinFactoDropdownItem$1, {
				item: elem,
				title: elem.title || "",
				subItems: elem.themes || [],
				currentSubItem,
				setCurrentSubItem,
				setCurrentItem,
				search,
				onClickIconAdd,
				onClickIconEdit,
				onClickIconDelete,
				onClickSubIconEdit,
				onClickSubIconDelete
			}, elem.id);
		})
	});
};
ValwinFactoDropdownMenu$1.propTypes = {
	elements: array.isRequired,
	currentTheme: object,
	setCurrentItem: func.isRequired,
	setCurrentSubItem: func.isRequired,
	search: string.isRequired,
	onClickIconAdd: func,
	onClickIconEdit: func,
	onClickIconDelete: func,
	onClickSubIconEdit: func,
	onClickSubIconDelete: func
};
// src/legacy/ValwinFactoDuration/ValwinFactoDurationUtils.js
const getHourValue = (value) => {
	try {
		if (!isString(value)) return 24;
		if (value.length < 5) return 24;
		const hoursString = value.slice(0, 2);
		const hoursNumber = Number.parseInt(hoursString);
		if (!isNumber(hoursNumber)) return 24;
		return hoursNumber;
	} catch {
		return 24;
	}
};
const getMinuteValue = (value) => {
	try {
		if (!isString(value)) return 0;
		if (value.length < 5) return 0;
		const hoursString = value.slice(3, 5);
		const hoursNumber = Number.parseInt(hoursString);
		if (!isNumber(hoursNumber)) return 0;
		return hoursNumber;
	} catch {
		return 0;
	}
};
const getNewValueWithHours = (value, hours) => {
	try {
		const newHoursInt = Number.parseInt(hours);
		return `${newHoursInt >= 10 ? newHoursInt : `0${newHoursInt}`}:${(isString(value) && isEqual(value.length, 5) ? value : "24:00").slice(3, 5)}`;
	} catch {
		return "24:00";
	}
};
const getNewValueWithMinutes = (value, minutes) => {
	try {
		const newMinutesInt = Number.parseInt(minutes);
		const newMinutesString = newMinutesInt >= 10 ? newMinutesInt : `0${newMinutesInt}`;
		return `${(isString(value) && isEqual(value.length, 5) ? value : "24:00").slice(0, 2)}:${newMinutesString}`;
	} catch {
		return "24:00";
	}
};
// src/legacy/ValwinFactoDuration/ValwinFactoDuration.jsx
const ValwinFactoDuration$1 = ({ name, label, disabled, required, errors, className, onChange, value, tooltip, maxHours, maxMinutes }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoDuration ${className}`, { "valwinFactoDuration--disabled": disabled }),
		id: `container__${name}`,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoDuration__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoDuration__label", { "valwinFactoDuration__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoDuration__required", { "valwinFactoDuration__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoDuration__tooltip"
				}),
				errors && errors[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoDuration__errors", { "valwinFactoDuration__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoDuration__inputs",
			children: [
				/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
					name: "valwinFactoDuration__hours",
					type: "number",
					min: 0,
					placeholder: "H",
					onChange: (event) => {
						onChange(getNewValueWithHours(value, event.target.value));
					},
					className: "valwinFactoDuration__input",
					value: getHourValue(value),
					max: maxHours,
					disabled
				}),
				/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: "h",
					className: classnames("valwinFactoDuration__paragraph", { "valwinFactoDuration__paragraph--disabled": disabled })
				}),
				/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
					name: "valwinFactoDuration__minutes  ",
					type: "number",
					min: 0,
					placeholder: "M",
					onChange: (event) => {
						onChange(getNewValueWithMinutes(value, event.target.value));
					},
					className: "valwinFactoDuration__input",
					value: getMinuteValue(value),
					max: maxMinutes,
					disabled
				}),
				/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: "m",
					className: classnames("valwinFactoDuration__paragraph", { "valwinFactoDuration__paragraph--disabled": disabled })
				})
			]
		})]
	});
};
ValwinFactoDuration$1.propTypes = {
	label: string.isRequired,
	onChange: func.isRequired,
	name: string.isRequired,
	maxHours: number.isRequired,
	maxMinutes: number.isRequired,
	value: any,
	disabled: bool,
	required: bool,
	errors: object,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoExtranetAffiliations/ValwinFactoExtranetAffiliations.jsx
const ValwinFactoExtranetAffiliations$1 = ({ className, disabled, value, affiliations, onSave, onBack, allPharmaciesLabel = "Toutes les pharmacies", cancelLabel = "Annuler", saveLabel = "Enregistrer" }) => {
	const [valueInside, setValueInside] = useState(value);
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoExtranetAffiliations ${className}`, { "valwinFactoExtranetAffiliations--disabled": disabled }),
		children: [
			/* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
				disabled,
				name: "ValwinFactoExtranetAffiliations__all",
				label: allPharmaciesLabel,
				onChange: (event) => {
					if (event.target.checked) setValueInside([]);
				},
				checked: isEqual(valueInside, []),
				className: "valwinFactoExtranetAffiliations__all"
			}),
			/* @__PURE__ */ jsx("div", {
				className: classnames(`valwinFactoExtranetAffiliations__container ${className}`, { "valwinFactoExtranetAffiliations__container--disabled": disabled }),
				children: affiliations.map((affiliation, index) => /* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
					disabled,
					name: `ValwinFactoExtranetAffiliations__${affiliation.value}`,
					label: affiliation?.label || "",
					onChange: (event) => {
						if (event.target.checked) {
							const newValueInside = [...valueInside, affiliation?.value || ""];
							setValueInside(newValueInside);
						} else {
							const newValueInsideFiltered = [...valueInside].filter((t) => !isEqual(t, affiliation?.value || ""));
							setValueInside(newValueInsideFiltered);
						}
					},
					checked: valueInside.includes(affiliation?.value || "")
				}, index))
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoExtranetAffiliations__buttons",
				children: [/* @__PURE__ */ jsx(ValwinFactoButton$1, {
					type: "button",
					label: cancelLabel,
					className: "valwinFactoButton--grey valwinFactoExtranetAffiliations__back",
					onClick: () => onBack()
				}), /* @__PURE__ */ jsx(ValwinFactoButton$1, {
					type: "button",
					label: saveLabel,
					className: "valwinFactoButton--greenStrong valwinFactoExtranetAffiliations__save",
					onClick: () => onSave(valueInside)
				})]
			})
		]
	});
};
ValwinFactoExtranetAffiliations$1.propTypes = {
	value: arrayOf(string).isRequired,
	affiliations: arrayOf(object).isRequired,
	onSave: func.isRequired,
	onBack: func.isRequired,
	className: string,
	disabled: bool
};
// src/legacy/ValwinFactoExtranetAffiliationsField/ValwinFactoExtranetAffiliationsField.jsx
const ValwinFactoExtranetAffiliationsField$1 = ({ label, disabled, className, value, onClick }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoExtranetAffiliationsField ${className}`, { "valwinFactoExtranetAffiliationsField--disabled": disabled }),
		onClick,
		children: [/* @__PURE__ */ jsx("div", {
			className: "valwinFactoExtranetAffiliationsField__header",
			children: /* @__PURE__ */ jsx("div", {
				className: classnames("valwinFactoExtranetAffiliationsField__label", { "valwinFactoExtranetAffiliationsField__label--disabled": disabled }),
				children: label
			})
		}), /* @__PURE__ */ jsx("div", {
			className: "valwinFactoExtranetAffiliationsField__container",
			children: /* @__PURE__ */ jsxs("div", {
				className: "valwinFactoExtranetAffiliationsField__affiliation",
				children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "USERS",
					className: "valwinFactoIcon--green valwinFactoExtranetAffiliationsField__affiliationIcon"
				}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: value,
					className: "valwinFactoParagraph--green valwinFactoExtranetAffiliationsField__affiliationLabel"
				})]
			})
		})]
	});
};
ValwinFactoExtranetAffiliationsField$1.propTypes = {
	label: string.isRequired,
	value: string.isRequired,
	onClick: func.isRequired,
	disabled: bool,
	className: string
};
// src/legacy/ValwinFactoExtranetAffiliationsLabel/ValwinFactoExtranetAffiliationsLabel.jsx
const ValwinFactoExtranetAffiliationsLabel$1 = ({ label, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoExtranetAffiliationsLabel ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
			icon: "USERS",
			className: "valwinFactoIcon--green valwinFactoExtranetAffiliationsLabel__icon"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label,
			className: "valwinFactoParagraph--green valwinFactoExtranetAffiliationsLabel__label"
		})]
	});
};
ValwinFactoExtranetAffiliationsLabel$1.propTypes = {
	label: string.isRequired,
	className: string
};
// src/legacy/ValwinFactoExtranetBanner/ValwinFactoExtranetBannerUtils.js
const getTitle = (banner) => {
	return banner?.title || "";
};
const getDescription = (banner) => {
	return banner?.description || "";
};
const getColor1 = (banner) => {
	return banner?.color1 || "";
};
const getColor2 = (banner) => {
	return banner?.color2 || "";
};
const getImage = (banner) => {
	return banner?.image || "";
};
const getHeight = (banner) => {
	return banner?.height || 100;
};
// src/legacy/ValwinFactoExtranetBanner/ValwinFactoExtranetBanner.jsx
const ValwinFactoExtranetBanner$1 = ({ banner, className }) => {
	const color1 = getColor1(banner);
	const color2 = getColor2(banner);
	const title = getTitle(banner);
	const description = getDescription(banner);
	const image = getImage(banner);
	const height = getHeight(banner);
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoExtranetBanner ${className}`,
		style: { background: `linear-gradient(90deg, ${color1} 0%, ${color2} 100%)` },
		children: [/* @__PURE__ */ jsx("img", {
			src: image,
			className: "valwinFactoExtranetBanner__image",
			alt: "",
			style: { height: `${height}px` }
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoExtranetBanner__container",
			children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: title,
				className: "valwinFactoParagraph--white valwinFactoParagraph--strong"
			}), !isEmpty(description) && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: description,
				className: "valwinFactoParagraph--white valwinFactoParagraph--light"
			})]
		})]
	});
};
ValwinFactoExtranetBanner$1.propTypes = {
	banner: object.isRequired,
	className: string
};
// src/legacy/ValwinFactoExtranetBulkAffiliation/ValwinFactoExtranetBulkAffiliationUtils.js
const getPrevious = (affiliation) => {
	return affiliation?.previous || "";
};
const getNext = (affiliation) => {
	return affiliation?.next || "";
};
// src/legacy/ValwinFactoExtranetBulkAffiliation/ValwinFactoExtranetBulkAffiliation.jsx
const ValwinFactoExtranetBulkAffiliation$1 = ({ className, name, affiliations }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoExtranetBulkAffiliation ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: name,
			className: "valwinFactoParagraph--lightBold"
		}), /* @__PURE__ */ jsx("div", {
			className: "valwinFactoExtranetBulkAffiliation__affiliations",
			children: isArray(affiliations) && affiliations.map((affiliation, index) => {
				const previous = getPrevious(affiliation);
				const next = getNext(affiliation);
				return /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoExtranetBulkAffiliation__affiliation",
					children: [
						/* @__PURE__ */ jsx(ValwinFactoExtranetAffiliationsLabel$1, { label: previous }),
						/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "LONG_ARROW_RIGHT",
							className: "valwinFactoExtranetBulkAffiliation__arrow"
						}),
						/* @__PURE__ */ jsx(ValwinFactoExtranetAffiliationsLabel$1, { label: next })
					]
				}, index);
			})
		})]
	});
};
ValwinFactoExtranetBulkAffiliation$1.propTypes = {
	name: string.isRequired,
	affiliations: arrayOf(object).isRequired,
	className: string
};
// src/legacy/ValwinFactoExtranetBulkDelete/ValwinFactoExtranetBulkDelete.jsx
const ValwinFactoExtranetBulkDelete$1 = ({ className, name, onDelete }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoExtranetBulkDelete ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: name,
			className: "valwinFactoParagraph--lightBold"
		}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
			icon: "TRASH",
			className: "valwinFactoIcon--red",
			onClick: onDelete
		})]
	});
};
ValwinFactoExtranetBulkDelete$1.propTypes = {
	name: string.isRequired,
	onDelete: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoExtranetButtonDocument/ValwinFactoExtranetButtonDocument.jsx
const ValwinFactoExtranetButtonDocument$1 = ({ className, icon, label, onClick }) => {
	return /* @__PURE__ */ jsxs("button", {
		className: `valwinFactoExtranetButtonDocument ${className}`,
		onClick,
		children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
			disabled: true,
			icon,
			className: "valwinFactoExtranetButtonDocument__icon"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label,
			className: "valwinFactoExtranetButtonDocument__label valwinFactoParagraph--medium"
		})]
	});
};
ValwinFactoExtranetButtonDocument$1.propTypes = {
	icon: string.isRequired,
	label: string.isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoExtranetDirectoryChoice/ValwinFactoExtranetDirectoryChoice.jsx
const ValwinFactoExtranetDirectoryChoice$1 = ({ className, icon, label, count, onClick, isSelected }) => {
	return /* @__PURE__ */ jsxs("button", {
		className: classnames(`valwinFactoExtranetDirectoryChoice ${className}`, { "valwinFactoExtranetDirectoryChoice--selected": isSelected }),
		onClick,
		children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
			icon,
			className: "valwinFactoIcon--green valwinFactoExtranetDirectoryChoice__icon"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: `${label} (${count})`,
			className: "valwinFactoParagraph--green"
		})]
	});
};
ValwinFactoExtranetDirectoryChoice$1.propTypes = {
	icon: string.isRequired,
	label: string.isRequired,
	count: number.isRequired,
	onClick: func.isRequired,
	isSelected: bool
};
// src/legacy/ValwinFactoExtranetMediasBreadcrumbs/ValwinFactoExtranetMediasBreadcrumbsUtils.js
const getName$2 = (folder) => {
	return folder?.name || "";
};
const getId = (folder) => {
	return folder?.id || "";
};
// src/legacy/ValwinFactoExtranetMediasBreadcrumbs/ValwinFactoExtranetMediasBreadcrumbs.jsx
const ValwinFactoExtranetMediasBreadcrumbs$1 = ({ className, breadcrumbs, onClick }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoExtranetMediasBreadcrumbs ${className}`,
		children: isArray(breadcrumbs) && breadcrumbs.map((folder, index) => {
			const name = getName$2(folder);
			const id = getId(folder);
			return /* @__PURE__ */ jsxs("div", {
				className: "valwinFactoExtranetMediasBreadcrumbs__container",
				children: [/* @__PURE__ */ jsx("div", {
					className: "valwinFactoExtranetMediasBreadcrumbs__link",
					onClick: () => onClick(id),
					children: name
				}), !isEqual(index, breadcrumbs.length - 1) && /* @__PURE__ */ jsx("div", {
					className: "valwinFactoExtranetMediasBreadcrumbs__arrow",
					children: `>`
				})]
			}, index);
		})
	});
};
ValwinFactoExtranetMediasBreadcrumbs$1.propTypes = {
	breadcrumbs: arrayOf(object).isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoExtranetMediasFolder/ValwinFactoExtranetMediasFolderUtils.js
const getName$1 = (mediasFolder) => {
	return mediasFolder?.pageData?.name || "";
};
const getColor$2 = (mediasFolder) => {
	return mediasFolder?.pageData?.color || "";
};
const getHasChildren = (mediasFolder) => {
	return (mediasFolder?.childrenSummary || []).some((children) => isEqual(children?.pageType, "MEDIAS_FOLDER"));
};
// src/legacy/ValwinFactoExtranetMediasFolder/ValwinFactoExtranetMediasFolder.jsx
const ValwinFactoExtranetMediasFolder$1 = ({ mediasFolder, className, onEdit, onDelete, onClick, onAdd, affiliationsLabel, isSelected, isOpen }) => {
	const name = getName$1(mediasFolder);
	const color = getColor$2(mediasFolder);
	const hasChildren = getHasChildren(mediasFolder);
	return /* @__PURE__ */ jsx("div", {
		className: classnames(`valwinFactoExtranetMediasFolder ${className}`, { "valwinFactoExtranetMediasFolder--selected": isSelected }),
		onClick,
		children: /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoExtranetMediasFolder__container",
			children: [
				/* @__PURE__ */ jsx(FaFolder, {
					className: "valwinFactoExtranetMediasFolder__folder",
					style: { color }
				}),
				hasChildren && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: isOpen ? "ARROW_DOWN" : "ARROW_RIGHT",
					className: "valwinFactoExtranetMediasFolder__arrow"
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoExtranetMediasFolder__infos",
					children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: name,
						className: "valwinFactoIcon--green"
					}), /* @__PURE__ */ jsxs("div", {
						className: "valwinFactoExtranetMediasFolder__affiliations",
						children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "USERS",
							className: "valwinFactoIcon--greyStrong valwinFactoExtranetMediasFolder__affiliationsIcon"
						}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
							label: affiliationsLabel,
							isItalic: true,
							className: "valwinFactoParagraph--greyStrong valwinFactoParagraph--miniBold"
						})]
					})]
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoExtranetMediasFolder__buttons",
					children: [
						/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "ADD",
							className: "valwinFactoIcon--green valwinFactoExtranetMediasFolder__add",
							onClick: onAdd
						}),
						/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
							type: "button",
							icon: "EDIT",
							className: "valwinFactoButtonIcon--green",
							onClick: onEdit
						}),
						/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
							type: "button",
							icon: "TRASH",
							className: "valwinFactoButtonIcon--red",
							onClick: onDelete
						})
					]
				})
			]
		})
	});
};
ValwinFactoExtranetMediasFolder$1.propTypes = {
	mediasFolder: object.isRequired,
	onEdit: func.isRequired,
	onDelete: func.isRequired,
	onClick: func.isRequired,
	onAdd: func.isRequired,
	affiliationsLabel: string.isRequired,
	className: string,
	isSelected: bool,
	isOpen: bool
};
// src/legacy/ValwinFactoExtranetMediasSubFolder/ValwinFactoExtranetMediasSubFolderUtils.js
const getName = (mediasFolder) => {
	return mediasFolder?.pageData?.name || "";
};
const getColor$1 = (mediasFolder) => {
	return mediasFolder?.pageData?.color || "";
};
// src/legacy/ValwinFactoExtranetMediasSubFolder/ValwinFactoExtranetMediasSubFolder.jsx
const ValwinFactoExtranetMediasSubFolder$1 = ({ mediasFolder, className, onClick, affiliationsLabel, isSelected }) => {
	const name = getName(mediasFolder);
	const color = getColor$1(mediasFolder);
	return /* @__PURE__ */ jsx("div", {
		className: classnames(`valwinFactoExtranetMediasSubFolder ${className}`, { "valwinFactoExtranetMediasSubFolder--selected": isSelected }),
		onClick,
		children: /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoExtranetMediasSubFolder__container",
			children: [/* @__PURE__ */ jsx(FaFolder, {
				className: "valwinFactoExtranetMediasSubFolder__folder",
				style: { color }
			}), /* @__PURE__ */ jsxs("div", {
				className: "valwinFactoExtranetMediasSubFolder__infos",
				children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: name }), /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoExtranetMediasSubFolder__affiliations",
					children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "USERS",
						className: "valwinFactoIcon--green valwinFactoExtranetMediasSubFolder__affiliationsIcon"
					}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: affiliationsLabel,
						isItalic: true,
						className: "valwinFactoParagraph--green"
					})]
				})]
			})]
		})
	});
};
ValwinFactoExtranetMediasSubFolder$1.propTypes = {
	mediasFolder: object.isRequired,
	onClick: func.isRequired,
	affiliationsLabel: string.isRequired,
	className: string,
	isSelected: bool
};
// src/legacy/ValwinFactoExtranetTag/ValwinFactoExtranetTag.jsx
const ValwinFactoExtranetTag$1 = ({ label, className, color }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoExtranetTag ${className}`,
		style: { background: color },
		children: label
	});
};
ValwinFactoExtranetTag$1.propTypes = {
	label: string.isRequired,
	color: string.isRequired,
	className: string
};
// src/legacy/ValwinFactoField/ValwinFactoField.jsx
const ValwinFactoField$1 = ({ name, label, placeholder, type, disabled, required, touched, errors, className, onChange, onBlur, value: defaultValue, tooltip, min, max, step, maxLength, isPassword }) => {
	const [inputType, setInputType] = useState(type);
	const [value, setValue] = useState(defaultValue);
	const handleChange = (event) => {
		setValue(event.target.value);
		onChange?.(event);
	};
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoField ${className}`, { "valwinFactoField--disabled": disabled }),
		id: `container__${name}`,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoField__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoField__label", { "valwinFactoField__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoField__required", { "valwinFactoField__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoField__tooltip"
				}),
				errors && errors[name] && touched && touched[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoField__errors", { "valwinFactoField__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoField__inputContainer",
			children: [/* @__PURE__ */ jsx("input", {
				name,
				id: name,
				placeholder,
				type: inputType,
				disabled,
				className: classnames("valwinFactoField__input", { "valwinFactoField__input--disabled": disabled }),
				onChange: handleChange,
				onBlur,
				value,
				min,
				max,
				step,
				maxLength
			}), isPassword && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
				icon: isEqual(inputType, "text") ? "HIDE" : "SHOW",
				onClick: () => setInputType(isEqual(inputType, "text") ? "password" : "text"),
				className: "valwinFactoField__inputIcon valwinFactoIcon--green"
			})]
		})]
	});
};
ValwinFactoField$1.propTypes = {
	label: string.isRequired,
	placeholder: string.isRequired,
	type: string.isRequired,
	value: any.isRequired,
	onChange: func.isRequired,
	name: string.isRequired,
	onBlur: func,
	disabled: bool,
	required: bool,
	touched: object,
	errors: object,
	className: string,
	tooltip: object,
	min: number,
	max: number,
	step: number,
	maxLength: number,
	isPassword: bool
};
// src/legacy/ValwinFactoFieldIframe/ValwinFactoFieldIframeUtils.js
const getEmbeddedUrlYoutube$1 = (value) => {
	if (!isString(value)) return "";
	const url = new URL(value);
	const id = new URLSearchParams(url.search).get("v");
	if (isEmpty(id)) return "";
	return `https://www.youtube.com/embed/${id}`;
};
const getEmbeddedUrl$1 = (url) => {
	if (!isString(url)) return "";
	if (url.includes("youtube")) return getEmbeddedUrlYoutube$1(url);
	return url;
};
const hasAutoplayUrl = (url) => {
	return new URL(url).searchParams.has("autoplay");
};
const addAutoplayUrl = (url) => {
	const newUrl = new URL(url);
	newUrl.searchParams.append("autoplay", "true");
	return newUrl.toString();
};
const removeAutoplayUrl = (url) => {
	const newUrl = new URL(url);
	newUrl.searchParams.delete("autoplay");
	return newUrl.toString();
};
// src/legacy/ValwinFactoFieldIframe/ValwinFactoFieldIframe.jsx
const ValwinFactoFieldIframe$1 = ({ name, label, placeholder, disabled, required, touched, errors, className, onChange, onBlur, value, tooltip, withYoutubeOptions }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoFieldIframe ${className}`,
		children: [
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				tooltip,
				disabled,
				required,
				name,
				label,
				placeholder,
				type: "text",
				value,
				onChange,
				onBlur,
				errors,
				touched
			}),
			!isEmpty(value) && isEmpty(errors) && /* @__PURE__ */ jsx("iframe", {
				title: name,
				className: "valwinFactoFieldIframe__iframe",
				src: getEmbeddedUrl$1(value),
				frameBorder: "0"
			}),
			withYoutubeOptions && isEmpty(errors) && isString(value) && value.includes("youtube") && /* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
				name: "autoplay",
				label: "Activer la lecture automatique",
				checked: hasAutoplayUrl(value),
				onChange: () => {
					onChange({ target: { value: hasAutoplayUrl(value) ? removeAutoplayUrl(value) : addAutoplayUrl(value) } });
				},
				errors,
				touched,
				className: "valwinFactoFieldIframe__checkbox"
			})
		]
	});
};
ValwinFactoFieldIframe$1.propTypes = {
	label: string.isRequired,
	placeholder: string.isRequired,
	value: string.isRequired,
	onChange: func.isRequired,
	name: string.isRequired,
	withYoutubeOptions: bool,
	onBlur: func,
	disabled: bool,
	required: bool,
	touched: object,
	errors: object,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoFormElementArea/ValwinFactoFormElementArea.jsx
const ValwinFactoFormElementArea = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementArea",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementArea__help",
				children: "Écrivez une question à laquelle vous souhaitez une réponse sous forme de texte long."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementArea__error",
				children: errors?.content?.[value?.name]
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Question",
				placeholder: "Question",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementArea.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoFormElementCountry/ValwinFactoFormElementCountry.jsx
const ValwinFactoFormElementCountry = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementCountry",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementCountry__help",
				children: "Écrivez une question à laquelle vous souhaitez une réponse sous forme de pays."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementCountry__error",
				children: errors?.content?.[value?.name]
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Question",
				placeholder: "Question",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementCountry.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoFormElementDateIso/ValwinFactoFormElementDateIso.jsx
const ValwinFactoFormElementDateIso = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementDateIso",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementDateIso__help",
				children: "Écrivez une question à laquelle vous souhaitez une réponse sous forme de date."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementDateIso__error",
				children: errors?.content?.[value?.name]
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Question",
				placeholder: "Question",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementDateIso.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired
};
// src/legacy/ValwinFactoFormElementExplication/ValwinFactoFormElementExplication.jsx
const ValwinFactoFormElementExplication = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementExplication",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementExplication__help",
				children: "Écrivez un texte."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementExplication__error",
				children: errors?.content?.[value?.name]
			}),
			/* @__PURE__ */ jsx(ValwinFactoArea$1, {
				name: value?.name || "",
				label: "Texte",
				placeholder: "Texte",
				onChange: (event) => setValue({
					...value,
					text: event.target.value
				}),
				value: value?.text || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementExplication.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoFormElementLink/ValwinFactoFormElementLink.jsx
const ValwinFactoFormElementLink = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementLink",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementLink__help",
				children: "Écrivez le nom du lien."
			}),
			!isEmpty(errors?.content?.[value?.name]?.label) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementLink__error",
				children: errors?.content?.[value?.name]?.label
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Nom",
				placeholder: "Lien",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementLink__help",
				children: "Écrivez l'adresse du lien."
			}),
			!isEmpty(errors?.content?.[value?.name]?.url) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementLink__error",
				children: errors?.content?.[value?.name]?.url
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Adresse",
				placeholder: "https://www.google.fr",
				type: "text",
				onChange: (event) => setValue({
					...value,
					url: event.target.value
				}),
				value: value?.url || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementLink.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoFormElementNir/ValwinFactoFormElementNir.jsx
const ValwinFactoFormElementNir = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementNir",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementNir__help",
				children: "Écrivez une question à laquelle vous souhaitez une réponse sous forme de numéro de sécurité sociale."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementNir__error",
				children: errors?.content?.[value?.name]
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Question",
				placeholder: "Question",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementNir.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoFormElementSelect/ValwinFactoFormElementSelect.jsx
const ValwinFactoFormElementSelect = ({ value, setValue, errors }) => {
	useEffect(() => {
		if (isEmpty(value?.options)) setValue({
			...value,
			options: ["", ""]
		});
	}, []);
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementSelect",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementSelect__help",
				children: "Écrivez une question à laquelle vous souhaitez une réponse à choix multiple."
			}),
			!isEmpty(errors?.content?.[value?.name]?.label) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementSelect__error",
				children: errors?.content?.[value?.name]?.label
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Question",
				placeholder: "Question",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementSelect__help",
				children: "Écrivez au moins deux réponses."
			}),
			!isEmpty(errors?.content?.[value?.name]?.options) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementSelect__error",
				children: errors?.content?.[value?.name]?.options
			}),
			value?.options?.map((option, index) => {
				return /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoFormElementSelect__row",
					children: [/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
						textAlignLeft: true,
						name: `${value?.name || ""}[${index}]`,
						type: "text",
						value: option,
						placeholder: `Réponse ${index + 1}`,
						onChange: (event) => {
							const newValue = structuredClone(value);
							newValue.options[index] = event.target.value;
							setValue(newValue);
						},
						className: "valwinFactoFormElementSelect__input"
					}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "TRASH",
						className: "valwinFactoIcon--grey valwinFactoFormElementSelect__delete",
						onClick: () => {
							const newValue = structuredClone(value);
							newValue.options.splice(index, 1);
							setValue(newValue);
						},
						disabled: (value?.options || []).length < 3
					})]
				}, index);
			}),
			/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
				type: "button",
				icon: "ADD",
				className: "valwinFactoButtonIcon--green valwinFactoFormElementSelect__add",
				onClick: () => {
					const newValue = structuredClone(value);
					newValue.options.push("");
					setValue(newValue);
				}
			})
		]
	});
};
ValwinFactoFormElementSelect.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoFormElementString/ValwinFactoFormElementString.jsx
const ValwinFactoFormElementString = ({ value, setValue, errors, isBasicElement }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementString",
		children: [
			!isBasicElement && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementString__help",
				children: "Écrivez une question à laquelle vous souhaitez une réponse sous forme de texte court."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementString__error",
				children: errors?.content?.[value?.name]
			}),
			isBasicElement && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementString__basic",
				children: "Vous ne pouvez pas modifier ou supprimer cet élément de base du questionnaire."
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Question",
				placeholder: "Question",
				type: "text",
				onChange: (event) => setValue({
					...value,
					label: event.target.value
				}),
				value: value?.label || "",
				required: true,
				disabled: isBasicElement
			})
		]
	});
};
ValwinFactoFormElementString.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object,
	isBasicElement: bool
};
// src/legacy/ValwinFactoFormElementTitre/ValwinFactoFormElementTitre.jsx
const ValwinFactoFormElementTitre = ({ value, setValue, errors }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoFormElementTitre",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementTitre__help",
				children: "Écrivez un titre."
			}),
			!isEmpty(errors?.content?.[value?.name]) && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoFormElementTitre__error",
				children: errors?.content?.[value?.name]
			}),
			/* @__PURE__ */ jsx(ValwinFactoField$1, {
				name: value?.name || "",
				label: "Titre",
				placeholder: "Titre",
				type: "text",
				onChange: (event) => setValue({
					...value,
					text: event.target.value
				}),
				value: value?.text || "",
				required: true
			})
		]
	});
};
ValwinFactoFormElementTitre.propTypes = {
	value: object.isRequired,
	setValue: func.isRequired,
	errors: object
};
// src/legacy/ValwinFactoSelectAlt/ValwinFactoSelectAlt.jsx
const ValwinFactoSelectAlt$1 = ({ className, onChange, value, options, maxMenuHeight, disabled, isAsync, loadOptions, isMulti, name, noOptionsMessage, placeholder, isSearchable }) => {
	const commonProps = {
		name,
		isDisabled: disabled,
		value,
		onChange,
		styles: {
			valueContainer: (styles) => ({
				...styles,
				minHeight: "22px",
				height: "22px",
				margin: "0px",
				padding: "0px",
				fontSize: "14px"
			}),
			indicatorsContainer: (styles) => ({
				...styles,
				minHeight: "22px",
				height: "22px",
				minWidth: "40px",
				width: "40px",
				margin: "0px",
				padding: "0px",
				fontSize: "14px"
			}),
			indicatorContainer: (styles) => ({
				...styles,
				minHeight: "22px",
				height: "22px",
				minWidth: "40px",
				width: "40px",
				margin: "0px",
				padding: "0px 0px 0px 0px",
				fontSize: "14px"
			}),
			indicatorSeparator: (styles) => ({
				...styles,
				minHeight: "22px",
				height: "22px",
				margin: "0px",
				padding: "0px",
				fontSize: "14px"
			}),
			option: (styles, { isFocused, isSelected }) => ({
				...styles,
				cursor: "pointer",
				color: isFocused || isSelected ? "#fff" : "#555555",
				"&:hover": { color: "#fff" },
				fontSize: "16px"
			}),
			control: (styles) => ({
				...styles,
				cursor: "pointer",
				border: "0px",
				boxShadow: "0px",
				background: "transparent",
				minHeight: "22px",
				height: "22px",
				margin: "-3px 0px 3px 10px",
				padding: "0px"
			}),
			singleValue: (styles, { isDisabled }) => ({
				...styles,
				color: isDisabled ? "#d9d9d9" : "#555555",
				fontSize: "14px",
				margin: "0px"
			}),
			placeholder: (styles) => ({
				...styles,
				fontStyle: "normal",
				fontWeight: 500,
				fontSize: "13px",
				color: "#d9d9d9"
			}),
			menu: (base) => ({
				...base,
				zIndex: 2
			})
		},
		placeholder: placeholder || "Sélectionnez une réponse",
		noOptionsMessage,
		isMulti,
		maxMenuHeight,
		theme: (theme) => ({
			...theme,
			colors: {
				...theme.colors,
				primary25: "#0B7678",
				primary: "#0B7678"
			}
		})
	};
	const syncProps = {
		options,
		isSearchable
	};
	const asyncProps = { loadOptions };
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoSelectAlt ${className}`,
		children: isAsync ? /* @__PURE__ */ jsx(AsyncSelect, {
			...commonProps,
			...asyncProps
		}) : /* @__PURE__ */ jsx(Select, {
			...commonProps,
			...syncProps
		})
	});
};
ValwinFactoSelectAlt$1.propTypes = {
	name: string.isRequired,
	onChange: func.isRequired,
	options: arrayOf(any),
	placeholder: string,
	noOptionsMessage: func,
	value: any,
	className: string,
	maxMenuHeight: number,
	isAsync: bool,
	loadOptions: func,
	isMulti: bool,
	isSearchable: bool
};
// src/legacy/ValwinFactoFormElement/ValwinFactoFormElement.jsx
const ValwinFactoFormElement$1 = forwardRef(function createValwinFactoFormElement({ className, value, setValue, types, deleteElement, errors, isBasicElement, isSbo, handleProps, isDragging }, ref) {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoFormElement ${className}`,
		ref,
		children: /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoFormElement__container",
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoFormElement__header",
					children: [/* @__PURE__ */ jsx("div", {
						...handleProps,
						style: { cursor: isDragging ? "grabbing" : "grab" },
						children: /* @__PURE__ */ jsx(VerticalGripIcon, { size: "xl" })
					}), !isBasicElement && /* @__PURE__ */ jsx(ValwinFactoSelectAlt$1, {
						name: "type",
						options: types,
						onChange: (newType) => setValue({
							name: value?.name || "",
							type: newType
						}),
						value: value?.type || "",
						className: "valwinFactoFormElement__type"
					})]
				}),
				/* @__PURE__ */ jsxs("div", {
					style: { cursor: "default" },
					children: [
						isEqual(value?.type.value, "TITLE") && /* @__PURE__ */ jsx(ValwinFactoFormElementTitre, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "EXPLICATION") && /* @__PURE__ */ jsx(ValwinFactoFormElementExplication, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "LINK") && /* @__PURE__ */ jsx(ValwinFactoFormElementLink, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "STRING") && /* @__PURE__ */ jsx(ValwinFactoFormElementString, {
							value,
							setValue,
							errors,
							isBasicElement
						}),
						isEqual(value?.type.value, "AREA") && /* @__PURE__ */ jsx(ValwinFactoFormElementArea, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "DATE_ISO") && /* @__PURE__ */ jsx(ValwinFactoFormElementDateIso, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "NIR") && /* @__PURE__ */ jsx(ValwinFactoFormElementNir, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "COUNTRY") && /* @__PURE__ */ jsx(ValwinFactoFormElementCountry, {
							value,
							setValue,
							errors
						}),
						isEqual(value?.type.value, "SELECT") && /* @__PURE__ */ jsx(ValwinFactoFormElementSelect, {
							value,
							setValue,
							errors
						})
					]
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoFormElement__footer",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "valwinFactoFormElement__activations",
						children: [!isBasicElement && value?.type.canBeRequired && /* @__PURE__ */ jsx(ValwinFactoActivation$1, {
							value: value?.required || false,
							onClick: () => {
								setValue({
									...value,
									required: !value?.required
								});
							},
							label: "Obligatoire",
							isSbo
						}), !isBasicElement && value?.type.canBeIsPharmacist && /* @__PURE__ */ jsx(ValwinFactoActivation$1, {
							value: value?.isPharmacist || false,
							onClick: () => {
								setValue({
									...value,
									isPharmacist: !value?.isPharmacist
								});
							},
							label: "Réservé au pharmacien",
							isSbo
						})]
					}), !isBasicElement && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "TRASH",
						className: "valwinFactoIcon--grey valwinFactoFormElement__icon valwinFactoFormElement__delete",
						onClick: deleteElement
					})]
				})
			]
		})
	});
});
ValwinFactoFormElement$1.propTypes = {
	className: string,
	value: object.isRequired,
	types: arrayOf(object).isRequired,
	setValue: func.isRequired,
	deleteElement: func.isRequired,
	errors: object,
	isBasicElement: bool,
	isSbo: bool
};
// src/legacy/ValwinFactoForumAttachment/ValwinFactoForumAttachment.jsx
const ValwinFactoForumAttachment = ({ attachment, displaySharedBy, onClickImage, className }) => {
	const name = attachment?.name || "";
	const typeString = name.split(".").at(-1);
	const type = isEqual(typeString, "pdf") ? "PDF" : "IMAGE";
	const url = attachment.assetUrl || attachment.url;
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoForumAttachment ${className}`,
		children: [
			isEqual(type, "IMAGE") && /* @__PURE__ */ jsx(ValwinFactoAttachmentImage$1, {
				url,
				name,
				onClick: onClickImage
			}),
			isEqual(type, "PDF") && /* @__PURE__ */ jsx(ValwinFactoAttachmentPdf$1, {
				url,
				title: attachment.name
			}),
			displaySharedBy && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `Partagé par ${attachment?.owner?.shortName || "A.Inconnu"}`,
				className: "valwinFactoParagraph--greenLight valwinFactoForumAttachment__author"
			})
		]
	});
};
ValwinFactoForumAttachment.propTypes = {
	attachment: object.isRequired,
	onClickImage: func.isRequired,
	displaySharedBy: bool,
	className: string
};
// src/legacy/ValwinFactoForumMessage/ValwinFactoForumMessage.jsx
const ValwinFactoForumMessage = ({ message, onClickImage, onClickShow, profile, onClickDeleteMessage, onClickPutMessage, className }) => {
	const isAuthor = isEqual(message?.author?.identity || "", profile?.identity || "");
	const getDateFormatted = (date) => {
		if (isString(date)) return date.replace(" ", " à ");
		return date;
	};
	const date = isEmpty(message?.updated || "") ? `Créé le ${getDateFormatted(message?.created || "")}` : `Modifié le ${getDateFormatted(message?.updated || "")}`;
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoForumMessage ${className}`,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoForumMessage__container",
				children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: `${(message?.author?.shortName || "").toLowerCase()} - ${message?.author?.info?.pharmacyName ? message?.author?.info?.pharmacyName?.toLowerCase() : `Votre groupement`}`,
					className: "valwinFactoParagraph--green valwinFactoForumMessage__author"
				}), /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoForumMessage__icons",
					children: [
						isAuthor && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "TRASH",
							className: "valwinFactoIcon--grey valwinFactoForumMessage__delete",
							onClick: () => onClickDeleteMessage(message)
						}),
						onClickShow && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "SHOW",
							className: "valwinFactoIcon--green valwinFactoForumMessage__show",
							onClick: () => onClickShow(message)
						}),
						isAuthor && onClickPutMessage && isEqual(message.format, "WYSIWYG") && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "EDIT",
							className: "valwinFactoIcon--green valwinFactoForumMessage__put",
							onClick: () => onClickPutMessage(message)
						})
					]
				})]
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: date,
				className: "valwinFactoParagraph--black valwinFactoParagraph--miniBold valwinFactoForumMessage__date"
			}),
			/* @__PURE__ */ jsx("div", {
				dangerouslySetInnerHTML: { __html: message.body },
				className: "valwinFactoForumMessage__body"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoForumMessage__attachments",
				children: (message?.attachments || []).map((attachment, index) => {
					return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ValwinFactoForumAttachment, {
						attachment,
						onClickImage,
						className: "valwinFactoForumMessage__attachment"
					}) }, index);
				})
			})
		]
	});
};
ValwinFactoForumMessage.propTypes = {
	message: object.isRequired,
	onClickImage: func.isRequired,
	profile: object.isRequired,
	onClickDeleteMessage: func.isRequired,
	className: string,
	onClickShow: func,
	onClickPutMessage: func
};
// src/legacy/ValwinFactoForumThread/ValwinFactoForumThread.jsx
const ValwinFactoForumThread = ({ thread, index, isSelected, onClick, search, category, profile, onClickDeleteThread, onClickPin, tooltipPinned, className }) => {
	const [loadingPin, setLoadingPin] = useState(null);
	const isUrgent = isEqual(thread?.level || "", "urgent");
	const unreadMessages = thread?.unread || 0;
	const isAuthor = isEqual(thread?.author?.identity || "", profile?.identity || "");
	const isPinned = isEqual(thread?.pinned || null, true);
	const getDateFormatted = (date) => {
		if (isString(date)) return date.replace(" ", " à ");
		return date;
	};
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoForumThread ${className}`, { "valwinFactoForumThread--selected": isSelected }),
		onClick: () => onClick(thread, index),
		children: [/* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: /* @__PURE__ */ jsx(Highlighter, {
					highlightClassName: "valwinFactoParagraph__highlight",
					searchWords: isString(search) ? search.split(" ") : [],
					autoEscape: true,
					textToHighlight: isEmpty(thread?.title) ? "Sans sujet" : thread?.title
				}),
				className: classnames("valwinFactoForumThread__title", {
					"valwinFactoParagraph--green": !isUrgent,
					"valwinFactoParagraph--red": isUrgent
				})
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: /* @__PURE__ */ jsx(Highlighter, {
				highlightClassName: "valwinFactoParagraph__highlight",
				searchWords: isString(search) ? search.split(" ") : [],
				autoEscape: true,
				textToHighlight: thread?.author?.shortName || ""
			}) }),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `Créé le ${getDateFormatted(thread?.created || "")}`,
				className: "valwinFactoParagraph--black valwinFactoParagraph--miniBold"
			}),
			thread?.lastMessage?.created && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `Dernière activité le ${getDateFormatted(thread?.lastMessage?.created || "")}`,
				className: "valwinFactoParagraph--black valwinFactoParagraph--miniBold"
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: category?.title || "Catégorie inconnue",
				className: "valwinFactoParagraph--greenLight valwinFactoParagraph--miniBold"
			}),
			thread?.readOnly && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: "Lecture seule",
				className: "valwinFactoParagraph--red valwinFactoParagraph--miniBold"
			})
		] }), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoForumThread__icons",
			children: [
				unreadMessages > 0 && /* @__PURE__ */ jsx(ValwinFactoBullet, {
					label: unreadMessages,
					className: "valwinFactoBullet--green valwinFactoForumThread__bullet"
				}),
				!isEmpty(category) && /* @__PURE__ */ jsx(Fragment$1, { children: loadingPin ? /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
					size: 15,
					className: "valwinFactoLoading--greenlight valwinFactoForumThread__loading"
				}) : /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: isPinned ? "PIN_FILLED" : "PIN",
					onClick: () => onClickPin(thread, index, setLoadingPin),
					tooltip: tooltipPinned,
					className: classnames("valwinFactoForumThread__pin", {
						"valwinFactoIcon--green": isPinned,
						"valwinFactoIcon--grey": !isPinned
					})
				}) }),
				isAuthor && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "TRASH",
					className: "valwinFactoIcon--grey valwinFactoForumThread__delete",
					onClick: () => onClickDeleteThread(thread)
				})
			]
		})]
	});
};
ValwinFactoForumThread.propTypes = {
	thread: object.isRequired,
	onClick: func.isRequired,
	search: string.isRequired,
	index: number.isRequired,
	profile: object.isRequired,
	onClickPin: func.isRequired,
	onClickDeleteThread: func.isRequired,
	isSelected: bool.isRequired,
	className: string,
	category: object,
	tooltipPinned: object
};
// src/legacy/ValwinFactoPaginator/ValwinFactoPaginatorConst.js
const VALWIN_FACTO_PAGINATOR_CONST = [
	{
		value: 10,
		label: "10"
	},
	{
		value: 20,
		label: "20"
	},
	{
		value: 50,
		label: "50"
	}
];
// src/legacy/ValwinFactoPaginator/ValwinFactoPaginator.jsx
const ValwinFactoPaginator$1 = ({ className, pageSize, setPageSize, page, setPage, pageMax, loading, disabled }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoPaginator ${className}`,
		children: [loading && /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
			size: 50,
			className: "valwinFactoLoading--green"
		}), !loading && /* @__PURE__ */ jsxs(Flex, {
			flexDirection: "column",
			alignItems: "center",
			gap: "2",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoPaginator__row",
				children: [
					/* @__PURE__ */ jsx(IconButton, {
						size: "xs",
						variant: "ghost",
						colorPalette: "gray",
						"aria-label": "Première page",
						disabled: page === 1 || disabled,
						onClick: () => setPage(1),
						children: /* @__PURE__ */ jsx(ChevronsLeftIcon, { size: "sm" })
					}),
					/* @__PURE__ */ jsx(IconButton, {
						size: "xs",
						variant: "ghost",
						colorPalette: "gray",
						"aria-label": "Page précédente",
						disabled: page === 1 || disabled,
						onClick: () => setPage(page - 1),
						children: /* @__PURE__ */ jsx(ChevronLeftIcon, { size: "sm" })
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "valwinFactoPaginator__page",
						children: [
							page,
							" / ",
							pageMax
						]
					}),
					/* @__PURE__ */ jsx(IconButton, {
						size: "xs",
						variant: "ghost",
						colorPalette: "gray",
						"aria-label": "Page suivante",
						disabled: page === pageMax || disabled || pageMax === 0,
						onClick: () => setPage(page + 1),
						children: /* @__PURE__ */ jsx(ChevronRightIcon, { size: "sm" })
					}),
					/* @__PURE__ */ jsx(IconButton, {
						size: "xs",
						variant: "ghost",
						colorPalette: "gray",
						"aria-label": "Dernière page",
						disabled: page === pageMax || disabled || pageMax === 0,
						onClick: () => setPage(pageMax),
						children: /* @__PURE__ */ jsx(ChevronsRightIcon, { size: "sm" })
					})
				]
			}), setPageSize && /* @__PURE__ */ jsxs("div", {
				className: "valwinFactoPaginator__row",
				children: [/* @__PURE__ */ jsx("select", {
					className: "valwinFactoPaginator__select",
					value: pageSize,
					onChange: (event) => {
						setPageSize(Number.parseInt(event.target.value));
					},
					children: VALWIN_FACTO_PAGINATOR_CONST.map((option, index) => /* @__PURE__ */ jsx("option", {
						value: option.value,
						children: option.label
					}, index))
				}), /* @__PURE__ */ jsx("div", {
					className: "valwinFactoPaginator__label",
					children: "Résultats par page"
				})]
			})]
		})]
	});
};
ValwinFactoPaginator$1.propTypes = {
	page: number.isRequired,
	setPage: func.isRequired,
	pageMax: number.isRequired,
	setPageSize: func,
	pageSize: number,
	className: string,
	loading: bool,
	disabled: bool
};
// src/legacy/ValwinFactoForum/ValwinFactoForumConst.js
const VALWIN_FACTO_FORUM_RESPONSIVE_CONST = {
	THREADS: "threads",
	MESSAGES: "messages"
};
const VALWIN_FACTO_FORUM_CONTENT_CONST = {
	ATTACHMENTS: "attachments",
	MESSAGES: "messages"
};
const VALWIN_FACTO_FORUM_SORTING_CONST = {
	ALPHABETICAL: "alphabetical",
	DATE: "dateUpdateDesc"
};
// src/legacy/ValwinFactoForum/ValwinFactoForumTooltips.js
const VALWIN_FACTO_FORUM_TOOLTIPS = {
	ATTACHMENTS: {
		placement: "bottomRight",
		width: "225px",
		content: [{
			type: "PARAGRAPH",
			text: "Retournez sur le fil de discussion."
		}]
	},
	MESSAGES: {
		placement: "bottomRight",
		content: [{
			type: "PARAGRAPH",
			text: "Retrouvez tous les fichiers partagés de cette discussion."
		}]
	},
	DATE: {
		placement: "bottomRight",
		width: "225px",
		content: [{
			type: "PARAGRAPH",
			text: "Trier les discussions par date."
		}]
	},
	ALPHABETICAL: {
		placement: "bottomRight",
		width: "225px",
		content: [{
			type: "PARAGRAPH",
			text: "Trier les discussions par ordre alphabétique."
		}]
	}
};
// src/legacy/ValwinFactoForum/ValwinFactoForum.jsx
const ValwinFactoForum$1 = ({ className, profile, search, categories, threads, threadSelected, pageThreads, setPageThreads, pageMaxThreads, messages, attachments, loadingMessages, pageMessages, setPageMessages, pageMaxMessages, onClickImage, onClickThread, onClickPin, onClickReply, onClickDeleteThread, onClickDeleteMessage, onClickPutMessage, onClickAddThread, tooltipPinned, displayAddThreadButton, displayAddMessageButton, onClickShow, sorting, setSorting }) => {
	const [responsive, setResponsive] = useState(VALWIN_FACTO_FORUM_RESPONSIVE_CONST.THREADS);
	const [content, setContent] = useState(VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES);
	const [prevThreads, setPrevThreads] = useState(threads);
	const [prevThreadSelected, setPrevThreadSelected] = useState(threadSelected);
	if (threads !== prevThreads || threadSelected !== prevThreadSelected) {
		setPrevThreads(threads);
		setPrevThreadSelected(threadSelected);
		setContent(VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES);
	}
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoForum ${className}`),
		children: [/* @__PURE__ */ jsxs("div", {
			className: classnames("valwinFactoForum__threads", {
				"valwinFactoForum__threads--hide": isEqual(responsive, VALWIN_FACTO_FORUM_RESPONSIVE_CONST.MESSAGES),
				"valwinFactoForum__threads--empty": isEmpty(threads)
			}),
			children: [
				/* @__PURE__ */ jsx(ValwinFactoSubTitle$1, {
					label: "Discussions",
					className: "valwinFactoForum__title"
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoForum__buttons",
					children: [displayAddThreadButton && /* @__PURE__ */ jsx(ValwinFactoButton$1, {
						type: "button",
						label: "Créer une discussion",
						className: "valwinFactoButton--greenStrong valwinFactoForum__button",
						onClick: onClickAddThread
					}), /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						className: "valwinFactoButtonIcon--green valwinFactoForum__button",
						type: "button",
						icon: isEqual(sorting, VALWIN_FACTO_FORUM_SORTING_CONST.DATE) ? "SORT_DOWN_ALPHABETICAL" : "SORT_DOWN_NUMERIC",
						tooltip: isEqual(sorting, VALWIN_FACTO_FORUM_SORTING_CONST.DATE) ? VALWIN_FACTO_FORUM_TOOLTIPS.ALPHABETICAL : VALWIN_FACTO_FORUM_TOOLTIPS.DATE,
						onClick: isEqual(sorting, VALWIN_FACTO_FORUM_SORTING_CONST.DATE) ? () => {
							setSorting(VALWIN_FACTO_FORUM_SORTING_CONST.ALPHABETICAL);
							setPageThreads(0);
						} : () => {
							setSorting(VALWIN_FACTO_FORUM_SORTING_CONST.DATE);
							setPageThreads(0);
						}
					})]
				}),
				isEmpty(threads) ? /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: "Aucune discussion à afficher." }) : /* @__PURE__ */ jsx("div", {
					className: "valwinFactoForum__list",
					children: /* @__PURE__ */ jsxs(Fragment$1, { children: [threads.map((thread, index) => {
						return /* @__PURE__ */ jsx(ValwinFactoForumThread, {
							thread,
							index,
							isSelected: !isEmpty(threadSelected) && threadSelected.id === thread.id,
							onClick: (thread, index) => {
								onClickThread(thread, index);
								setResponsive(VALWIN_FACTO_FORUM_RESPONSIVE_CONST.MESSAGES);
							},
							search,
							category: categories.find((category) => isEqual(category?.id, thread?.catId)),
							profile,
							onClickDeleteThread,
							onClickPin,
							tooltipPinned,
							className: "valwinFactoForum__thread"
						}, index);
					}), pageMaxThreads > 1 && /* @__PURE__ */ jsx(ValwinFactoPaginator$1, {
						page: pageThreads,
						setPage: setPageThreads,
						pageMax: pageMaxThreads
					})] })
				})
			]
		}), !isEmpty(threads) && /* @__PURE__ */ jsxs("div", {
			className: classnames("valwinFactoForum__messages", { "valwinFactoForum__messages--hide": isEqual(responsive, VALWIN_FACTO_FORUM_RESPONSIVE_CONST.THREADS) }),
			children: [loadingMessages && /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
				size: 20,
				className: "valwinFactoLoading--green"
			}), !loadingMessages && /* @__PURE__ */ jsxs(Fragment$1, { children: [
				/* @__PURE__ */ jsx(ValwinFactoSubTitle$1, {
					label: "Messages",
					className: "valwinFactoForum__title"
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoForum__buttons",
					children: [displayAddMessageButton && /* @__PURE__ */ jsx(ValwinFactoButton$1, {
						type: "button",
						label: "Répondre",
						className: "valwinFactoButton--greenStrong valwinFactoForum__button",
						onClick: () => onClickReply(threadSelected)
					}), !isEmpty(attachments) && /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						className: "valwinFactoButtonIcon--green valwinFactoForum__button",
						type: "button",
						icon: isEqual(content, VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES) ? "FILE" : "MAIL_FILLED",
						tooltip: isEqual(content, VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES) ? VALWIN_FACTO_FORUM_TOOLTIPS.MESSAGES : VALWIN_FACTO_FORUM_TOOLTIPS.ATTACHMENTS,
						onClick: isEqual(content, VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES) ? () => setContent(VALWIN_FACTO_FORUM_CONTENT_CONST.ATTACHMENTS) : () => setContent(VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES)
					})]
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoForum__list",
					children: [isEqual(content, VALWIN_FACTO_FORUM_CONTENT_CONST.MESSAGES) && /* @__PURE__ */ jsx(Fragment$1, { children: isEmpty(messages) ? /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: "Aucun message dans cette discussion." }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [messages.map((message, index) => {
						return /* @__PURE__ */ jsx(ValwinFactoForumMessage, {
							onClickImage,
							message,
							profile,
							onClickDeleteMessage,
							onClickPutMessage,
							className: "valwinFactoForum__message",
							onClickShow
						}, index);
					}), pageMaxMessages > 1 && /* @__PURE__ */ jsx(ValwinFactoPaginator$1, {
						page: pageMessages,
						setPage: setPageMessages,
						pageMax: pageMaxMessages
					})] }) }), isEqual(content, VALWIN_FACTO_FORUM_CONTENT_CONST.ATTACHMENTS) && /* @__PURE__ */ jsx(Fragment$1, { children: isEmpty(attachments) ? /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: "Aucun fichier partagé dans cette discussion." }) : /* @__PURE__ */ jsx("div", {
						className: "valwinFactoForum__attachments",
						children: attachments.map((attachment, index) => {
							return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ValwinFactoForumAttachment, {
								attachment,
								onClickImage,
								displaySharedBy: true,
								className: "valwinFactoForum__attachment"
							}) }, index);
						})
					}) })]
				}),
				/* @__PURE__ */ jsx(ValwinFactoButton$1, {
					className: "valwinFactoButton--grey valwinFactoForum__back",
					type: "button",
					label: "Retour",
					onClick: () => setResponsive(VALWIN_FACTO_FORUM_RESPONSIVE_CONST.THREADS)
				})
			] })]
		})]
	});
};
ValwinFactoForum$1.propTypes = {
	className: string.isRequired,
	profile: object.isRequired,
	search: string.isRequired,
	categories: arrayOf(object).isRequired,
	threads: arrayOf(object).isRequired,
	threadSelected: object,
	pageThreads: number.isRequired,
	setPageThreads: func.isRequired,
	pageMaxThreads: number.isRequired,
	messages: arrayOf(object).isRequired,
	attachments: arrayOf(object).isRequired,
	loadingMessages: bool.isRequired,
	pageMessages: number.isRequired,
	setPageMessages: func.isRequired,
	pageMaxMessages: number.isRequired,
	onClickImage: func.isRequired,
	onClickThread: func.isRequired,
	onClickPin: func.isRequired,
	onClickReply: func.isRequired,
	onClickDeleteThread: func.isRequired,
	onClickDeleteMessage: func.isRequired,
	onClickAddThread: func.isRequired,
	displayAddThreadButton: bool.isRequired,
	displayAddMessageButton: bool.isRequired,
	sorting: string.isRequired,
	setSorting: func.isRequired,
	tooltipPinned: object,
	onClickPutMessage: func,
	onClickShow: func
};
// src/legacy/ValwinFactoImageSelect/ValwinFactoImageSelect.jsx
const ValwinFactoImageSelect$1 = ({ className, images, value, setValue, disabled }) => {
	return /* @__PURE__ */ jsx("div", {
		className: `valwinFactoImageSelect ${className}`,
		children: images.map((image, index) => /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoImageSelect__item",
			children: [/* @__PURE__ */ jsxs("div", {
				className: classnames("valwinFactoImageSelect__container", { "valwinFactoImageSelect__container--disabled": disabled }),
				onClick: () => !disabled && setValue(image),
				children: [/* @__PURE__ */ jsx("div", { className: classnames("valwinFactoImageSelect__button", {
					"valwinFactoImageSelect__button--selected": isEqual(value, image),
					"valwinFactoImageSelect__button--disabled": disabled
				}) }, index), /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoImageSelect__imageContainer", {
						"valwinFactoImageSelect__imageContainer--selected": isEqual(value, image),
						"valwinFactoImageSelect__imageContainer--disabled": disabled
					}),
					children: /* @__PURE__ */ jsx("img", {
						src: image?.url || "",
						alt: "",
						className: "valwinFactoImageSelect__image"
					})
				})]
			}), /* @__PURE__ */ jsx("div", {
				className: "valwinFactoImageSelect__infos",
				children: /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: image?.title || "",
					className: classnames("valwinFactoImageSelect__title valwinFactoParagraph--greenLight", { "valwinFactoParagraph--grey": disabled })
				})
			})]
		}, index))
	});
};
ValwinFactoImageSelect$1.propTypes = {
	images: arrayOf(object).isRequired,
	value: object.isRequired,
	setValue: func.isRequired,
	className: string,
	disabled: bool
};
// src/legacy/ValwinFactoJob/ValwinFactoJobConst.js
const JOBS_TYPES = [
	{
		label: "Pharmacien(ne) adjoint(e)",
		value: "PHARMACIST_ASSISTANT"
	},
	{
		label: "Pharmacien(ne) remplaçant(e)",
		value: "PHARMACIST_SUBSTITUTE"
	},
	{
		label: "Pharmacien(ne) stagiaire",
		value: "PHARMACIST_INTERNSHIP"
	},
	{
		label: "Préparateur(trice) en pharmacie",
		value: "PHARMACIST_TECHNICIAN"
	},
	{
		label: "Esthéticien(ne)",
		value: "BEAUTICIAN"
	},
	{
		label: "Conseiller(ère) beauté",
		value: "BEAUTY_ADVISOR"
	},
	{
		label: "Nutritionniste",
		value: "NUTRITIONIST"
	},
	{
		label: "Chef(fe) de rayon",
		value: "DEPARTMENT_MANAGER"
	},
	{
		label: "Logisticien(ne)",
		value: "LOGISTICIAN"
	},
	{
		label: "Agent(e) de sécurité",
		value: "SECURITY_AGENT"
	},
	{
		label: "Agent(e) d’entretien",
		value: "SERVICE_AGENT"
	}
];
const CONTRACT_TYPES = [
	{
		label: "CDI",
		value: "PERMANENT"
	},
	{
		label: "CDD",
		value: "TEMPORARY"
	},
	{
		label: "Intérim",
		value: "INTERIM"
	},
	{
		label: "Alternance",
		value: "STUDENT"
	},
	{
		label: "Stage",
		value: "INTERNSHIP"
	}
];
// src/legacy/ValwinFactoJob/ValwinFactoJobUtils.js
const getJobLabel = (job) => {
	const jobType = JOBS_TYPES.find((TYPE) => isEqual$1(TYPE.value, get(job, "title", "")));
	return isUndefined(jobType) ? get(job, "title", "") : get(jobType, "label", "");
};
const getContractLabels = (job) => {
	return CONTRACT_TYPES.filter((TYPE) => includes(get(job, "contractTypes", ""), TYPE.value)).map((elt) => elt.label);
};
const getWorkingTime = (job) => {
	const workingTime = get(job, "workingTime", "");
	if (isString$1(workingTime)) {
		const hours = workingTime.split(":")[0];
		const minutes = workingTime.split(":")[1];
		return minutes > 0 ? `${hours} heures ${minutes} minutes` : `${hours} heures`;
	}
	return "";
};
const getUpdatedDateJob = (job, fromSbo = false) => {
	const createdAt = format(parseISO(job.createdAt), "dd/MM/yyyy");
	const updatedAt = get(job, "updatedAt", "");
	const groupUpdatedAt = get(job, "groupUpdatedAt", "");
	if (updatedAt && groupUpdatedAt) {
		const mostRecentDate = updatedAt > groupUpdatedAt ? updatedAt : groupUpdatedAt;
		return `Créé le ${createdAt}. Mise à jour ${isEqual$1(mostRecentDate, groupUpdatedAt) && !fromSbo ? " par mon groupement" : ""} le
      ${format(parseISO(mostRecentDate), "dd/MM/yyyy à HH:mm")}
      `;
	}
	if (updatedAt) return `Créé le ${createdAt}. Mise à jour le ${format(parseISO(updatedAt), "dd/MM/yyyy à HH:mm")}`;
	if (groupUpdatedAt) return `Créé le ${createdAt}. Mise à jour${fromSbo ? "" : " par mon groupement"} le ${format(parseISO(groupUpdatedAt), "dd/MM/yyyy à HH:mm")}`;
	return `Créé le ${createdAt}.`;
};
// src/legacy/ValwinFactoJob/ValwinFactoJob.jsx
const ValwinFactoJob$1 = ({ job, isSbo, onClickEdit, onClickDuplicate, onClickDisplay, onClickArchive, onClickDelete, onClickPrint, displayLoadingJobs, className, fromSbo = false }) => {
	const isUnread = isSbo && isEqual(job?.groupRead || "", false) && isEqual(job?.origin || "", "PHARMACY");
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoJob ${className}`, { "valwinFactoJob--unRead": isUnread }),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoJob__left",
			children: [
				isUnread && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: "NEW",
					className: "valwinFactoJob__new"
				}),
				!isSbo && isEqual(job?.origin || "", "GROUP") && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: "Créée par votre groupement",
					className: "valwinFactoParagraph--green valwinFactoJob__from"
				}),
				isSbo && isEqual(job?.origin || "", "PHARMACY") && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: "Créée par la pharmacie",
					className: "valwinFactoParagraph--green valwinFactoJob__from"
				}),
				isSbo && /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoJob__recruiterContainer",
					children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: `${job?.recruiterName || ""}, `,
						className: "valwinFactoParagraph--lightBold"
					}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: `${job?.city || ""} `,
						className: "valwinFactoJob__city valwinFactoParagraph--lightBold"
					})]
				}),
				/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: getJobLabel(job),
					className: "valwinFactoJob__title"
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoJob__tags",
					children: [
						isSbo && /* @__PURE__ */ jsxs("div", {
							className: "valwinFactoJob__tag",
							children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
								icon: "PIN_MAP",
								className: "valwinFactoJob__pin"
							}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: job?.city || "" })]
						}),
						getContractLabels(job).map((label, ind) => /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
							label,
							className: "valwinFactoJob__tag"
						}, ind)),
						/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
							label: getWorkingTime(job),
							className: "valwinFactoJob__tag"
						})
					]
				})
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoJob__right",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoJob__buttons",
				children: [
					/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						type: "button",
						icon: "EDIT",
						className: "valwinFactoButtonIcon--green",
						onClick: onClickEdit
					}),
					!job?.archived && /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						type: "button",
						loading: displayLoadingJobs,
						icon: isEqual(job?.hidden || "", true) ? "HIDE" : "SHOW",
						className: isEqual(job?.hidden || "", true) ? "valwinFactoButtonIcon--grey" : "valwinFactoButtonIcon--green",
						onClick: onClickDisplay
					}),
					/* @__PURE__ */ jsx("div", {
						className: "valwinFactoJob__container",
						children: /* @__PURE__ */ jsxs(Menu, {
							loopFocus: true,
							positioning: { placement: "bottom-start" },
							children: [/* @__PURE__ */ jsx(Menu.Trigger, { children: /* @__PURE__ */ jsx(VerticalEllipsisIcon, { size: "md" }) }), /* @__PURE__ */ jsxs(Menu.Content, { children: [
								/* @__PURE__ */ jsx(Menu.Item, {
									value: "duplicate",
									onClick: onClickDuplicate,
									children: "Dupliquer"
								}),
								/* @__PURE__ */ jsx(Menu.Item, {
									value: "print",
									onClick: onClickPrint,
									children: "Imprimer"
								}),
								!job.archived && /* @__PURE__ */ jsx(Menu.Item, {
									value: "archive",
									onClick: onClickArchive,
									children: "Archiver"
								}),
								/* @__PURE__ */ jsx(Menu.DangerItem, {
									value: "delete",
									onClick: onClickDelete,
									children: "Supprimer"
								})
							] })]
						})
					})
				]
			}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: getUpdatedDateJob(job, fromSbo),
				className: "valwinFactoJob__update valwinFactoParagraph--mini"
			})]
		})]
	});
};
ValwinFactoJob$1.propTypes = {
	job: object.isRequired,
	onClickEdit: func.isRequired,
	onClickDuplicate: func.isRequired,
	onClickDisplay: func.isRequired,
	onClickArchive: func.isRequired,
	onClickDelete: func.isRequired,
	onClickPrint: func.isRequired,
	isSbo: bool,
	displayLoadingJobs: bool,
	className: string,
	fromSbo: bool
};
// src/legacy/ValwinFactoJobToPrint/ValwinFactoJobToPrint.jsx
var ValwinFactoJobToPrint$1 = class extends PureComponent {
	render() {
		const { job, isPharmabest } = this.props;
		return /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoJobToPrint",
			children: [
				/* @__PURE__ */ jsx("img", {
					alt: "",
					className: "valwinFactoJobToPrint__image",
					src: "https://valwin-pharma-assets.s3.eu-west-1.amazonaws.com/valwin-pharma-assets/images/resources/recrutement/RECRUITMENT.jpg"
				}),
				/* @__PURE__ */ jsxs("div", {
					className: "valwinFactoJobToPrint__headerContainer",
					children: [/* @__PURE__ */ jsx("div", {
						className: "valwinFactoJobToPrint__title",
						children: /* @__PURE__ */ jsx("strong", { children: getJobLabel(job) })
					}), /* @__PURE__ */ jsxs("div", {
						className: "valwinFactoJobToPrint__tags",
						children: [
							/* @__PURE__ */ jsx("div", {
								className: classnames("valwinFactoJobToPrint__tag", { "valwinFactoJobToPrint__tag--pharmabest": isPharmabest }),
								children: job?.city || ""
							}),
							getContractLabels(job).map((label, ind) => /* @__PURE__ */ jsx("div", {
								className: classnames("valwinFactoJobToPrint__tag", { "valwinFactoJobToPrint__tag--pharmabest": isPharmabest }),
								children: label
							}, ind)),
							/* @__PURE__ */ jsx("div", {
								className: classnames("valwinFactoJobToPrint__tag", { "valwinFactoJobToPrint__tag--pharmabest": isPharmabest }),
								children: getWorkingTime(job)
							})
						]
					})]
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__subTitle",
					children: /* @__PURE__ */ jsx("strong", { children: `${job?.recruiterName || ""}.toUpperCase()}, ${job?.city || ""}` })
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__text",
					dangerouslySetInnerHTML: { __html: job?.presentation || "" }
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__subTitle",
					children: /* @__PURE__ */ jsx("strong", { children: "Poste " })
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__text",
					dangerouslySetInnerHTML: { __html: job?.description || "" }
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__subTitle",
					children: /* @__PURE__ */ jsx("strong", { children: "Contact " })
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__text",
					children: job?.tel || ""
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoJobToPrint__text",
					children: job?.email || ""
				})
			]
		});
	}
};
ValwinFactoJobToPrint$1.propTypes = {
	job: object.isRequired,
	isPharmabest: bool
};
// src/legacy/ValwinFactoMenuSelectButton/ValwinFactoMenuSelectButton.jsx
const ValwinFactoMenuSelectButton$1 = ({ className, label, icon, onClick }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoMenuSelectButton ${className}`,
		onClick,
		children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
			icon,
			className: "valwinFactoMenuSelectButton__icon"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label,
			className: "valwinFactoMenuSelectButton__label"
		})]
	});
};
ValwinFactoMenuSelectButton$1.propTypes = {
	label: string.isRequired,
	icon: string.isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoModal/ValwinFactoModal.jsx
const ValwinFactoModal$1 = ({ className, children, close, title, tooltip, size, id }) => {
	return /* @__PURE__ */ jsxs("div", {
		id,
		className: `valwinFactoModal ${className}`,
		children: [/* @__PURE__ */ jsx("div", {
			className: "valwinFactoModal__background",
			onClick: close
		}), /* @__PURE__ */ jsxs("div", {
			className: classnames("valwinFactoModal__content", { "valwinFactoModal__content--large": isEqual(size, "LARGE") }),
			id: "valwinFactoModal__content",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoModal__header",
				children: [/* @__PURE__ */ jsx(ValwinFactoSubTitle$1, {
					label: title,
					tooltip,
					className: "valwinFactoModal__subtitle"
				}), /* @__PURE__ */ jsx("div", {
					className: "valwinFactoModal__icon",
					onClick: close,
					children: /* @__PURE__ */ jsx(AiOutlineClose, {})
				})]
			}), children]
		})]
	});
};
ValwinFactoModal$1.propTypes = {
	children: node.isRequired,
	title: string.isRequired,
	close: func.isRequired,
	size: string,
	tooltip: object,
	className: string,
	id: string
};
// src/legacy/ValwinFactoNew/ValwinFactoNew.jsx
const ValwinFactoNew$1 = ({ new_, className }) => {
	const date = format(new_?.date || /* @__PURE__ */ new Date(), "dd/MM/yyyy");
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoNew ${className}`, {
			"valwinFactoNew--unRead": !new_?.isRead || false,
			"valwinFactoNew--unRead--isGroup": (!new_?.isRead || false) && (new_?.isGroup || false)
		}),
		onClick: new_?.onClick || null,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoNew__header",
				children: [
					!new_?.isRead && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "NEW",
						className: classnames("valwinFactoNew__new", { "valwinFactoNew__new--isGroup": new_?.isGroup || false })
					}),
					/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: new_?.icon || "",
						className: classnames("valwinFactoNew__icon", { "valwinFactoNew__icon--isGroup": new_?.isGroup || false })
					}),
					/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: new_?.title || "",
						className: "valwinFactoParagraph--lightBold valwinFactoNew__title"
					})
				]
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: new_?.description || "",
				className: "valwinFactoNew__description"
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				className: "valwinFactoParagraph--mini",
				label: date
			})
		]
	});
};
ValwinFactoNew$1.propTypes = {
	new_: object.isRequired,
	className: string
};
// src/legacy/ValwinFactoNotices/ValwinFactoNotices.jsx
const ValwinFactoNotices$1 = ({ notices, onClick, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoNotices ${className}`,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoNotices__notice valwinFactoParagraph--lightBold",
			label: `${notices.label} :`
		}), notices.notices.map((notice, index) => /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoNotices__notice valwinFactoParagraph--green",
			label: notice.title,
			isUnderline: true,
			onClick: () => onClick(notice.title, notice.embed)
		}, index))]
	});
};
ValwinFactoNotices$1.propTypes = {
	notices: object.isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoOptionColor/ValwinFactoOptionColor.jsx
const ValwinFactoOptionColor$1 = ({ option }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionColor",
		children: [/* @__PURE__ */ jsx("div", {
			className: "valwinFactoOptionColor__square",
			style: { background: option.hex1 }
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoOptionColor__label",
			label: option.label
		})]
	});
};
ValwinFactoOptionColor$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionLining/ValwinFactoOptionLining.jsx
const ValwinFactoOptionLining$1 = ({ option }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionLining",
		children: [/* @__PURE__ */ jsx("img", {
			src: option?.image || "",
			alt: "",
			className: "valwinFactoOptionLining__image"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoOptionLining__name valwinFactoParagraph--miniBold",
			label: /* @__PURE__ */ jsx(Highlighter, {
				highlightClassName: "valwinFactoParagraph__highlight",
				searchWords: (option?.search || "").split(" "),
				autoEscape: true,
				textToHighlight: option?.name || ""
			})
		})]
	});
};
ValwinFactoOptionLining$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionMeetingPatient/ValwinFactoOptionMeetingPatient.jsx
const ValwinFactoOptionMeetingPatient$1 = ({ option }) => {
	const start = option?.start ? new Date(option.start) : null;
	const meetingTypeFormatted = isString(option?.meetingType) && option.meetingType.length < 15 ? option.meetingType : `${option.meetingType.slice(0, 15)}...`;
	const dateFormatted = isDate(start) ? format(start, "dd/MM/yyyy à HH:mm") : null;
	const patient = `${option?.firstName || ""} ${option?.lastName || ""}`;
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionMeetingPatient",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoOptionMeetingPatient__line",
			children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: /* @__PURE__ */ jsx(Highlighter, {
					highlightClassName: "valwinFactoParagraph__highlight",
					searchWords: (option?.search || "").split(" "),
					autoEscape: true,
					textToHighlight: patient
				}),
				className: "valwinFactoParagraph--miniBold valwinFactoParagraph--greenLight valwinFactoOptionMeetingPatient__paragraph"
			}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: dateFormatted,
				className: "valwinFactoParagraph--miniBold valwinFactoParagraph--green valwinFactoOptionMeetingPatient__paragraph"
			})]
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoOptionMeetingPatient__line",
			children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: meetingTypeFormatted,
				className: "valwinFactoParagraph--miniBold valwinFactoOptionMeetingPatient__paragraph"
			}), option?.email && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: /* @__PURE__ */ jsx(Highlighter, {
					highlightClassName: "valwinFactoParagraph__highlight",
					searchWords: (option?.search || "").split(" "),
					autoEscape: true,
					textToHighlight: option?.email
				}),
				className: "valwinFactoParagraph--miniBold valwinFactoOptionMeetingPatient__paragraph"
			})]
		})]
	});
};
ValwinFactoOptionMeetingPatient$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionPharmacyColors/ValwinFactoOptionPharmacyColors.jsx
const ValwinFactoOptionPharmacyColors$1 = ({ option }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionPharmacyColors",
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: option?.label || "",
			className: "valwinFactoOptionPharmacyColors__name"
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoOptionPharmacyColors__colors",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoOptionPharmacyColors__color",
					style: { background: option?.value.actionColor || "" }
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoOptionPharmacyColors__color",
					style: { background: option?.value.infoColor || "" }
				}),
				/* @__PURE__ */ jsx("div", {
					className: "valwinFactoOptionPharmacyColors__color",
					style: { background: option?.value.backgroundColor || "" }
				})
			]
		})]
	});
};
ValwinFactoOptionPharmacyColors$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionService/ValwinFactoOptionService.jsx
const ValwinFactoOptionService$1 = ({ option }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionService",
		children: [/* @__PURE__ */ jsx("img", {
			src: option?.image || "",
			alt: "",
			className: "valwinFactoOptionService__image"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoOptionService__name valwinFactoParagraph--miniBold",
			label: /* @__PURE__ */ jsx(Highlighter, {
				highlightClassName: "valwinFactoParagraph__highlight",
				searchWords: (option?.search || "").split(" "),
				autoEscape: true,
				textToHighlight: option?.name || ""
			})
		})]
	});
};
ValwinFactoOptionService$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionSpeciality/ValwinFactoOptionSpeciality.jsx
const ValwinFactoOptionSpeciality$1 = ({ option }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionSpeciality",
		children: [/* @__PURE__ */ jsx("img", {
			src: option?.image || "",
			alt: "",
			className: "valwinFactoOptionSpeciality__image"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoOptionSpeciality__name valwinFactoParagraph--miniBold",
			label: /* @__PURE__ */ jsx(Highlighter, {
				highlightClassName: "valwinFactoParagraph__highlight",
				searchWords: (option?.search || "").split(" "),
				autoEscape: true,
				textToHighlight: option?.name || ""
			})
		})]
	});
};
ValwinFactoOptionSpeciality$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionTag/ValwinFactoOptionTagUtils.js
const emptyFunction = () => {};
const getColor = (option) => {
	return option?.color || "";
};
const getLabel = (option) => {
	return option?.label || "";
};
const getOnEdit = (option) => {
	return option?.onEdit || emptyFunction;
};
const getOnDelete = (option) => {
	return option?.onDelete || emptyFunction;
};
// src/legacy/ValwinFactoOptionTag/ValwinFactoOptionTag.jsx
const ValwinFactoOptionTag$1 = ({ option }) => {
	const color = getColor(option);
	const label = getLabel(option);
	const onEdit = getOnEdit(option);
	const onDelete = getOnDelete(option);
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionTag",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoOptionTag__color",
				style: { background: color }
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label,
				className: "valwinFactoParagraph--green valwinFactoOptionTag__label"
			}),
			/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
				icon: "EDIT",
				onClick: (event) => {
					event.stopPropagation();
					onEdit(option);
				},
				className: "valwinFactoIcon--grey valwinFactoOptionTag__edit"
			}),
			/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
				icon: "TRASH",
				onClick: (event) => {
					event.stopPropagation();
					onDelete(option);
				},
				className: "valwinFactoIcon--grey valwinFactoOptionTag__delete"
			})
		]
	});
};
ValwinFactoOptionTag$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoOptionVideo/ValwinFactoOptionVideo.jsx
const ValwinFactoOptionVideo$1 = ({ option }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoOptionVideo",
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoOptionVideo__title valwinFactoParagraph--miniBold",
			label: /* @__PURE__ */ jsx(Highlighter, {
				highlightClassName: "valwinFactoParagraph__highlight",
				searchWords: (option?.search || "").split(" "),
				autoEscape: true,
				textToHighlight: option?.title || ""
			})
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			className: "valwinFactoOptionVideo__category valwinFactoParagraph--miniBold valwinFactoParagraph--greenLight",
			label: option?.category?.title || ""
		})]
	});
};
ValwinFactoOptionVideo$1.propTypes = { option: object.isRequired };
// src/legacy/ValwinFactoPanelAlt/ValwinFactoPanelAlt.jsx
const ValwinFactoPanelAlt$1 = ({ className, children, bulletLabel, icon, title, onClickDelete, displayContentOnLoad, disabled, onClick, isOpenable, tooltip, isGrey }) => {
	const [displayContent, setDisplayContent] = useState(displayContentOnLoad);
	const [prevDisplayContentOnLoad, setPrevDisplayContentOnLoad] = useState(displayContentOnLoad);
	const [prevDisabled, setPrevDisabled] = useState(disabled);
	if (displayContentOnLoad !== prevDisplayContentOnLoad || disabled !== prevDisabled) {
		setPrevDisplayContentOnLoad(displayContentOnLoad);
		setPrevDisabled(disabled);
		setDisplayContent(displayContentOnLoad);
	}
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoPanelAlt ${className}`, {
			"valwinFactoPanelAlt--disabled": disabled,
			"valwinFactoPanelAlt--grey": isGrey
		}),
		onClick: onClick ? () => onClick() : null,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoPanelAlt__header",
			children: [
				isNumber(bulletLabel) && /* @__PURE__ */ jsx(ValwinFactoBullet, {
					label: bulletLabel,
					className: "valwinFactoBullet--greenLight valwinFactoPanelAlt__bullet"
				}),
				icon && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon,
					className: "valwinFactoPanelAlt__icon valwinFactoIcon--green"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoPanelAlt__tooltip"
				}),
				title && /* @__PURE__ */ jsx("div", {
					className: "valwinFactoPanelAlt__title",
					children: title
				}),
				!disabled && /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoPanelAlt__action",
					children: [onClickDelete && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "ADD",
						className: "valwinFactoPanelAlt__delete",
						onClick: onClickDelete
					}), isOpenable && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: displayContent ? "ARROW_UP" : "ARROW_DOWN",
						className: "valwinFactoPanelAlt__display",
						onClick: () => setDisplayContent(!displayContent)
					})]
				})
			]
		}), displayContent && /* @__PURE__ */ jsx("div", {
			className: "valwinFactoPanelAlt__content",
			children
		})]
	});
};
ValwinFactoPanelAlt$1.propTypes = {
	children: node.isRequired,
	isOpenable: bool.isRequired,
	className: string,
	bulletLabel: number,
	icon: string,
	title: string,
	onClickDelete: func,
	displayContentOnLoad: bool,
	disabled: bool,
	onClick: func,
	tooltip: object,
	isGrey: bool
};
// src/legacy/ValwinFactoPatientForm/ValwinFactoPatientForm.jsx
const ValwinFactoPatientForm$1 = ({ className, form, onClick }) => {
	const date = form?.createdAt ? new Date(form.createdAt) : null;
	const dateFormatted = isDate(date) ? format(date, "P", { locale: fr }) : null;
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoPatientForm ${className}`),
		onClick,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: form?.formData?.name || "",
			className: "valwinFactoPatientForm__title valwinFactoParagraph--greenLight"
		}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: dateFormatted })]
	});
};
ValwinFactoPatientForm$1.propTypes = {
	form: object.isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoPatientMeeting/ValwinFactoPatientMeeting.jsx
const ValwinFactoPatientMeeting$1 = ({ meeting, className, onClick }) => {
	const start = meeting.start ? new Date(meeting.start) : null;
	const startFormatted = isDate(start) ? format(start, "HH:mm", { locale: fr }) : null;
	const end = meeting.end ? new Date(meeting.end) : null;
	const endFormatted = isDate(end) ? format(end, "HH:mm", { locale: fr }) : null;
	const dayFormatted = isDate(start) ? format(start, "P", { locale: fr }) : null;
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoPatientMeeting ${className}`),
		onClick,
		children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
			label: meeting.meetingConfiguration.title,
			className: "valwinFactoPatientMeeting__title valwinFactoParagraph--greenLight"
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoPatientMeeting__date",
			children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: dayFormatted,
				className: "valwinFactoPatientMeeting__paragraph"
			}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: `${startFormatted} - ${endFormatted}`,
				className: "valwinFactoPatientMeeting__paragraph"
			})]
		})]
	});
};
ValwinFactoPatientMeeting$1.propTypes = {
	meeting: object.isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoPatientOrder/ValwinFactoPatientOrder.jsx
const ValwinFactoPatientOrder$1 = ({ order, className, onClick }) => {
	const orderDate = order.date ? new Date(order.date) : null;
	const orderDateFormatted = isDate(orderDate) ? format(orderDate, "P", { locale: fr }) : "";
	const isReservation = isEqual(order?.method, "reservation");
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoPatientOrder ${className}`),
		onClick,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoPatientOrder__priceOrder",
			children: [
				/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: `${order.price / 100} €`,
					className: "valwinFactoPatientOrder__price valwinFactoParagraph--greenLight"
				}),
				/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: orderDateFormatted,
					className: "valwinFactoPatientOrder__date"
				}),
				/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: (order?.id?.idStr || "").slice(0, 8),
					className: "valwinFactoPatientOrder__orderNumber"
				})
			]
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoPatientOrder__statusOrder",
			children: [/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: order?.status?.label || "",
				className: `valwinFactoPatientOrder__element ${order?.status?.style || ""}`
			}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: isReservation ? "Paiement en pharmacie" : "Paiement en ligne",
				className: `valwinFactoPatientOrder__element ${isReservation ? "valwinFactoParagraph--yellow" : "valwinFactoParagraph--green"}`
			})]
		})]
	});
};
ValwinFactoPatientOrder$1.propTypes = {
	order: object.isRequired,
	onClick: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoPatientThreadToPrint/ValwinFactoPatientThreadToPrint.jsx
var ValwinFactoPatientThreadToPrint$1 = class extends PureComponent {
	render() {
		const { thread } = this.props;
		return /* @__PURE__ */ jsx("div", { children: (thread?.messages || []).map((message, index) => {
			const messageDate = message.date ? new Date(message.date) : /* @__PURE__ */ new Date();
			const dateFormatted = format(messageDate, "HH:mm P", { locale: fr });
			return /* @__PURE__ */ jsxs("div", { children: [
				/* @__PURE__ */ jsx("strong", {
					style: {
						fontSize: "14px",
						margin: "0px 0px 0px 20px"
					},
					children: isEqual(message.direction, "in") ? thread.patientFullname : "La Pharmacie"
				}),
				/* @__PURE__ */ jsx("div", {
					style: {
						fontSize: "12px",
						margin: "0px 0px 0px 20px"
					},
					children: dateFormatted
				}),
				/* @__PURE__ */ jsx("div", {
					style: {
						fontSize: "12px",
						margin: "0px 0px 0px 20px"
					},
					dangerouslySetInnerHTML: { __html: message.body }
				}),
				/* @__PURE__ */ jsx("br", {})
			] }, index);
		}) });
	}
};
ValwinFactoPatientThreadToPrint$1.propTypes = { thread: object.isRequired };
// src/legacy/ValwinFactoPharmaciesSelect/ValwinFactoPharmaciesSelect.jsx
const ValwinFactoPharmaciesSelect$1 = ({ pharmaciesSelected, setPharmaciesSelected, pharmaciesList, groupsList, disabled, hasWebSiteGroup, withWebSiteGroup, title = "Ciblage", pharmacyGroupsLabel = "Groupes de pharmacies", pharmaciesLabel = "Pharmacies", allPharmaciesLabel = "Toutes les pharmacies", allPharmaciesWithGroupementLabel = "Toutes les pharmacies et le site Groupement" }) => {
	const displayWebSiteGroupSelection = hasWebSiteGroup && withWebSiteGroup;
	const [displayPharmaciesSelect, setDisplayPharmacySelect] = useState(!isEmpty(pharmaciesSelected));
	return /* @__PURE__ */ jsx("div", {
		className: "valwinFactoPharmaciesSelect",
		children: /* @__PURE__ */ jsxs(ValwinFactoPanelAlt$1, {
			title,
			displayContentOnLoad: true,
			isOpenable: false,
			children: [/* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
				className: "valwinFactoPharmaciesSelect__all",
				disabled,
				name: "allPharmacies",
				label: displayWebSiteGroupSelection ? allPharmaciesWithGroupementLabel : allPharmaciesLabel,
				checked: !displayPharmaciesSelect,
				onChange: (event) => {
					if (event.target.checked) {
						setDisplayPharmacySelect(false);
						setPharmaciesSelected([]);
					} else {
						setDisplayPharmacySelect(true);
						setPharmaciesSelected([]);
					}
				}
			}), displayPharmaciesSelect && /* @__PURE__ */ jsxs(Fragment$1, { children: [
				!isEmpty(groupsList) && /* @__PURE__ */ jsxs("div", {
					className: "valwinFactoPharmaciesSelect__groups",
					children: [/* @__PURE__ */ jsx("div", {
						className: "valwinFactoPharmaciesSelect__label",
						children: pharmacyGroupsLabel
					}), groupsList.map((group, index) => {
						const pharmaciesIdsGroupFormatted = (group?.pharmacyIds || []).map((pharmacyId) => pharmacyId?.idStr || "");
						return /* @__PURE__ */ jsx(ValwinFactoCheckbox$1, {
							className: "valwinFactoPharmaciesSelect__group",
							disabled,
							name: group?.id?.idStr || "",
							label: group?.name || "",
							checked: every(pharmaciesIdsGroupFormatted, (pharmacyIdGroup) => pharmaciesSelected.includes(pharmacyIdGroup)),
							onChange: (event) => {
								if (event.target.checked) {
									const newPharmaciesSelected = [...pharmaciesSelected];
									pharmaciesIdsGroupFormatted.forEach((pharmacyIdGroup) => newPharmaciesSelected.push(pharmacyIdGroup));
									setPharmaciesSelected(uniq(newPharmaciesSelected).filter((pharmacy) => !isEmpty(pharmacy)));
								} else setPharmaciesSelected([...pharmaciesSelected].filter((pharmacySelect) => !pharmaciesIdsGroupFormatted.includes(pharmacySelect)));
							}
						}, index);
					})]
				}),
				/* @__PURE__ */ jsx(ValwinFactoCheckboxList$1, {
					className: "valwinFactoPharmaciesSelect__checkboxList",
					disabled,
					name: "pharmacies",
					label: pharmaciesLabel,
					values: pharmaciesSelected.filter((pharmacy) => !isEqual(pharmacy, "GROUP_WEBSITE")).map((pharmacySelected) => {
						return pharmaciesList.find((pharmacyFromList) => isEqual(pharmacyFromList?.pharmacyId, pharmacySelected));
					}).map((pharmacy) => {
						return {
							name: pharmacy?.pharmacyId || "",
							label: pharmacy?.name || ""
						};
					}),
					checkboxList: pharmaciesList.map((pharmacy) => {
						return {
							name: pharmacy?.pharmacyId || "",
							label: pharmacy?.name || ""
						};
					}),
					onChange: (newPharmaciesSelected) => {
						const newPharmaciesSelectedFormatted = newPharmaciesSelected.map((pharmacy) => pharmacy?.name || "");
						if (pharmaciesSelected.includes("GROUP_WEBSITE")) newPharmaciesSelectedFormatted.push("GROUP_WEBSITE");
						setPharmaciesSelected(newPharmaciesSelectedFormatted);
					}
				}),
				displayWebSiteGroupSelection && /* @__PURE__ */ jsx(ValwinFactoCheckboxList$1, {
					className: "valwinFactoPharmaciesSelect__checkboxList",
					disabled,
					name: "group",
					label: "Groupement",
					values: pharmaciesSelected.includes("GROUP_WEBSITE") ? [{
						name: "GROUP_WEBSITE",
						label: "Site groupement"
					}] : [],
					checkboxList: [{
						name: "GROUP_WEBSITE",
						label: "Site groupement"
					}],
					onChange: () => {
						if (pharmaciesSelected.includes("GROUP_WEBSITE")) setPharmaciesSelected([...pharmaciesSelected].filter((pharmacy) => !isEqual(pharmacy, "GROUP_WEBSITE")).filter((pharmacy) => !isEqual(pharmacy, "GROUP_WEBSITE")));
						else setPharmaciesSelected([...pharmaciesSelected, "GROUP_WEBSITE"]);
					}
				})
			] })]
		})
	});
};
ValwinFactoPharmaciesSelect$1.propTypes = {
	pharmaciesSelected: arrayOf(string).isRequired,
	pharmaciesList: arrayOf(object).isRequired,
	groupsList: arrayOf(object).isRequired,
	setPharmaciesSelected: func.isRequired,
	disabled: bool,
	hasWebSiteGroup: bool,
	withWebSiteGroup: bool
};
// src/legacy/ValwinFactoPosterForm/ValwinFactoPosterFormUtils.js
const getBackgroundImage = async (setBackgroundImage) => {
	const url = `https://valwin-pharma-assets.s3.eu-west-1.amazonaws.com/valwin-pharma-assets/images/resources/posterMeeting/posterMeeting.jpg`;
	try {
		const responseBlob = await (await fetch(url)).blob();
		var reader = new FileReader();
		reader.readAsDataURL(responseBlob);
		setBackgroundImage(await new Promise((resolve) => {
			reader.onloadend = () => {
				resolve(reader.result);
			};
		}));
	} catch (error) {
		console.log(error);
		return null;
	}
};
const getPharmacyNameDecodeHtml = (pharmacy) => {
	const pharmacyName = pharmacy?.name || "";
	const textArea = document.createElement("textarea");
	textArea.innerHTML = pharmacyName;
	return textArea.value;
};
// src/legacy/ValwinFactoPosterForm/ValwinFactoPosterForm.jsx
const ValwinFactoPosterForm$1 = ({ pharmacy, link, id, label }) => {
	const [backgroundImage, setBackgroundImage] = useState(null);
	const pharmacyName = getPharmacyNameDecodeHtml(pharmacy);
	useEffect(() => {
		getBackgroundImage(setBackgroundImage);
	}, []);
	return /* @__PURE__ */ jsx(Fragment$1, { children: !isEmpty(backgroundImage) && /* @__PURE__ */ jsxs("div", {
		id,
		style: { backgroundImage: `url(${backgroundImage})` },
		className: "valwinFactoPosterForm",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPosterForm__container valwinFactoPosterForm__container--label",
				children: /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label,
					className: "valwinFactoParagraph--white valwinFactoParagraph--mega valwinFactoPosterForm__label"
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPosterForm__container valwinFactoPosterForm__container--pharmacy",
				children: /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: pharmacyName.toLowerCase().includes("pharmacie") ? `${pharmacyName}` : `Pharmacie ${pharmacyName}`,
					className: "valwinFactoParagraph--white valwinFactoParagraph--mega valwinFactoPosterForm__pharmacy"
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPosterForm__container valwinFactoPosterForm__container--scan",
				children: /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: "Scannez le QR Code pour remplir votre questionnaire",
					className: "valwinFactoParagraph--greenLight valwinFactoParagraph--mega valwinFactoPosterForm__scan"
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPosterForm__qrCode",
				children: /* @__PURE__ */ jsx(QrCode, {
					value: link,
					size: "2xl"
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPosterForm__container valwinFactoPosterForm__container--prepare",
				children: /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: "Préparez votre rendez-vous en remplissant en ligne votre questionnaire",
					className: "valwinFactoParagraph--white valwinFactoParagraph--mega valwinFactoPosterForm__prepare"
				})
			})
		]
	}) });
};
ValwinFactoPosterForm$1.propTypes = {
	pharmacy: object.isRequired,
	link: string.isRequired,
	id: string.isRequired,
	label: string.isRequired
};
// src/legacy/ValwinFactoProduct/ValwinFactoProductConst.js
const VALWIN_FACTO_PRODUCT_CONST = [
	{
		name: "ACCESSORY",
		label: "Accessoire"
	},
	{
		name: "DIETETIC",
		label: "Diététique"
	},
	{
		name: "HOMEOPATHIC",
		label: "Homéopathique"
	},
	{
		name: "NON_PHARMACEUTICAL",
		label: "Parapharmacie"
	},
	{
		name: "VETERINARY",
		label: "Vétérinaire"
	},
	{
		name: "VIDAL",
		label: "Médicament"
	}
];
// src/legacy/ValwinFactoProduct/ValwinFactoProductUtils.js
const getIsInStock = (pharmacy, hit) => {
	return hit?.[pharmacy?.id]?.isInStock;
};
const getIsSold = (pharmacy, hit) => {
	return hit?.[pharmacy?.id]?.isSold;
};
const getTypeLabel = (hit) => {
	return VALWIN_FACTO_PRODUCT_CONST.find((CATALOG_PRODUCT_TYPE) => isEqual(CATALOG_PRODUCT_TYPE.name, hit?.details?.productType))?.label || "";
};
// src/legacy/ValwinFactoProduct/ValwinFactoProduct.jsx
const ValwinFactoProduct$1 = forwardRef(function createValwinFactoProduct({ hit, className, stock, pharmacy, isDraggable, handleProps, isDragging }, ref) {
	const isInStock = getIsInStock(pharmacy, hit);
	const isSold = getIsSold(pharmacy, hit);
	const typeLabel = getTypeLabel(hit);
	return /* @__PURE__ */ jsxs("div", {
		ref,
		className: `valwinFactoProduct ${className}`,
		children: [
			isDraggable && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoProduct__containerPoints",
				...handleProps,
				style: { cursor: isDragging ? "grabbing" : "grab" },
				children: /* @__PURE__ */ jsx(VerticalGripIcon, { size: "xl" })
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoProduct__containerImage",
				children: /* @__PURE__ */ jsx("img", {
					className: "valwinFactoProduct__image",
					src: hit?.details?.image || "https://valwin-pharma-assets.s3.eu-west-1.amazonaws.com/valwin-pharma-assets/images/resources/ValwindefaultNoProductImage.jpg",
					alt: ""
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoProduct__infos",
				children: [
					hit?.ids?.ean && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						html: `EAN : ${hit?.ids?.ean || ""}`,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph"
					}),
					hit?.ids?.cip13 && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						html: `CIP : ${hit?.ids?.cip13 || ""}`,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph"
					}),
					hit?.details?.name && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						html: `Nom : ${hit?.details?.name || ""}`,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph"
					}),
					hit?.details?.lining && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: `Gamme : ${hit?.details?.lining || ""}`,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph"
					}),
					hit?.details?.producer && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: `Marque: ${hit?.details?.producer || ""}`,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph"
					}),
					isNumber(stock) && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: `Stock: ${stock}`,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph"
					}),
					!isEmpty(typeLabel) && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: typeLabel,
						className: "valwinFactoParagraph--mini valwinFactoProduct__paragraph valwinFactoParagraph--blue"
					}),
					pharmacy?.id && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: isInStock ? "En stock web" : "Épuisé web",
						className: classnames("valwinFactoParagraph--mini valwinFactoProduct__paragraph", {
							"valwinFactoParagraph--greenLight": isInStock,
							"valwinFactoParagraph--red": !isInStock
						})
					}),
					pharmacy?.id && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						label: isSold ? "En vente" : "Non vendu",
						className: classnames("valwinFactoParagraph--mini valwinFactoProduct__paragraph", {
							"valwinFactoParagraph--greenLight": isSold,
							"valwinFactoParagraph--red": !isSold
						})
					})
				]
			})
		]
	});
});
ValwinFactoProduct$1.propTypes = {
	hit: object.isRequired,
	className: string,
	stock: number,
	pharmacy: object.isRequired,
	isDraggable: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailFreeDeliveryFeesBeyondThreshold.jsx
const ValwinFactoPromotionDetailFreeDeliveryFeesBeyondThreshold = ({ name1, value1, onChange, onBlur, disabled }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "Livraison gratuite à partir de"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "€ d'achat"
			})
		]
	});
};
ValwinFactoPromotionDetailFreeDeliveryFeesBeyondThreshold.propTypes = {
	name1: string.isRequired,
	value1: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailMaxFeesBeyondThreshold.jsx
const ValwinFactoPromotionDetailMaxFeesBeyondThreshold = ({ name1, value1, name2, value2, onChange, onBlur, disabled }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "Livraison à"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "€ max à partir de"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "€ d'achat"
			})
		]
	});
};
ValwinFactoPromotionDetailMaxFeesBeyondThreshold.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNForValue.jsx
const ValwinFactoPromotionDetailNForValue = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "produit(s) pour";
	const secondLabel = labelPartials?.label2 || "€";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNForValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onBlur: func.isRequired,
	onChange: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNPercentForYBasketValue.jsx
const PROMOTION_CODE_N_PERCENT_FOR_Y_BASKET_VALUE_LABELS = {
	label1: "% à partir de",
	label1Key: "promotions promoCode explanation NPercentForYBasketValue label1",
	label2: "€ d'achat",
	label2Key: "promotions promoCode explanation NPercentForYBasketValue label2"
};
const ValwinFactoPromotionDetailNPercentForYBasketValue = ({ name1, value1, name2, value2, onChange, onBlur, disabled, innerLabels = PROMOTION_CODE_N_PERCENT_FOR_Y_BASKET_VALUE_LABELS }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "-"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label1
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label2
			})
		]
	});
};
ValwinFactoPromotionDetailNPercentForYBasketValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool,
	innerLabels: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNPercentOnFirstOrderValue.jsx
const PROMOTION_CODE_N_PERCENT_ON_FIRST_ORDER_VALUE_LABELS = {
	label1: "% sur le premier achat",
	label1Key: "promotions promoCode explanation NPercentOnFirstOrderValue label1"
};
const ValwinFactoPromotionDetailNPercentOnFirstOrderValue = ({ name1, value1, onChange, onBlur, disabled, innerLabels = PROMOTION_CODE_N_PERCENT_ON_FIRST_ORDER_VALUE_LABELS }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "-"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label1
			})
		]
	});
};
ValwinFactoPromotionDetailNPercentOnFirstOrderValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	onBlur: func.isRequired,
	onChange: func.isRequired,
	disabled: bool,
	innerLabels: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNPlusAdditionalOffered.jsx
const ValwinFactoPromotionDetailNPlusAdditionalOffered = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "produit(s) acheté(s) de la sélection,";
	const secondLabel = labelPartials?.label2 || "produit(s) différent(s) offert(s)";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled: true,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: isArray(value2) ? value2.length : "",
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNPlusAdditionalOffered.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNplusBundlePourcent.jsx
const ValwinFactoPromotionDetailNplusBundlePourcent = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "produit(s) acheté(s),";
	const secondLabel = labelPartials?.label2 || "% de réduction";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNplusBundlePourcent.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool,
	labelPartials: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNplusBundleValue.jsx
const ValwinFactoPromotionDetailNplusBundleValue = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "produit(s) acheté(s),";
	const secondLabel = labelPartials?.label2 || "€ de réduction";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNplusBundleValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool,
	labelPartials: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNPlusM.jsx
const ValwinFactoPromotionDetailNPlusM = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "produit(s) acheté(s),";
	const secondLabel = labelPartials?.label2 || "produit(s) offert(s)";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNPlusM.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNPlusPercent.jsx
const ValwinFactoPromotionDetailNPlusPercent = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "Le";
	const secondLabel = labelPartials?.label2 || "ème produit à -";
	const thirdLabel = labelPartials?.label3 || "%";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: thirdLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNPlusPercent.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onBlur: func.isRequired,
	onChange: func.isRequired,
	disabled: bool,
	labelPartials: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNSpentPlusAdditionalOffered.jsx
const ValwinFactoPromotionDetailNSpentPlusAdditionalOffered = ({ name1, value1, name2, value2, onChange, onBlur, disabled, labelPartials }) => {
	const firstLabel = labelPartials?.label1 || "€ de produit(s) acheté(s) de la sélection,";
	const secondLabel = labelPartials?.label2 || "produit(s) différent(s) offert(s)";
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: firstLabel
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled: true,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: isArray(value2) ? value2.length : "",
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: secondLabel
			})
		]
	});
};
ValwinFactoPromotionDetailNSpentPlusAdditionalOffered.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	labelPartials: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNValueForYBasketValue.jsx
const PROMOTION_CODE_N_VALUE_FOR_Y_BASKET_VALUE_LABELS = {
	label1: "€ à partir de",
	label1Key: "promotions promoCode explanation NValueForYBasketValue label1",
	label2: "€ d'achat",
	label2Key: "promotions promoCode explanation NValueForYBasketValue label2"
};
const ValwinFactoPromotionDetailNValueForYBasketValue = ({ name1, value1, name2, value2, onChange, onBlur, disabled, innerLabels = PROMOTION_CODE_N_VALUE_FOR_Y_BASKET_VALUE_LABELS }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "-"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label1
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label2
			})
		]
	});
};
ValwinFactoPromotionDetailNValueForYBasketValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool,
	innerLabels: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailNValueOnFirstOrderValue.jsx
const PROMOTION_CODE_N_VALUE_ON_FIRST_ORDER_VALUE_LABELS = {
	label1: "€ sur le premier achat à partir de",
	label1Key: "promotions promoCode explanation NValueOnFirstOrderValue label1",
	label2: "€ d'achat",
	label2Key: "promotions promoCode explanation NValueOnFirstOrderValue label2"
};
const ValwinFactoPromotionDetailNValueOnFirstOrderValue = ({ name1, value1, name2, value2, onChange, onBlur, disabled, innerLabels = PROMOTION_CODE_N_VALUE_ON_FIRST_ORDER_VALUE_LABELS }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "-"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label1
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: innerLabels.label2
			})
		]
	});
};
ValwinFactoPromotionDetailNValueOnFirstOrderValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool,
	innerLabels: object
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailPercent.jsx
const ValwinFactoPromotionDetailPercent = ({ name1, value1, onChange, onBlur, disabled }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "-"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "%"
			})
		]
	});
};
ValwinFactoPromotionDetailPercent.propTypes = {
	name1: string.isRequired,
	value1: any,
	onBlur: func.isRequired,
	onChange: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailReducedFeesBeyondThreshold.jsx
const ValwinFactoPromotionDetailReducedFeesBeyondThreshold = ({ name1, value1, name2, value2, onChange, onBlur, disabled }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "Réduction de"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "€ sur la livraison à partir de"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name2,
				id: name2,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value2,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "€ d'achat"
			})
		]
	});
};
ValwinFactoPromotionDetailReducedFeesBeyondThreshold.propTypes = {
	name1: string.isRequired,
	value1: any,
	name2: string.isRequired,
	value2: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/PromotionDetails/ValwinFactoPromotionDetailValue.jsx
const ValwinFactoPromotionDetailValue = ({ name1, value1, onChange, onBlur, disabled }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoPromotionDetail__row",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "-"
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				name: name1,
				id: name1,
				type: "number",
				disabled,
				className: "valwinFactoPromotionDetail__input",
				onChange,
				onBlur,
				value: value1,
				min: 0,
				step: 1,
				placeholder: "20"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoPromotionDetail__text",
				children: "€"
			})
		]
	});
};
ValwinFactoPromotionDetailValue.propTypes = {
	name1: string.isRequired,
	value1: any,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	disabled: bool
};
// src/legacy/ValwinFactoPromotionDetail/ValwinFactoPromotionDetail.jsx
const PromotionTypes = {
	VALUE: "VALUE",
	PERCENT: "PERCENT",
	N_PLUS_PERCENT: "N_PLUS_PERCENT",
	N_PLUS_M: "N_PLUS_M",
	N_PLUS_ADDITIONAL_OFFERED: "N_PLUS_ADDITIONAL_OFFERED",
	N_FOR_VALUE: "N_FOR_VALUE",
	N_PERCENT_ON_FIRST_ORDER_VALUE: "N_PERCENT_ON_FIRST_ORDER_VALUE",
	FREE_DELIVERY_FEES_BEYOND_THRESHOLD: "FREE_DELIVERY_FEES_BEYOND_THRESHOLD",
	N_VALUE_FOR_Y_BASKET_VALUE: "N_VALUE_FOR_Y_BASKET_VALUE",
	N_PERCENT_FOR_Y_BASKET_VALUE: "N_PERCENT_FOR_Y_BASKET_VALUE",
	N_VALUE_ON_FIRST_ORDER_VALUE: "N_VALUE_ON_FIRST_ORDER_VALUE",
	MAX_FEES_BEYOND_THRESHOLD: "MAX_FEES_BEYOND_THRESHOLD",
	REDUCED_FEES_BEYOND_THRESHOLD: "REDUCED_FEES_BEYOND_THRESHOLD",
	N_PLUS_BUNDLE_VALUE: "N_PLUS_BUNDLE_VALUE",
	N_PLUS_BUNDLE_POURCENT: "N_PLUS_BUNDLE_POURCENT",
	N_SPENT_PLUS_ADDITIONAL_OFFERED: "N_SPENT_PLUS_ADDITIONAL_OFFERED"
};
/**
* The innerLabels property is an object containing the internationalized labels of the inner components.
* It’s up to the inner component to handle it.
*
* @param {*} param0
* @returns
*/
const ValwinFactoPromotionDetail$1 = ({ promotionType, name1, value1, name2, value2, onChange, onBlur, label, disabled, required, touched, errors, className, tooltip, innerLabels, labelPartials }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoPromotionDetail ${className}`, { "valwinFactoPromotionDetail--disabled": disabled }),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoPromotionDetail__header",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoPromotionDetail__label", { "valwinFactoPromotionDetail__label--disabled": disabled }),
						children: label
					}),
					required && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoPromotionDetail__required", { "valwinFactoPromotionDetail__required--disabled": disabled }),
						children: "*"
					}),
					tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
						tooltip,
						className: "valwinFactoPromotionDetail__tooltip"
					}),
					errors && errors[name1] && touched && touched[name1] && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoPromotionDetail__errors", { "valwinFactoPromotionDetail__errors--disabled": disabled }),
						children: errors[name1]
					}),
					errors && errors[name2] && touched && touched[name2] && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoPromotionDetail__errors", { "valwinFactoPromotionDetail__errors--disabled": disabled }),
						children: errors[name2]
					})
				]
			}),
			isEqual(promotionType, "VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailValue, {
				name1,
				value1,
				onChange,
				onBlur,
				disabled
			}),
			isEqual(promotionType, "PERCENT") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailPercent, {
				name1,
				value1,
				onChange,
				onBlur,
				disabled
			}),
			isEqual(promotionType, "N_PLUS_PERCENT") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNPlusPercent, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			}),
			isEqual(promotionType, "N_PLUS_M") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNPlusM, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			}),
			isEqual(promotionType, "N_PLUS_ADDITIONAL_OFFERED") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNPlusAdditionalOffered, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			}),
			isEqual(promotionType, "N_FOR_VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNForValue, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			}),
			isEqual(promotionType, "N_PERCENT_ON_FIRST_ORDER_VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNPercentOnFirstOrderValue, {
				name1,
				value1,
				onChange,
				onBlur,
				disabled,
				innerLabels
			}),
			isEqual(promotionType, "FREE_DELIVERY_FEES_BEYOND_THRESHOLD") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailFreeDeliveryFeesBeyondThreshold, {
				name1,
				value1,
				onChange,
				onBlur,
				disabled
			}),
			isEqual(promotionType, "N_VALUE_FOR_Y_BASKET_VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNValueForYBasketValue, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				innerLabels
			}),
			isEqual(promotionType, "N_PERCENT_FOR_Y_BASKET_VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNPercentForYBasketValue, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				innerLabels
			}),
			isEqual(promotionType, "N_VALUE_ON_FIRST_ORDER_VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNValueOnFirstOrderValue, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				innerLabels
			}),
			isEqual(promotionType, "MAX_FEES_BEYOND_THRESHOLD") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailMaxFeesBeyondThreshold, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled
			}),
			isEqual(promotionType, "REDUCED_FEES_BEYOND_THRESHOLD") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailReducedFeesBeyondThreshold, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled
			}),
			isEqual(promotionType, "N_PLUS_BUNDLE_VALUE") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNplusBundleValue, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			}),
			isEqual(promotionType, "N_PLUS_BUNDLE_POURCENT") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNplusBundlePourcent, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			}),
			isEqual(promotionType, "N_SPENT_PLUS_ADDITIONAL_OFFERED") && /* @__PURE__ */ jsx(ValwinFactoPromotionDetailNSpentPlusAdditionalOffered, {
				name1,
				value1,
				name2,
				value2,
				onChange,
				onBlur,
				disabled,
				labelPartials
			})
		]
	});
};
ValwinFactoPromotionDetail$1.propTypes = {
	promotionType: string.isRequired,
	name1: string.isRequired,
	value1: any,
	name2: string,
	value2: any,
	onBlur: func.isRequired,
	onChange: func.isRequired,
	label: string.isRequired,
	disabled: bool,
	required: bool,
	touched: object,
	errors: object,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoRecurringWeekDays/ValwinFactoRecurringWeekDaysConst.js
const VALWIN_FACTO_RECURRING_WEEK_DAYS_CONST = [
	{
		value: "Mo",
		icon: "L"
	},
	{
		value: "Tu",
		icon: "M"
	},
	{
		value: "We",
		icon: "M"
	},
	{
		value: "Th",
		icon: "J"
	},
	{
		value: "Fr",
		icon: "V"
	},
	{
		value: "Sa",
		icon: "S"
	},
	{
		value: "Su",
		icon: "D"
	}
];
// src/legacy/ValwinFactoRecurringWeekDays/ValwinFactoRecurringWeekDays.jsx
const ValwinFactoRecurringWeekDays$1 = ({ weekDays, setWeekDays, disabled, tooltip, className, label, required }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoRecurringWeekDays ${className}`, { "valwinFactoRecurringWeekDays--disabled": disabled }),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoRecurringWeekDays__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoRecurringWeekDays__label", { "valwinFactoRecurringWeekDays__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoRecurringWeekDays__required", { "valwinFactoRecurringWeekDays__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoRecurringWeekDays__tooltip"
				})
			]
		}), /* @__PURE__ */ jsx("div", {
			className: "valwinFactoRecurringWeekDays__row",
			children: VALWIN_FACTO_RECURRING_WEEK_DAYS_CONST.map((day, index) => {
				const selected = !isEmpty(weekDays.find((value) => {
					return isEqual(value, day.value);
				}));
				return /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
					type: "button",
					icon: day.icon,
					disabled,
					onClick: () => {
						if (selected && weekDays.length > 1) setWeekDays(weekDays.filter((value) => {
							return !isEqual(value, day.value);
						}));
						if (!selected) setWeekDays([...weekDays, day.value]);
					},
					className: selected ? "valwinFactoButtonIcon--green valwinFactoRecurringWeekDays__day" : "valwinFactoButtonIcon--grey valwinFactoRecurringWeekDays__day"
				}, index);
			})
		})]
	});
};
ValwinFactoRecurringWeekDays$1.propTypes = {
	setWeekDays: func.isRequired,
	weekDays: array.isRequired,
	disabled: bool,
	tooltip: object,
	className: string,
	required: bool
};
// src/legacy/ValwinFactoRichText/ValwinFactoRichText.jsx
const ValwinFactoRichText$1 = ({ name, label, placeholder, disabled, required, errors, className, onChange, onBlur, value, tooltip, touched }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoRichText ${className}`, { "valwinFactoRichText--disabled": disabled }),
		onBlur,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoRichText__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoRichText__label", { "valwinFactoRichText__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoRichText__required", { "valwinFactoRichText__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoRichText__tooltip"
				}),
				errors && errors[name] && touched && touched[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoRichText__errors", { "valwinFactoRichText__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), /* @__PURE__ */ jsx(EditorProvider, { children: /* @__PURE__ */ jsx(Editor, {
			value,
			onChange: (event) => onChange(event.target.value),
			placeholder,
			disabled
		}) })]
	});
};
ValwinFactoRichText$1.propTypes = {
	label: string.isRequired,
	name: string.isRequired,
	onChange: func.isRequired,
	value: string.isRequired,
	placeholder: string.isRequired,
	onBlur: func,
	disabled: bool,
	required: bool,
	errors: object,
	className: string,
	tooltip: object,
	touched: object
};
// src/legacy/ValwinFactoSearch/ValwinFactoSearch.jsx
const ValwinFactoSearch$1 = ({ placeholder, onChange, value, className, CustomOptionComponent, noOptionsMessage, isAsync, loadOptions }) => {
	const customStyles = {
		option: (styles, { isFocused, isSelected }) => ({
			...styles,
			cursor: "pointer",
			color: isFocused || isSelected ? "#fff" : "#5f5f5f",
			"&:hover": { color: "#fff" },
			fontSize: "16px"
		}),
		control: (styles) => ({
			...styles,
			cursor: "pointer",
			border: "0px",
			boxShadow: "0px",
			background: "transparent",
			height: "10px",
			margin: "-3px 0px 3px 0px",
			fontSize: "16px"
		}),
		singleValue: (styles) => ({
			...styles,
			color: "#d9d9d9",
			fontSize: "16px"
		}),
		placeholder: (styles) => ({
			...styles,
			fontSize: "14px",
			color: "#d9d9d9"
		}),
		container: (styles) => ({
			...styles,
			width: "100%"
		})
	};
	const CustomOption = ({ ...props }) => {
		return /* @__PURE__ */ jsx(components.Control, {
			...props,
			children: /* @__PURE__ */ jsx(CustomOptionComponent, { option: props.data })
		});
	};
	const commonProps = {
		placeholder,
		onChange,
		className,
		value
	};
	const asyncProps = {
		loadOptions,
		noOptionsMessage,
		styles: customStyles,
		theme: (theme) => ({
			...theme,
			colors: {
				...theme.colors,
				primary25: "#d9d9d9",
				primary: "#d9d9d9"
			}
		}),
		...CustomOptionComponent && { components: { Option: CustomOption } }
	};
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoSearch ${className}`,
		children: [/* @__PURE__ */ jsx(FaSearch, { className: "valwinFactoSearch__icon" }), isAsync ? /* @__PURE__ */ jsx(AsyncSelect, {
			...commonProps,
			...asyncProps,
			className: "valwinFactoSearch__async"
		}) : /* @__PURE__ */ jsx("input", {
			...commonProps,
			className: "valwinFactoSearch__input"
		})]
	});
};
ValwinFactoSearch$1.propTypes = {
	placeholder: string.isRequired,
	onChange: func.isRequired,
	value: any,
	className: string,
	CustomOptionComponent: any,
	noOptionsMessage: func,
	isAsync: bool,
	loadOptions: func
};
// src/legacy/ValwinFactoSelect/ValwinFactoSelect.jsx
const MENU_Z_INDEX = 11;
const ValwinFactoSelect$1 = ({ name, label, disabled, required, touched, errors, className, onChange, onBlur, value, tooltip, options, isMulti, isSearchable, placeholder, maxMenuHeight, isClearable, isAsync, loadOptions, noOptionsMessage, CustomOptionComponent, CustomMenuComponent, defaultOptions, menuTop }) => {
	const customStyles = {
		option: (styles, { isFocused, isSelected }) => ({
			...styles,
			cursor: "pointer",
			color: isFocused || isSelected ? "#fff" : null,
			"&:hover": { color: "#fff" },
			fontSize: "16px",
			fontStyle: "normal",
			fontWeight: 500
		}),
		control: (styles) => ({
			...styles,
			cursor: "pointer",
			border: "0px",
			boxShadow: "0px",
			background: "transparent",
			margin: "-3px 0px 3px 0px"
		}),
		singleValue: (styles, { isDisabled }) => ({
			...styles,
			color: isDisabled ? "#d9d9d9" : "#555555",
			fontSize: "16px"
		}),
		placeholder: (styles) => ({
			...styles,
			fontStyle: "normal",
			fontWeight: 500,
			fontSize: "16px",
			color: "#d9d9d9"
		}),
		menu: (base) => ({
			...base,
			zIndex: MENU_Z_INDEX
		})
	};
	const CustomOption = ({ ...props }) => {
		return /* @__PURE__ */ jsx(components.Control, {
			...props,
			children: /* @__PURE__ */ jsx(CustomOptionComponent, { option: props.data })
		});
	};
	const CustomMenu = ({ ...props }) => {
		return /* @__PURE__ */ jsx(components.Control, {
			...props,
			children: /* @__PURE__ */ jsxs("div", {
				className: "valwinFactoSelect__menu",
				children: [props.children, /* @__PURE__ */ jsx(CustomMenuComponent, {})]
			})
		});
	};
	const commonProps = {
		name,
		value,
		onChange,
		isDisabled: disabled,
		isMulti,
		placeholder: placeholder || "Sélectionnez une réponse",
		styles: customStyles,
		onBlur,
		maxMenuHeight,
		isClearable,
		noOptionsMessage,
		...menuTop && { menuPlacement: "top" },
		theme: (theme) => ({
			...theme,
			colors: {
				...theme.colors,
				primary25: "#0B7678",
				primary: "#0B7678"
			}
		}),
		...(CustomOptionComponent || CustomMenuComponent) && { components: {
			...CustomOptionComponent && { Option: CustomOption },
			...CustomMenuComponent && { MenuList: CustomMenu }
		} }
	};
	const unAsyncProps = {
		options,
		isSearchable
	};
	const asyncProps = {
		loadOptions,
		defaultOptions
	};
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoSelect ${className}`, { "valwinFactoSelect--disabled": disabled }),
		id: `container__${name}`,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoSelect__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoSelect__label", { "valwinFactoSelect__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoSelect__required", { "valwinFactoSelect__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoSelect__tooltip"
				}),
				errors && errors[name] && touched && touched[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoSelect__errors", { "valwinFactoSelect__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), isAsync ? /* @__PURE__ */ jsx(AsyncSelect, {
			...commonProps,
			...asyncProps
		}) : /* @__PURE__ */ jsx(Select, {
			...commonProps,
			...unAsyncProps
		})]
	});
};
ValwinFactoSelect$1.propTypes = {
	label: string.isRequired,
	onChange: func.isRequired,
	onBlur: func.isRequired,
	placeholder: string,
	name: string.isRequired,
	options: arrayOf(any),
	value: any,
	disabled: bool,
	required: bool,
	touched: object,
	errors: object,
	className: string,
	tooltip: object,
	isMulti: bool,
	isSearchable: bool,
	maxMenuHeight: number,
	isClearable: bool,
	isAsync: bool,
	loadOptions: func,
	noOptionsMessage: func,
	customOptionComponent: node,
	CustomMenuComponent: node,
	defaultOptions: bool,
	menuTop: bool
};
// src/legacy/ValwinFactoSubTitleAlt/ValwinFactoSubTitleAlt.jsx
const ValwinFactoSubTitleAlt$1 = ({ label, tooltip, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoSubTitleAlt ${className}`,
		children: [label, !isEmpty(tooltip) && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
			tooltip,
			className: "valwinFactoSubTitleAlt__tooltip"
		})]
	});
};
ValwinFactoSubTitleAlt$1.propTypes = {
	label: any.isRequired,
	tooltip: object,
	className: string
};
// src/legacy/ValwinFactoTable/ValwinFactoTable.jsx
const ValwinFactoTable$1 = ({ children, className, id }) => {
	return /* @__PURE__ */ jsx("table", {
		id,
		className: `valwinFactoTable ${className}`,
		children
	});
};
ValwinFactoTable$1.propTypes = {
	children: node.isRequired,
	string,
	id: string
};
// src/legacy/ValwinFactoLocker/ValwinFactoLocker.jsx
const ValwinFactoLocker = ({ value, onClick, className, disabled }) => {
	return /* @__PURE__ */ jsx("div", {
		onClick: () => {
			if (!disabled) onClick();
		},
		className: classnames(`valwinFactoLocker ${className}`, {
			"valwinFactoLocker--active": value,
			"valwinFactoLocker--inactive": !value,
			"valwinFactoLocker--disabled": disabled
		}),
		children: /* @__PURE__ */ jsx("div", { className: classnames("valwinFactoLocker__bullet", {
			"valwinFactoLocker__bullet--active": value,
			"valwinFactoLocker__bullet--inactive": !value
		}) })
	});
};
ValwinFactoLocker.propTypes = {
	value: bool.isRequired,
	onClick: func.isRequired,
	className: string,
	disabled: bool
};
// src/legacy/ValwinFactoTask/ValwinFactoTask.jsx
const ValwinFactoTask = ({ task, disabled, error, id, onChangeTitle, onChangeAssetCountTarget, onClickRemoveTask, onChangeType, canRemoveTask, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoTask ${className}`,
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "valwinFactoTask__error",
				children: error && /* @__PURE__ */ jsxs("div", {
					className: classnames("valwinFactoTask__error", { "valwinFactoTask__error--disabled": disabled }),
					children: [
						error?.title || "",
						" ",
						error?.assetCountTarget || ""
					]
				})
			}),
			/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
				id: `valwinFactoTask__${id}_title`,
				name: `valwinFactoTask__${id}_title`,
				placeholder: "Titre",
				type: "text",
				onChange: (event) => {
					onChangeTitle(event.target.value);
				},
				value: task?.title || "",
				disabled,
				className: "valwinFactoTask__title"
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoTask__row",
				children: [
					/* @__PURE__ */ jsx(ValwinFactoLocker, {
						value: isEqual(task?._type, "IMAGE"),
						onClick: () => onChangeType(),
						disabled
					}),
					isEqual(task?._type, "IMAGE") && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(ValwinFactoFieldAlt$1, {
						id: `valwinFactoTask__${id}_assetCountTarget`,
						name: `valwinFactoTask__${id}_assetCountTarget`,
						placeholder: "1",
						type: "number",
						onChange: (event) => {
							onChangeAssetCountTarget(event.target.value);
						},
						value: task?.assetCountTarget || 0,
						min: 1,
						step: 1,
						disabled,
						className: "valwinFactoTask__assetCountTarget"
					}), /* @__PURE__ */ jsx("div", {
						className: "valwinFactoTask__withAsset",
						children: "Preuve(s)"
					})] }),
					isEqual(task?._type, "MANUAL") && /* @__PURE__ */ jsx("div", {
						className: "valwinFactoTask__withoutAsset",
						children: "Sans preuve"
					}),
					canRemoveTask && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon: "TRASH",
						onClick: onClickRemoveTask,
						className: "valwinFactoIcon--grey valwinFactoTask__remove"
					})
				]
			})
		]
	});
};
ValwinFactoTask.propTypes = {
	task: object.isRequired,
	disabled: bool,
	canRemoveTask: bool,
	error: object,
	id: string.isRequired,
	onChangeTitle: func.isRequired,
	onChangeAssetCountTarget: func.isRequired,
	onClickRemoveTask: func.isRequired,
	onChangeType: func.isRequired,
	className: string
};
// src/legacy/ValwinFactoTasks/ValwinFactoTasks.jsx
const ValwinFactoTasks$1 = ({ label, setTasks, tasks, disabled, required, errors, tooltip, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoTasks ${className}`, { "valwinFactoTasks--disabled": disabled }),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoTasks__header",
				children: [
					/* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoTasks__label", { "valwinFactoTasks__label--disabled": disabled }),
						children: label
					}),
					required && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoTasks__required", { "valwinFactoTasks__required--disabled": disabled }),
						children: "*"
					}),
					tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
						tooltip,
						className: "valwinFactoTasks__tooltip"
					})
				]
			}),
			tasks.map((task, index) => /* @__PURE__ */ jsx(ValwinFactoTask, {
				className: "valwinFactoTasks__task",
				task,
				disabled,
				error: errors?.tasks?.[index] || {},
				id: `${index}`,
				onChangeTitle: (newTitle) => {
					const newTask = {
						...task,
						title: newTitle
					};
					const newTasks = [...tasks];
					newTasks[index] = newTask;
					setTasks(newTasks);
				},
				onChangeType: () => {
					const newTask = {
						...task,
						_type: task?._type === "IMAGE" ? "MANUAL" : "IMAGE",
						assetCountTarget: 1
					};
					const newTasks = [...tasks];
					newTasks[index] = newTask;
					setTasks(newTasks);
				},
				onChangeAssetCountTarget: (newAssetCountTarget) => {
					const newTask = {
						...task,
						assetCountTarget: Number.parseInt(newAssetCountTarget)
					};
					const newTasks = [...tasks];
					newTasks[index] = newTask;
					setTasks(newTasks);
				},
				canRemoveTask: !disabled && size(tasks) > 1,
				onClickRemoveTask: () => {
					const newTasks = [...tasks];
					newTasks.splice(index, 1);
					setTasks(newTasks);
				}
			}, index)),
			!disabled && /* @__PURE__ */ jsx(ValwinFactoButton$1, {
				type: "button",
				label: "Ajouter une tâche",
				icon: "ADD",
				onClick: () => {
					setTasks([...tasks, {
						title: "",
						assetCountTarget: 1,
						_type: "MANUAL"
					}]);
				},
				className: "valwinFactoTasks__add valwinFactoButton--greenStrong"
			})
		]
	});
};
ValwinFactoTasks$1.propTypes = {
	tasks: arrayOf(object).isRequired,
	setTasks: func.isRequired,
	label: string.isRequired,
	disabled: bool,
	required: bool,
	errors: object,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoTbody/ValwinFactoTbody.jsx
const ValwinFactoTbody$1 = ({ children, className }) => {
	return /* @__PURE__ */ jsx("tbody", {
		className: `valwinFactoTbody ${className}`,
		children
	});
};
ValwinFactoTbody$1.propTypes = {
	children: node.isRequired,
	className: string
};
// src/legacy/ValwinFactoTd/ValwinFactoTd.jsx
const ValwinFactoTd$1 = ({ children, colSpan, className, isBordered }) => {
	return /* @__PURE__ */ jsx("td", {
		className: classnames(`valwinFactoTd ${className}`, { "valwinFactoTd--bordered": isBordered }),
		colSpan,
		children
	});
};
ValwinFactoTd$1.propTypes = {
	children: node.isRequired,
	colSpan: any,
	className: string,
	isBordered: bool
};
// src/legacy/ValwinFactoTh/ValwinFactoTh.jsx
const ValwinFactoTh$1 = ({ children, className, colSpan, onSort, isSort }) => {
	return /* @__PURE__ */ jsx("th", {
		className: `valwinFactoTh ${className}`,
		colSpan,
		children: /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoTh__content",
			children: [isFunction(onSort) && isBoolean(isSort) && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
				className: "valwinFactoTh__icon",
				icon: isSort ? "ARROW_DOWN" : "ARROW_UP",
				onClick: () => {
					onSort(!isSort);
				}
			}), children]
		})
	});
};
ValwinFactoTh$1.propTypes = {
	children: node.isRequired,
	className: string,
	colSpan: any,
	onSort: func,
	isSort: bool
};
// src/legacy/ValwinFactoThreadMenuElement/ValwinFactoThreadMenuElement.jsx
const ValwinFactoThreadMenuElement$1 = ({ className, menu }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoThreadMenuElement ${className}`, { "valwinFactoThreadMenuElement--selected": menu.isSelected }),
		onClick: menu.onClick,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoThreadMenuElement__messages",
			children: [menu.icon && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
				icon: menu.icon,
				className: `valwinFactoThreadMenuElement__icon valwinFactoIcon--${menu.iconColor}`
			}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: menu.title,
				className: `valwinFactoParagraph--${menu.titleColor}`
			})]
		}), menu.notificationsNumber > 0 && /* @__PURE__ */ jsx(ValwinFactoBullet, {
			label: menu.notificationsNumber,
			className: `valwinFactoBullet--${menu.bulletColor} valwinFactoThreadMenuElement__notificationsNumber`
		})]
	});
};
ValwinFactoThreadMenuElement$1.propTypes = {
	menu: object.isRequired,
	className: string
};
// src/legacy/ValwinFactoThreadMenu/ValwinFactoThreadMenu.jsx
const ValwinFactoThreadMenu$1 = ({ menus, className }) => {
	return /* @__PURE__ */ jsx("div", {
		className: classnames(`valwinFactoThreadMenu ${className}`),
		children: menus.map((menu, index) => {
			return /* @__PURE__ */ jsx(ValwinFactoThreadMenuElement$1, { menu }, index);
		})
	});
};
ValwinFactoThreadMenu$1.propTypes = {
	menus: arrayOf(object).isRequired,
	className: string
};
// src/legacy/ValwinFactoTime/ValwinFactoTime.jsx
const ValwinFactoTime$1 = ({ name, label, placeholder, disabled, required, errors, className, onChange, onBlur, value, tooltip, cancelLabel = "Annuler", okLabel = "Valider" }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoTime ${className}`, { "valwinFactoTime--disabled": disabled }),
		id: `container__${name}`,
		children: [/* @__PURE__ */ jsxs("div", {
			className: "valwinFactoTime__header",
			children: [
				/* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoTime__label", { "valwinFactoTime__label--disabled": disabled }),
					children: label
				}),
				required && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoTime__required", { "valwinFactoTime__required--disabled": disabled }),
					children: "*"
				}),
				tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
					tooltip,
					className: "valwinFactoTime__tooltip"
				}),
				errors && errors[name] && /* @__PURE__ */ jsx("div", {
					className: classnames("valwinFactoTime__errors", { "valwinFactoTime__errors--disabled": disabled }),
					children: errors[name]
				})
			]
		}), /* @__PURE__ */ jsx(Application, {
			theme: { rainbow: { palette: { brand: "#0b7678" } } },
			children: /* @__PURE__ */ jsx(TimePicker, {
				name,
				value,
				onChange,
				className: "valwinFactoTime__input",
				placeholder,
				hour24: true,
				cancelLabel,
				okLabel,
				disabled,
				formatStyle: "large",
				onBlur
			})
		})]
	});
};
ValwinFactoTime$1.propTypes = {
	label: string.isRequired,
	placeholder: string.isRequired,
	value: any,
	onChange: func.isRequired,
	name: string.isRequired,
	onBlur: func,
	disabled: bool,
	required: bool,
	errors: object,
	className: string,
	tooltip: object
};
// src/legacy/ValwinFactoTimelineColissimo/ValwinFactoTimelineColissimoUtils.js
var import_COLISSIMO_LOGO_BLACK_BACKGROUND_WHITE = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = "../assets/COLISSIMO_LOGO_BLACK_BACKGROUND_WHITE-BnDT59AJ.png";
})))(), 1);
const getColissimoEtiquetteNumber = (order) => {
	return order?.basket?.basketDetails?.colissimo?.label?.parcelNumber;
};
const getHasEstimation = (order) => {
	const step = (order?.basket?.basketDetails?.colissimo?.steps || []).find((step) => isEqual(step?.stepId, 5));
	return isEqual(step?.status, "STEP_STATUS_INACTIVE") && !isEmpty(step?.date);
};
const getIsSent = (order) => {
	const step = (order?.basket?.basketDetails?.colissimo?.steps || []).find((step) => isEqual(step?.stepId, 1));
	return isEqual(step?.status, "STEP_STATUS_ACTIVE");
};
const getIsInProgress = (order) => {
	const step = (order?.basket?.basketDetails?.colissimo?.steps || []).find((step) => isEqual(step?.stepId, 2));
	return isEqual(step?.status, "STEP_STATUS_ACTIVE");
};
const getIsDelivered = (order) => {
	const step = (order?.basket?.basketDetails?.colissimo?.steps || []).find((step) => isEqual(step?.stepId, 5));
	return isEqual(step?.status, "STEP_STATUS_ACTIVE");
};
const getDateFormatted = (order, stepId) => {
	const dateString = (order?.basket?.basketDetails?.colissimo?.steps || []).find((step) => isEqual(step?.stepId, stepId))?.date;
	if (!isString(dateString)) return "";
	const date = new Date(dateString);
	if (!isDate(date)) return "";
	return `le ${format(date, "dd/MM/yyyy")}`;
};
const getIsSentLabel = (order) => {
	return `Colis pris en charge ${getIsSent(order) ? getDateFormatted(order, 1) : ""}`;
};
const getIsInProgressLabel = (order) => {
	return `Colis en cours de livraison ${getIsInProgress(order) ? getDateFormatted(order, 2) : ""}`;
};
const getIsDeliveredLabel = (order) => {
	const isDelivered = getIsDelivered(order);
	const hasEstimation = getHasEstimation(order);
	if (isDelivered && !hasEstimation) return `Colis livré ${getDateFormatted(order, 5)}`;
	if (!isDelivered && hasEstimation) return `Colis livré au plus tard ${getDateFormatted(order, 5)}`;
	return "Colis livré";
};
// src/legacy/ValwinFactoTimelineColissimo/ValwinFactoTimelineColissimo.jsx
const ValwinFactoTimelineColissimo$1 = ({ className, order }) => {
	const colissimoEtiquetteNumber = getColissimoEtiquetteNumber(order);
	const hasEstimation = getHasEstimation(order);
	const isSent = getIsSent(order);
	const isInProgress = getIsInProgress(order);
	const isDelivered = getIsDelivered(order);
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoTimelineColissimo ${className}`,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoTimelineColissimo__header",
				children: [/* @__PURE__ */ jsx("img", {
					src: import_COLISSIMO_LOGO_BLACK_BACKGROUND_WHITE.default,
					alt: "",
					className: "valwinFactoTimelineColissimo__logo"
				}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, { label: `N° ${colissimoEtiquetteNumber}` })]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoTimelineColissimo__timeline",
				children: [
					/* @__PURE__ */ jsx("div", { className: classnames("valwinFactoTimelineColissimo__point", { "valwinFactoTimelineColissimo__point--validate": isSent }) }),
					/* @__PURE__ */ jsx("div", { className: classnames("valwinFactoTimelineColissimo__line", { "valwinFactoTimelineColissimo__line--validate": isInProgress }) }),
					/* @__PURE__ */ jsx("div", { className: classnames("valwinFactoTimelineColissimo__point", { "valwinFactoTimelineColissimo__point--validate": isInProgress }) }),
					/* @__PURE__ */ jsx("div", { className: classnames("valwinFactoTimelineColissimo__line", { "valwinFactoTimelineColissimo__line--validate": isDelivered }) }),
					/* @__PURE__ */ jsx("div", { className: classnames("valwinFactoTimelineColissimo__point", {
						"valwinFactoTimelineColissimo__point--validate": isDelivered && !hasEstimation,
						"valwinFactoTimelineColissimo__point--estimation": !isDelivered & hasEstimation
					}) })
				]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoTimelineColissimo__infos",
				children: [
					/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						className: classnames("valwinFactoTimelineColissimo__info valwinFactoTimelineColissimo__info--left", {
							"valwinFactoParagraph--grey": !isSent,
							"valwinFactoParagraph--greenLight": isSent
						}),
						label: getIsSentLabel(order)
					}),
					/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						className: classnames("valwinFactoTimelineColissimo__info valwinFactoTimelineColissimo__info--center", {
							"valwinFactoParagraph--grey": !isInProgress,
							"valwinFactoParagraph--greenLight": isInProgress
						}),
						label: getIsInProgressLabel(order)
					}),
					/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
						className: classnames("valwinFactoTimelineColissimo__info valwinFactoTimelineColissimo__info--right", {
							"valwinFactoParagraph--grey": !isDelivered && !hasEstimation,
							"valwinFactoParagraph--greenLight": isDelivered && !hasEstimation,
							"valwinFactoParagraph--yellow": hasEstimation && !isDelivered
						}),
						label: getIsDeliveredLabel(order)
					})
				]
			})
		]
	});
};
ValwinFactoTimelineColissimo$1.propTypes = {
	className: string,
	order: object.isRequired
};
// src/legacy/ValwinFactoTip/ValwinFactoTipUtils.js
const getValue = (tip) => {
	const value = tip?.value || "";
	if (!isString(value)) return "";
	if (value.length > 25) return `${value.slice(0, 25)}...`;
	return value;
};
// src/legacy/ValwinFactoTip/ValwinFactoTip.jsx
const ValwinFactoTip$1 = ({ tip, onClickEdit, onClickDelete, onClickShow, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoTip ${className}`,
		children: [/* @__PURE__ */ jsx("div", {
			className: "valwinFactoTip__header",
			children: /* @__PURE__ */ jsx("div", {
				className: "valwinFactoTip__title",
				children: tip?.title
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "valwinFactoTip__container",
			children: [
				isEqual(tip?._type, "URL") && /* @__PURE__ */ jsx("a", {
					href: tip?.value,
					target: "_blank",
					rel: "noreferrer",
					className: "valwinFactoTip__value valwinFactoTip__url",
					children: getValue(tip)
				}),
				isEqual(tip?._type, "TEL") && /* @__PURE__ */ jsx("div", {
					className: "valwinFactoTip__value valwinFactoTip__tel",
					children: getValue(tip)
				}),
				onClickEdit && /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
					type: "button",
					icon: "EDIT",
					className: "valwinFactoTip__buttonIcon valwinFactoButtonIcon--green",
					onClick: onClickEdit
				}),
				onClickShow && /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
					type: "button",
					icon: "LIST",
					className: "valwinFactoButtonIcon--greenLight",
					onClick: onClickShow
				}),
				/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
					type: "button",
					icon: "TRASH",
					className: "valwinFactoTip__buttonIcon valwinFactoButtonIcon--red",
					onClick: onClickDelete
				})
			]
		})]
	});
};
ValwinFactoTip$1.propTypes = {
	tip: object.isRequired,
	onClickDelete: func.isRequired,
	onClickEdit: func,
	onClickShow: func,
	className: string
};
// src/legacy/ValwinFactoTr/ValwinFactoTr.jsx
const ValwinFactoTr$1 = ({ children, onClick, className, notResponsive, isHoverable, onMouseEnter, onMouseLeave }) => {
	return /* @__PURE__ */ jsx("tr", {
		className: classnames(`valwinFactoTr ${className}`, {
			"valwinFactoTr--responsive": !notResponsive,
			"valwinFactoTr--hoverable": isHoverable
		}),
		onClick,
		onMouseEnter,
		onMouseLeave,
		children
	});
};
ValwinFactoTr$1.propTypes = {
	children: node.isRequired,
	onClick: func,
	onMouseEnter: func,
	onMouseLeave: func,
	className: string,
	notResponsive: bool,
	isHoverable: bool
};
// src/legacy/ValwinFactoUploader/ValwinFactoUploaderConst.js
const VALWIN_FACTO_UPLOADER_CONST = {
	IMAGE: {
		maxSize: 5242880,
		error: "5Mo maximum pour les images"
	},
	FILE: {
		maxSize: 10485760,
		error: "10Mo maximum pour les documents"
	}
};
// src/legacy/ValwinFactoUploader/ValwinFactoUploaderCropperUtils.js
const getFileToCropped = (cropperRef, fileToCrop) => {
	const fileName = fileToCrop?.name || "image.jpg";
	const type = fileToCrop?.type || "image/jpg";
	const imageElement = cropperRef && cropperRef.current;
	const dataURL = (imageElement && imageElement.cropper).getCroppedCanvas().toDataURL();
	const blobBin = atob(dataURL.split(",")[1]);
	const array = [];
	for (var i = 0; i < blobBin.length; i++) array.push(blobBin.codePointAt(i));
	const blob = new Blob([new Uint8Array(array)], { type });
	return new File([blob], fileName, { type });
};
// src/legacy/ValwinFactoUploader/ValwinFactoUploaderCropper.jsx
const ValwinFactoUploaderCropper = ({ fileToCrop, ratioX, ratioY, setFileToCompress, setModal, setLoading, validateLabel = "Valider" }) => {
	const cropperRef = useRef(null);
	return /* @__PURE__ */ jsxs("div", {
		className: "valwinFactoUploaderCropper",
		children: [/* @__PURE__ */ jsx(Cropper$1, {
			src: URL.createObjectURL(fileToCrop),
			style: {
				width: "500px",
				height: "300px"
			},
			aspectRatio: ratioX / ratioY,
			guides: true,
			ref: cropperRef
		}), /* @__PURE__ */ jsx(ValwinFactoButton$1, {
			type: "button",
			label: validateLabel,
			className: "valwinFactoButton--greenStrong valwinFactoUploaderCropper__button",
			onClick: () => {
				setFileToCompress(getFileToCropped(cropperRef, fileToCrop));
				setLoading(false);
				setModal(null);
			}
		})]
	});
};
ValwinFactoUploaderCropper.propTypes = {
	fileToCrop: object.isRequired,
	ratioX: number,
	ratioY: number,
	setFileToCompress: func.isRequired,
	setModal: func.isRequired,
	setLoading: func.isRequired
};
// src/legacy/ValwinFactoUploader/ValwinFactoUploaderHandlers.js
const postFile = async (method, urlApi, formData) => {
	return await (await fetch(urlApi, {
		method,
		body: formData
	})).json();
};
// src/legacy/ValwinFactoUploader/ValwinFactoUploaderUtils.jsx
const cropFile = (inputRef, setFileToCrop, setLoading, setModal, setFileToCompress, ratioX, ratioY, fileToCrop, cropModalTitle = "Ajustez votre image", validateLabel = "Valider") => {
	setLoading(true);
	setModal({
		title: cropModalTitle,
		close: () => {
			inputRef.current.value = "";
			setLoading(false);
			setFileToCrop(null);
			setModal(null);
		},
		content: /* @__PURE__ */ jsx(ValwinFactoUploaderCropper, {
			fileToCrop,
			ratioX,
			ratioY,
			setFileToCompress,
			setModal,
			setLoading,
			validateLabel
		})
	});
};
const compressFile = async (setLoading, setFileToUpload, fileToCompress) => {
	setLoading(true);
	const options = {
		maxSizeMB: 1,
		useWebWorker: true
	};
	const fileName = fileToCompress?.name || "image.jpg";
	const blob = await imageCompression(fileToCompress, options);
	const fileCompressed = new File([blob], fileName, { type: fileToCompress.type });
	setLoading(false);
	setFileToUpload(fileCompressed);
};
const uploadFile = async (onChangeAsset, setLoading, urlApi, assetPath, fileToUpload, method) => {
	setLoading(true);
	const formData = new FormData();
	formData.append("assetPath", assetPath);
	formData.append("file", fileToUpload, fileToUpload.name);
	const response = await postFile(method, urlApi, formData);
	setLoading(false);
	onChangeAsset(response);
};
// src/legacy/ValwinFactoUploader/ValwinFactoUploader.jsx
const CreateValwinFactoUploader = ({ onChangeAsset, urlApi, assetPath, setModal, label, className, url, isRounded, isCroppable, tooltip, ratioX, ratioY, required, errors, touched, name, disabled, type, fileName, method, onBlur, icon, isDraggable, onClickDelete, handleProps, isDragging, cropModalTitle = "Ajustez votre image", validateLabel = "Valider" }, ref) => {
	const inputRef = useRef(null);
	const [loading, setLoading] = useState(false);
	const [fileToCrop, setFileToCrop] = useState(null);
	const [fileToCompress, setFileToCompress] = useState(null);
	const [fileToUpload, setFileToUpload] = useState(null);
	const [error, setError] = useState(null);
	const validateFileSize = (file, fileType) => {
		if (!file) return { isValid: true };
		const fileSize = file.size;
		const maxSize = fileType === "IMAGE" ? VALWIN_FACTO_UPLOADER_CONST.IMAGE.maxSize : VALWIN_FACTO_UPLOADER_CONST.FILE.maxSize;
		const errorMessage = fileType === "IMAGE" ? VALWIN_FACTO_UPLOADER_CONST.IMAGE.error : VALWIN_FACTO_UPLOADER_CONST.FILE.error;
		if (fileSize > maxSize) return {
			isValid: false,
			error: errorMessage
		};
		return { isValid: true };
	};
	const clearInput = () => {
		if (inputRef.current) inputRef.current.value = "";
	};
	const processFile = (selectedFile) => {
		if (type === "IMAGE") {
			if (isCroppable) {
				setFileToCrop(selectedFile);
				return;
			}
			setFileToCompress(selectedFile);
			return;
		}
		setFileToUpload(selectedFile);
	};
	const onInputChange = (event) => {
		setError(null);
		const selectedFile = event.target.files?.[0];
		if (!selectedFile) {
			clearInput();
			return;
		}
		const validation = validateFileSize(selectedFile, type);
		if (!validation.isValid) {
			setError(validation.error);
			clearInput();
			return;
		}
		processFile(selectedFile);
		clearInput();
	};
	useEffect(() => {
		if (fileToCrop) cropFile(inputRef, setFileToCrop, setLoading, setModal, setFileToCompress, ratioX, ratioY, fileToCrop, cropModalTitle, validateLabel);
	}, [fileToCrop]);
	useEffect(() => {
		if (fileToCompress) compressFile(setLoading, setFileToUpload, fileToCompress);
	}, [fileToCompress]);
	useEffect(() => {
		if (fileToUpload) uploadFile(onChangeAsset, setLoading, urlApi, assetPath, fileToUpload, method);
	}, [fileToUpload]);
	return /* @__PURE__ */ jsxs("div", {
		ref,
		className: `valwinFactoUploader ${className}`,
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: classnames("valwinFactoUploader__label", { "valwinFactoUploader__label--disabled": disabled }),
				children: [
					label,
					icon && /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
						icon,
						className: "valwinFactoUploader__iconTitle valwinFactoIcon--green"
					}),
					required && /* @__PURE__ */ jsx("div", {
						className: classnames("valwinFactoUploader__required", { "valwinFactoUploader__required--disabled": disabled }),
						children: "*"
					}),
					tooltip && /* @__PURE__ */ jsx(ValwinFactoTooltip$1, {
						tooltip,
						className: "valwinFactoUploader__tooltip"
					})
				]
			}),
			fileName && /* @__PURE__ */ jsx("div", {
				className: classnames("valwinFactoUploader__fileName", { "valwinFactoUploader__fileName--disabled": disabled }),
				children: fileName
			}),
			ratioX && ratioY && /* @__PURE__ */ jsx("div", {
				className: classnames("valwinFactoUploader__ratio", { "valwinFactoUploader__ratio--disabled": disabled }),
				children: `${ratioX}px / ${ratioY}px`
			}),
			errors && errors?.[name] && touched && touched?.[name] && /* @__PURE__ */ jsx("div", {
				className: classnames("valwinFactoUploader__errors", { "valwinFactoUploader__errors--disabled": disabled }),
				children: errors?.[name]
			}),
			error && /* @__PURE__ */ jsx("div", {
				className: classnames("valwinFactoUploader__errors", { "valwinFactoUploader__errors--disabled": disabled }),
				children: error
			}),
			/* @__PURE__ */ jsx("input", {
				className: "valwinFactoUploader__input",
				ref: inputRef,
				type: "file",
				onChange: onInputChange,
				onBlur,
				accept: type === "IMAGE" ? "image/png, image/jpg, image/jpeg, image/webp" : "application/pdf"
			}),
			!loading && /* @__PURE__ */ jsxs("div", {
				className: classnames(`valwinFactoUploader__preview`, {
					"valwinFactoUploader__preview--rounded": isRounded,
					"valwinFactoUploader__preview--disabled": disabled
				}),
				style: { backgroundImage: url && type === "IMAGE" ? `url(${url})` : null },
				onClick: () => {
					if (!disabled) inputRef.current.click();
				},
				children: [
					!url && type === "IMAGE" && /* @__PURE__ */ jsx(FaRegFileImage, { className: "valwinFactoUploader__icon valwinFactoUploader__icon--grey" }),
					!url && type === "FILE" && /* @__PURE__ */ jsx(FaRegFileAlt, { className: "valwinFactoUploader__icon valwinFactoUploader__icon--grey" }),
					url && type === "FILE" && disabled && /* @__PURE__ */ jsx(FaRegFileAlt, { className: "valwinFactoUploader__icon valwinFactoUploader__icon--grey" }),
					url && type === "FILE" && !disabled && /* @__PURE__ */ jsx(FaRegFileAlt, { className: "valwinFactoUploader__icon valwinFactoUploader__icon--green" })
				]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoUploader__options",
				children: [isDraggable && /* @__PURE__ */ jsx("div", {
					...handleProps,
					style: { cursor: isDragging ? "grabbing" : "grab" },
					children: /* @__PURE__ */ jsx(VerticalGripIcon, { size: "xl" })
				}), onClickDelete && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
					type: "button",
					icon: "TRASH",
					className: "valwinFactoButtonIcon--red",
					onClick: onClickDelete
				}) })]
			}),
			loading && /* @__PURE__ */ jsx("div", {
				className: "valwinFactoUploader__preview valwinFactoUploader__preview--loading",
				children: /* @__PURE__ */ jsx(ValwinFactoLoading$1, {
					size: 40,
					className: "valwinFactoLoading--green valwinFactoUploader__loading"
				})
			})
		]
	});
};
const ValwinFactoUploader$1 = forwardRef(CreateValwinFactoUploader);
ValwinFactoUploader$1.propTypes = {
	onChangeAsset: func.isRequired,
	assetPath: string.isRequired,
	label: string.isRequired,
	name: string.isRequired,
	onBlur: func.isRequired,
	setModal: func,
	isCroppable: bool,
	ratioX: number,
	ratioY: number,
	url: string,
	isRounded: bool,
	className: string,
	tooltip: object,
	errors: object,
	touched: object,
	disabled: bool,
	fileName: string,
	icon: string,
	isDraggable: bool,
	onClickDelete: func,
	validateLabel: string,
	cropModalTitle: string
};
// src/legacy/ValwinFactoVictory/ValwinFactoVictory.jsx
const ValwinFactoVictory$1 = ({ victory, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames(`valwinFactoVictory ${className}`),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoVictory__header",
				children: [/* @__PURE__ */ jsx(ValwinFactoIcon$1, {
					icon: victory.icon,
					className: "valwinFactoVictory__icon"
				}), /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
					label: victory.title,
					className: "valwinFactoParagraph--lightBold"
				})]
			}),
			victory?.levelLabel && /* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: victory.levelLabel,
				className: "valwinFactoParagraph--minibold valwinFactoParagraph--greenLight"
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				className: "valwinFactoParagraph--minibold valwinFactoVictory__label",
				label: victory.label
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoVictory__levelContainer",
				children: [
					/* @__PURE__ */ jsxs("div", {
						className: classnames("valwinFactoVictory__level", { valwinFactoVictory__isValidated: victory.level > 0 }),
						children: [/* @__PURE__ */ jsx("div", {
							className: "valwinFactoVictory__indication",
							children: victory.ranks["1"]
						}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "STAR",
							className: "valwinFactoVictory__star"
						})]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: classnames("valwinFactoVictory__level", { valwinFactoVictory__isValidated: victory.level > 1 }),
						children: [/* @__PURE__ */ jsx("div", {
							className: "valwinFactoVictory__indication",
							children: victory.ranks["2"]
						}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "STAR",
							className: "valwinFactoVictory__star"
						})]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: classnames("valwinFactoVictory__level", { valwinFactoVictory__isValidated: victory.level > 2 }),
						children: [/* @__PURE__ */ jsx("div", {
							className: "valwinFactoVictory__indication",
							children: victory.ranks["3"]
						}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "STAR",
							className: "valwinFactoVictory__star"
						})]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: classnames("valwinFactoVictory__level", { valwinFactoVictory__isValidated: victory.level > 3 }),
						children: [/* @__PURE__ */ jsx("div", {
							className: "valwinFactoVictory__indication",
							children: victory.ranks["4"]
						}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "STAR",
							className: "valwinFactoVictory__star"
						})]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: classnames("valwinFactoVictory__level", { valwinFactoVictory__isValidated: victory.level > 4 }),
						children: [/* @__PURE__ */ jsx("div", {
							className: "valwinFactoVictory__indication",
							children: victory.ranks["5"]
						}), /* @__PURE__ */ jsx(ValwinFactoIcon$1, {
							icon: "STAR",
							className: "valwinFactoVictory__star"
						})]
					})
				]
			})
		]
	});
};
ValwinFactoVictory$1.propTypes = {
	victory: object.isRequired,
	className: string
};
// src/legacy/ValwinFactoVideo/ValwinFactoVideoUtils.js
const getEmbeddedUrlYoutube = (value) => {
	if (!isString(value)) return "";
	const url = new URL(value);
	const id = new URLSearchParams(url.search).get("v");
	if (isEmpty(id)) return "";
	return `https://www.youtube.com/embed/${id}`;
};
const getEmbeddedUrl = (url) => {
	if (!isString(url)) return "";
	if (url.includes("youtube")) return getEmbeddedUrlYoutube(url);
	return url;
};
// src/legacy/ValwinFactoVideo/ValwinFactoVideo.jsx
const ValwinFactoVideo$1 = ({ video, onClickEdit, onClickDelete, onClickShow, className }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: `valwinFactoVideo ${className}`,
		children: [
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: video?.title || "",
				className: "valwinFactoVideo__title"
			}),
			/* @__PURE__ */ jsx(ValwinFactoParagraph$1, {
				label: video?.category?.title || "",
				className: "valwinFactoVideo__category"
			}),
			/* @__PURE__ */ jsx("iframe", {
				title: video?.link || "",
				className: "valwinFactoVideo__iframe",
				src: getEmbeddedUrl(video?.link || ""),
				frameBorder: "0"
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "valwinFactoVideo__buttons",
				children: [
					onClickEdit && /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						type: "button",
						icon: "EDIT",
						className: "valwinFactoButtonIcon--green",
						onClick: onClickEdit
					}),
					onClickShow && /* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						type: "button",
						icon: "LIST",
						className: "valwinFactoButtonIcon--greenLight",
						onClick: onClickShow
					}),
					/* @__PURE__ */ jsx(ValwinFactoButtonIcon$1, {
						type: "button",
						icon: "TRASH",
						className: "valwinFactoButtonIcon--red",
						onClick: onClickDelete
					})
				]
			})
		]
	});
};
ValwinFactoVideo$1.propTypes = {
	video: object.isRequired,
	onClickDelete: func.isRequired,
	onClickEdit: func,
	onClickShow: func,
	className: string
};
// src/legacy/index.ts
const legacy = (component) => component;
const ValwinFactoActivation = legacy(ValwinFactoActivation$1);
const ValwinFactoAdvancement = legacy(ValwinFactoAdvancement$1);
const ValwinFactoAlgoliaHierarchicalMenu = legacy(ValwinFactoAlgoliaHierarchicalMenu$1);
const ValwinFactoAlgoliaRefinementList = legacy(ValwinFactoAlgoliaRefinementList$1);
const ValwinFactoArea = legacy(ValwinFactoArea$1);
const ValwinFactoAsset = legacy(ValwinFactoAsset$1);
const ValwinFactoAttachment = legacy(ValwinFactoAttachment$1);
const ValwinFactoAttachmentImage = legacy(ValwinFactoAttachmentImage$1);
const ValwinFactoAttachmentPdf = legacy(ValwinFactoAttachmentPdf$1);
const ValwinFactoAttendeeDetails = legacy(ValwinFactoAttendeeDetails$1);
const ValwinFactoButton = legacy(ValwinFactoButton$1);
const ValwinFactoButtonIcon = legacy(ValwinFactoButtonIcon$1);
const ValwinFactoButtonImage = legacy(ValwinFactoButtonImage$1);
const ValwinFactoCaroussel = legacy(ValwinFactoCaroussel$1);
const ValwinFactoChart = legacy(ValwinFactoChart$1);
const ValwinFactoCheckbox = legacy(ValwinFactoCheckbox$1);
const ValwinFactoCheckboxList = legacy(ValwinFactoCheckboxList$1);
const ValwinFactoDate = legacy(ValwinFactoDate$1);
const ValwinFactoDateAlt = legacy(ValwinFactoDateAlt$1);
const ValwinFactoDownload = legacy(ValwinFactoDownload$1);
const ValwinFactoDropdownItem = legacy(ValwinFactoDropdownItem$1);
const ValwinFactoDropdownMenu = legacy(ValwinFactoDropdownMenu$1);
const ValwinFactoDuration = legacy(ValwinFactoDuration$1);
const ValwinFactoExtranetAffiliations = legacy(ValwinFactoExtranetAffiliations$1);
const ValwinFactoExtranetAffiliationsField = legacy(ValwinFactoExtranetAffiliationsField$1);
const ValwinFactoExtranetAffiliationsLabel = legacy(ValwinFactoExtranetAffiliationsLabel$1);
const ValwinFactoExtranetBanner = legacy(ValwinFactoExtranetBanner$1);
const ValwinFactoExtranetBulkAffiliation = legacy(ValwinFactoExtranetBulkAffiliation$1);
const ValwinFactoExtranetBulkDelete = legacy(ValwinFactoExtranetBulkDelete$1);
const ValwinFactoExtranetButtonDocument = legacy(ValwinFactoExtranetButtonDocument$1);
const ValwinFactoExtranetDirectoryChoice = legacy(ValwinFactoExtranetDirectoryChoice$1);
const ValwinFactoExtranetMediasBreadcrumbs = legacy(ValwinFactoExtranetMediasBreadcrumbs$1);
const ValwinFactoExtranetMediasFolder = legacy(ValwinFactoExtranetMediasFolder$1);
const ValwinFactoExtranetMediasSubFolder = legacy(ValwinFactoExtranetMediasSubFolder$1);
const ValwinFactoExtranetTag = legacy(ValwinFactoExtranetTag$1);
const ValwinFactoField = legacy(ValwinFactoField$1);
const ValwinFactoFieldAlt = legacy(ValwinFactoFieldAlt$1);
const ValwinFactoFieldIframe = legacy(ValwinFactoFieldIframe$1);
const ValwinFactoFormElement = legacy(ValwinFactoFormElement$1);
const ValwinFactoForum = legacy(ValwinFactoForum$1);
const ValwinFactoIcon = legacy(ValwinFactoIcon$1);
const ValwinFactoImageSelect = legacy(ValwinFactoImageSelect$1);
const ValwinFactoJob = legacy(ValwinFactoJob$1);
const ValwinFactoJobToPrint = legacy(ValwinFactoJobToPrint$1);
const ValwinFactoLoading = legacy(ValwinFactoLoading$1);
const ValwinFactoMenuSelectButton = legacy(ValwinFactoMenuSelectButton$1);
const ValwinFactoModal = legacy(ValwinFactoModal$1);
const ValwinFactoNew = legacy(ValwinFactoNew$1);
const ValwinFactoNotices = legacy(ValwinFactoNotices$1);
const ValwinFactoOptionColor = legacy(ValwinFactoOptionColor$1);
const ValwinFactoOptionLining = legacy(ValwinFactoOptionLining$1);
const ValwinFactoOptionMeetingPatient = legacy(ValwinFactoOptionMeetingPatient$1);
const ValwinFactoOptionPharmacyColors = legacy(ValwinFactoOptionPharmacyColors$1);
const ValwinFactoOptionService = legacy(ValwinFactoOptionService$1);
const ValwinFactoOptionSpeciality = legacy(ValwinFactoOptionSpeciality$1);
const ValwinFactoOptionTag = legacy(ValwinFactoOptionTag$1);
const ValwinFactoOptionVideo = legacy(ValwinFactoOptionVideo$1);
const ValwinFactoPaginator = legacy(ValwinFactoPaginator$1);
const ValwinFactoPanelAlt = legacy(ValwinFactoPanelAlt$1);
const ValwinFactoParagraph = legacy(ValwinFactoParagraph$1);
const ValwinFactoPatientForm = legacy(ValwinFactoPatientForm$1);
const ValwinFactoPatientMeeting = legacy(ValwinFactoPatientMeeting$1);
const ValwinFactoPatientOrder = legacy(ValwinFactoPatientOrder$1);
const ValwinFactoPatientThreadToPrint = legacy(ValwinFactoPatientThreadToPrint$1);
const ValwinFactoPharmaciesSelect = legacy(ValwinFactoPharmaciesSelect$1);
const ValwinFactoPosterForm = legacy(ValwinFactoPosterForm$1);
const ValwinFactoProduct = legacy(ValwinFactoProduct$1);
const ValwinFactoPromotionDetail = legacy(ValwinFactoPromotionDetail$1);
const ValwinFactoRecurringWeekDays = legacy(ValwinFactoRecurringWeekDays$1);
const ValwinFactoRichText = legacy(ValwinFactoRichText$1);
const ValwinFactoSearch = legacy(ValwinFactoSearch$1);
const ValwinFactoSelect = legacy(ValwinFactoSelect$1);
const ValwinFactoSelectAlt = legacy(ValwinFactoSelectAlt$1);
const ValwinFactoSubTitle = legacy(ValwinFactoSubTitle$1);
const ValwinFactoSubTitleAlt = legacy(ValwinFactoSubTitleAlt$1);
const ValwinFactoTable = legacy(ValwinFactoTable$1);
const ValwinFactoTasks = legacy(ValwinFactoTasks$1);
const ValwinFactoTbody = legacy(ValwinFactoTbody$1);
const ValwinFactoTd = legacy(ValwinFactoTd$1);
const ValwinFactoTh = legacy(ValwinFactoTh$1);
const ValwinFactoThreadMenu = legacy(ValwinFactoThreadMenu$1);
const ValwinFactoThreadMenuElement = legacy(ValwinFactoThreadMenuElement$1);
const ValwinFactoTime = legacy(ValwinFactoTime$1);
const ValwinFactoTimelineColissimo = legacy(ValwinFactoTimelineColissimo$1);
const ValwinFactoTip = legacy(ValwinFactoTip$1);
const ValwinFactoTooltip = legacy(ValwinFactoTooltip$1);
const ValwinFactoTr = legacy(ValwinFactoTr$1);
const ValwinFactoUploader = legacy(ValwinFactoUploader$1);
const ValwinFactoVictory = legacy(ValwinFactoVictory$1);
const ValwinFactoVideo = legacy(ValwinFactoVideo$1);
export { PROMOTION_CODE_N_PERCENT_FOR_Y_BASKET_VALUE_LABELS, PROMOTION_CODE_N_PERCENT_ON_FIRST_ORDER_VALUE_LABELS, PROMOTION_CODE_N_VALUE_FOR_Y_BASKET_VALUE_LABELS, PROMOTION_CODE_N_VALUE_ON_FIRST_ORDER_VALUE_LABELS, PromotionTypes, ValwinFactoActivation, ValwinFactoAdvancement, ValwinFactoAlgoliaHierarchicalMenu, ValwinFactoAlgoliaRefinementList, ValwinFactoArea, ValwinFactoAsset, ValwinFactoAttachment, ValwinFactoAttachmentImage, ValwinFactoAttachmentPdf, ValwinFactoAttendeeDetails, ValwinFactoButton, ValwinFactoButtonIcon, ValwinFactoButtonImage, ValwinFactoCaroussel, ValwinFactoChart, ValwinFactoCheckbox, ValwinFactoCheckboxList, ValwinFactoDate, ValwinFactoDateAlt, ValwinFactoDownload, ValwinFactoDropdownItem, ValwinFactoDropdownMenu, ValwinFactoDuration, ValwinFactoExtranetAffiliations, ValwinFactoExtranetAffiliationsField, ValwinFactoExtranetAffiliationsLabel, ValwinFactoExtranetBanner, ValwinFactoExtranetBulkAffiliation, ValwinFactoExtranetBulkDelete, ValwinFactoExtranetButtonDocument, ValwinFactoExtranetDirectoryChoice, ValwinFactoExtranetMediasBreadcrumbs, ValwinFactoExtranetMediasFolder, ValwinFactoExtranetMediasSubFolder, ValwinFactoExtranetTag, ValwinFactoField, ValwinFactoFieldAlt, ValwinFactoFieldIframe, ValwinFactoFormElement, ValwinFactoForum, ValwinFactoIcon, ValwinFactoImageSelect, ValwinFactoJob, ValwinFactoJobToPrint, ValwinFactoLoading, ValwinFactoMenuSelectButton, ValwinFactoModal, ValwinFactoNew, ValwinFactoNotices, ValwinFactoOptionColor, ValwinFactoOptionLining, ValwinFactoOptionMeetingPatient, ValwinFactoOptionPharmacyColors, ValwinFactoOptionService, ValwinFactoOptionSpeciality, ValwinFactoOptionTag, ValwinFactoOptionVideo, ValwinFactoPaginator, ValwinFactoPanelAlt, ValwinFactoParagraph, ValwinFactoPatientForm, ValwinFactoPatientMeeting, ValwinFactoPatientOrder, ValwinFactoPatientThreadToPrint, ValwinFactoPharmaciesSelect, ValwinFactoPosterForm, ValwinFactoProduct, ValwinFactoPromotionDetail, ValwinFactoRecurringWeekDays, ValwinFactoRichText, ValwinFactoSearch, ValwinFactoSelect, ValwinFactoSelectAlt, ValwinFactoSubTitle, ValwinFactoSubTitleAlt, ValwinFactoTable, ValwinFactoTasks, ValwinFactoTbody, ValwinFactoTd, ValwinFactoTh, ValwinFactoThreadMenu, ValwinFactoThreadMenuElement, ValwinFactoTime, ValwinFactoTimelineColissimo, ValwinFactoTip, ValwinFactoTooltip, ValwinFactoTr, ValwinFactoUploader, ValwinFactoVictory, ValwinFactoVideo };

//# sourceMappingURL=index.js.map